'use strict';
import { module } from '../app';
import moment from 'moment';
import * as _ from 'lodash';

import { RightHistoryRecordDetailDialogModel } from './rightHistoryRecordDetail';
import { ImplantsRecordDetailDialogModel } from './implantsRecordDetails';
import { AccessionBarcodeDialogModel } from "./accessionBarcode";
import { DateRecordEditDialogModel } from './dateRecordEdit';
import { RefreshWorklistDetailsDialogModel } from './refreshWorklistDetails';
import { CemTechniqueDialogModel } from './cemTechniqueDialogModel';
import { constantStrings } from "../constants/constantStrings";
import * as commonConstants from '../constants/constantStrings';
import * as propertyTypeConstants from '../constants/property-type-constants';
import * as riskPropertyConstants from '../constants/risk-property-constants';
import * as patientConstants from '../constants/patient-constants';
import * as examConstants from '../constants/exam-constants';
import { CannedNotesModel } from './cannedNotesModel';
import { PatientImportDocumentDialogModel } from './patientImportDocumentDialogModel';
import { CropDialogModel } from './cropDialogModel';
import { ImportPatientDocumentModel } from './importPatientDocumentModel';
import { SIDE_UNKNOWN_KEY, SIDE_BILATERAL_KEY, SIDE_LEFT_KEY, SIDE_RIGHT_KEY } from '../constants/constantStrings';
import { FollowUpHelpers } from '../helpers/followUpHelpers';
import { StudyDisplayHelpers } from '../helpers/studyDisplayHelpers';


const IMPLANTS_TYPE = 'IMPLANTS';

module
  .factory('patientViewModel', [
    'Worklist', 'Diagram', 'Patient', 'authService', '$timeout', '$location', 'modalService',
    'eventsMgr', '$ionicLoading', 'serverTimeService', 'techpadConfig', 'Study', 'documentsSvc', '$rootScope',
    'dataRetrieverService', 'signalrService', 'enums',
    'FollowUpsDomain', 'FollowUpDetailDialogModel', 'SelectProblemsDialogModel',
    '$window', 'SelectUltrasoundTechniqueModel', 'patientDetailsViewModel',
    'DocumentCreateDialogModel',
    'techpadInitialConfigProvider',
    '$ionicScrollDelegate',
    'linkStudiesViewModel',
    'SurveyService',
    'PatientReferringPhysiciansDialogModel',
    'techpadOptions', 'environmentHelper', 'datePickerService', 'ageHelper', 'ContactDocumentCreateDialogModel',
    'FollowUpResolveDialogModel', 'MultiRadioDetailsDialogModel', '$ionicListDelegate', 'dateHelper', 'dateFormattingHelper',
    'followUpOperations', 'filmsComparedService', 'repeatFilmService', 'documentPrintHelper',
    function (Worklist, Diagram, Patient, authService, $timeout, $location, modalService,
      eventsMgr, $ionicLoading, serverTimeService, techpadConfig, Study, documentsSvc, $rootScope,
      dataRetrieverService, signalrService, enums,
      FollowUpsDomain, FollowUpDetailDialogModel, SelectProblemsDialogModel,
      $window, SelectUltrasoundTechniqueModel, patientDetailsViewModel,
      DocumentCreateDialogModel,
      techpadInitialConfigProvider,
      $ionicScrollDelegate,
      linkStudiesViewModel,
      SurveyService,
      PatientReferringPhysiciansDialogModel,
      techpadOptions, environmentHelper, datePickerService, ageHelper,
      ContactDocumentCreateDialogModel, FollowUpResolveDialogModel,
      MultiRadioDetailsDialogModel,
      $ionicListDelegate, dateHelper, dateFormattingHelper,
      followUpOperations, filmsComparedService, repeatFilmService, documentPrintHelper) {

      let vm = function (id, isViewOnly, returnUrl, isMyPatientMode) {

        const SAVE_DIAGRAM_ERROR_MESSAGE = 'Error while saving the diagram';

        let self = this;

        self.returnUrl = returnUrl || patientConstants.DEFAULT_RETURN_URL;
        self.propertyTypeConstants = propertyTypeConstants;
        self.riskPropertyConstants = riskPropertyConstants;
        self.commonConstants = commonConstants;
        self.examConstants = examConstants;

        self.itemArray = [
          { id: 1, name: 'first' },
          { id: 2, name: 'second' },
          { id: 3, name: 'third' },
          { id: 4, name: 'fourth' },
          { id: 5, name: 'fifth' },
        ];
        self.procTypes = enums.procTypes;

        self.selected = { value: self.itemArray[0] };
        self.findingCaptionsDict = {};
        self.isDisplayFindingRecord = {};

        techpadOptions.getOptions();
        self.darkMode = techpadOptions.options.DarkMode;

        self.isIOSDevice = environmentHelper.isIOSDevice();

        self.worklistId = id;
        self.diagramImage = null;
        self.DiagramDescription = null;
        self.diagramFullscreen = false;
        self.findingEditing = false;
        self.hideProcedures = false;
        self.historyLoadRetries = $rootScope.techpadSettings.HistoryLoadRetries;
        self.isViewOnly = isViewOnly === true.toString();
        self.isMyPatientMode = isMyPatientMode;
        self.isOnline = () => $rootScope.isOnline();
        self.isInitialViewOnly = isViewOnly === true.toString();
        self.techpadConfig = techpadConfig;
        self.visitReasons = [];
        self.ultrasoundTechniques = [];
        self.studyUTechniques = [];
        self.tecknologists = [];
        self.svg = null;
        self.views = [];
        self.procedures = [];
        self.problems = [];
        self.problemsList = [];
        self.problemsListCopy = [];
        self.notValidLeftHistory = [];
        self.notValidExamUfields = [];
        self.selectedFilmsCompared = undefined;
        self.selectedFilmsComparedData = [];
        self.selectedFilmsComparedDataCopy = [];
        self.notValidRiskProperties = [];
        self.initialComments = {};
        self.isFollowUpTabVisited = false;
        self.highlightingDocumentIds = [];
        self.wasViewsChanged = false;
        self.isPatientAgreementChanged = false;
        self.scanResults = [];
        self.recommendations = [];
        self.myriadSkippedFlag = false;
        self.isAnsweredInModal = false;

        self.familyTreeEnabledCodeObject = {};
        if (self.techpadConfig.settings.FamilyTree) {
          let codeList = self.techpadConfig.settings.FamilyTreeEnabledCodeList.split(",");
          codeList.forEach(code => {
            self.familyTreeEnabledCodeObject[code.trim()] = true;
          });
        }

        self.documentSourceTypes = {
          Contacts: 'Contacts',
          PortalDocument: 'PortalDocument',
          EnotifyAndRelease: 'EnotifyAndRelease'
        };


        self.riskTabColumns = [];
        self.processRiskTabSettings = function () {
          if ($rootScope.techpadSettings.NccnPat) {
            const risks = $rootScope.techpadSettings.StoreRisks && $rootScope.techpadSettings.StoreRisks.filter(risk => risk !== 'NCCN') || [];
            self.riskTabColumns = [risks, [riskPropertyConstants.nccnRiskModule]];
          } else {
            const risks = $rootScope.techpadSettings.StoreRisks && $rootScope.techpadSettings.StoreRisks.filter(risk => risk !== 'NCCN') || [];
            const MIN_COLUMN_ELEMENTS = 4;
            let firstColumnMaxElements = MIN_COLUMN_ELEMENTS;
            if (risks.length >= 2 * MIN_COLUMN_ELEMENTS) {
              firstColumnMaxElements = ~~(risks / 2);
            }
            const firstColumn = risks.slice(0, firstColumnMaxElements);
            const secondColumn = risks.slice(firstColumnMaxElements, $rootScope.techpadSettings.length);
            self.riskTabColumns = [firstColumn, secondColumn];
          }
        }
        self.processRiskTabSettings();

        self.handleResumeEvent = function () {
          $ionicLoading.show({
            template: commonConstants.DEFAULT_LOADER_MESSAGE
          });
          try {
            signalrService.connect();            
          } catch (e) {
            console.error(e);
          } finally {
            $ionicLoading.hide();
          }
        };

        self.startWatchingJSExecution = function () {
          let lastFired = new Date().getTime();
          self.watchJSExecutionInterval = setInterval(async () => {
            const now = new Date().getTime();
            if (now - lastFired > 1500) {
              self.handleResumeEvent();
            }
            lastFired = now;
          }, 500);
        }

        self.startWatchingJSExecution();

        self.handleResumeEvent();

        self.diagramEditor = null;

        self.isTyrerCuzickFullScreen = false;
        self.currenntMagViewUrl = authService.currentMagViewUrl();

        self.onDiagramEditorReady = function (diagramEditor) {
          self.diagramEditor = diagramEditor;
        };

        self.onProblemsChanged = function (problems) {
          self.problemsList = problems;
        };

        self.isSurveyStarted = false;
        self.viewsTypes = [...enums.viewsTypes];

        if (!techpadConfig.settings.TomoViews) {
          self.viewsTypes = self.viewsTypes.filter(type => type.Key !== 'T');
        }
        if (techpadConfig.settings.HideMag) {
          self.viewsTypes = self.viewsTypes.filter(type => type.Key !== 'M');
        }

        self.sides = [{
          Key: SIDE_LEFT_KEY,
          Value: 'Left'
        }, {
          Key: SIDE_RIGHT_KEY,
          Value: 'Right'
        }, {
          Key: SIDE_BILATERAL_KEY,
          Value: 'Both'
        }, {
          Key: SIDE_UNKNOWN_KEY,
          Value: 'No side'
        }];

        self.sidesWithoutUnknown = self.sides.filter(x => x.Key !== SIDE_UNKNOWN_KEY);
        self.sidesWithoutBilateral = self.sides.filter(x => x.Key !== SIDE_BILATERAL_KEY);
        self.sidesOnlyUnknown = self.sides.filter(x => x.Key === SIDE_UNKNOWN_KEY);

        self.trueFalseValues = [{
          Key: true,
          Value: 'Yes'
        }, {
          Key: false,
          Value: 'No'
        }];

        self.optInValues = [
          { Key: true, Value: 'Yes' },
          { Key: false, Value: 'No' },
          { Key: null, Value: '' },
        ];

        self.unambiguousRelativeCodeList = [
          'M', 'F', 'MG', 'PG', 'MF', 'PF'
        ];

        self.diagramEditor = null;

        self.setDiagramEditor = (diagramEditor) => {
          self.diagramEditor = diagramEditor;
        };

        self.personalBRCA1Value = null;
        self.personalBRCA2Value = null;

        self.notValidPersonalBRCAHistory = false;


        self.tabs = {
          Exam: 1,
          Detail: 2,
          Demographic: 3,
          History: 5,
          Images: 6,
          Diagram: 7,
          DiagramNew: 8,
          Comments: 9,
          Documents: 10,
          FollowUps: 11,
          SurveyHistory: 12,
          RiskAssessments: 13,
          TyrerCuzick: 14
        };


        self.surveyIdentity = {};
        self.viewMode = true;
        self.canLoadSurveyTheme = false;
        self.canLoadTyrerCuzickContent = false;
        self.viewsSidesDictionary = {};
        self.procedureSideDictionary = {};

        self.worklistStatuses = enums.worklistStatuses;

        self.statusesToEnableControls = [
          self.worklistStatuses.ExamInProgress,
          self.worklistStatuses.ExamPaused,
          self.worklistStatuses.ExamStopped,
          self.worklistStatuses.ExamIncomplete,
          self.worklistStatuses.Finished
        ];

        self.diagramPaperSettings = {
          small: {
            width: 800
          },
          large: {
            width: 1024
          }
        };

        $ionicLoading.show({
          template: 'Loading...'
        });

        self.noDocumentsMessage = 'There are no documents for this patient';

        self.failLoading = function (resp) {
          $ionicLoading.hide();
          if (resp.status === 409) {
            modalService.showAlert(resp.data, self.refreshPage);
          }
          modalService.showErrorMessage(resp.data, resp.status).then(function () {
            self.goToReturnUrl();
          });
        };

        self.refreshPage = function () {
          $window.location.reload();
        };

        self.ProceduresCodesToShowViewObtained = ['M', 'D'];

        self.canShowViewsObtained = function () {

          if (!self.patient || !self.patient.Study ||
            !self.patient.Study.Procedures || !self.patient.Study.Procedures.length ||
            !self.procedures || !self.procedures.length)
            return false;

          let canShowViews = false;
          self.patient.Study.Procedures.forEach((procedure) => {
            let procedureDefinition = self.procedures.find(p => p.Key === procedure.Code);
            let procedureType = procedureDefinition ? procedureDefinition.Type : null;
            if (procedureType && self.ProceduresCodesToShowViewObtained.includes(procedureType)) canShowViews = true;
          });

          return canShowViews;
        }

        self.isAnyUltrasoundProcedure = function () {
          let isUltrasound = false;
          self.patient.Study.Procedures.forEach((procedure) => {
            let procedureDefinition = self.procedures.find(p => p.Key === procedure.Code);
            let procedureType = procedureDefinition ? procedureDefinition.Type : null;
            if (procedureType === 'U') isUltrasound = true;
          });

          return isUltrasound;
        }

        self.canShowUltrasoundOptions = function () {
          let canShowUltrasoundOptions = self.patient && self.patient.Study && self.patient.Study.Procedures
            && self.patient.Study.Procedures.length && self.procedures
            && self.procedures.length && self.isAnyUltrasoundProcedure();

          return canShowUltrasoundOptions;
        };

        self.onTechpadSettingChanged = function (newSettings) {
        };

        let techpadConfigChangeRegistration = techpadConfig.registerOnSettingChange(self.onTechpadSettingChanged);

        self.reloadDiagram = function () {
          if (!self.worklistId) {
            let promise = Diagram.get(self.ssn, self.sdate);

            return promise
              .then((resp) => {
                self.fillDiagramProblems(resp.data.Problems);
              })
              .finally(() => {
                self.problemLoaded = true;
              });
          }
        };

        self.onGivingUpReconnecting = function () {
          modalService.showAlert('Reconnecting Failed. Before you continue to work, please fix your WiFi network issue. Offline mode is now enabled.',
            undefined,
            'offline-mode-message');
        };

        self.fillDiagramProblems = function (problems) {
          $rootScope.safeApply(() => {
            self.problemsList = [];
            if (problems && problems.length > 0) {
              problems.forEach((item) => {
                if (typeof item.Settings === 'string' || item.Settings instanceof String) {
                  item.Settings = JSON.parse(item.Settings);
                }
                if (item.CustomType !== undefined && item.CustomType !== null) {
                  item.Type = item.CustomType;
                }
              });

              problems = self.filterDiagramProblemsIfNeeded(problems);

              self.problemsList = self.problemsList.concat(problems);

              self.problemsListCopy = _.cloneDeep(self.problemsList);
            }
          });
        };

        self.showCEMTechniqueModal = async function () {
          const report = !self.newCEMTechniqueData.CEMTechniqueCEMTechData.Technique ? self.newCEMTechniqueData.Techniques[0].Report : self.newCEMTechniqueData.Techniques.find(tech => tech.Code === self.newCEMTechniqueData.CEMTechniqueCEMTechData.Technique).Report || '';

          let model = new CemTechniqueDialogModel({
            U1: self.newCEMTechniqueData.CEMTechniqueCEMTechData.U1,
            U2: self.newCEMTechniqueData.CEMTechniqueCEMTechData.U2,
            U3: self.newCEMTechniqueData.CEMTechniqueCEMTechData.U3,
            U4: self.newCEMTechniqueData.CEMTechniqueCEMTechData.U4,
            Techniques: self.newCEMTechniqueData.Techniques,
            ContrastAgents: self.newCEMTechniqueData.ContrastAgents,
            Veins: self.newCEMTechniqueData.Veins,
            CatheterGauges: self.newCEMTechniqueData.CatheterGauges,
            ComplicationsAndReactions: self.newCEMTechniqueData.ComplicationsAndReactions,
            ReactionTypes: self.newCEMTechniqueData.ReactionTypes,
            NoComplications: self.newCEMTechniqueData.NoComplications,
            UdfFieldsConfigs: self.newCEMTechniqueData.UdfFieldsConfigs,
            CEMTechniqueCEMTechData: {
              ...self.newCEMTechniqueData.CEMTechniqueCEMTechData,
              Report: report,
              Technique: !self.newCEMTechniqueData.CEMTechniqueCEMTechData.Technique ? self.newCEMTechniqueData.Techniques[0] : self.newCEMTechniqueData.Techniques.find(tech => tech.Code === self.newCEMTechniqueData.CEMTechniqueCEMTechData.Technique),
            },
            FieldLabelsConfigs: self.newCEMTechniqueData.FieldLabelsConfigs,
          });
          const closeByButtonsClickOnly = true;

          await modalService.showDialogWindow(
            "views/templates/modals/cem-technique-modal.html",
            model,
            closeByButtonsClickOnly
          );

          if(model.cancelled){
            return;
          }

          if (model.updatedCEMTechniqueCEMTechData) {
            self.newCEMTechniqueData = {
              ...self.newCEMTechniqueData,
              CEMTechniqueCEMTechData: {
                ...model.updatedCEMTechniqueCEMTechData,
                Technique: model.updatedCEMTechniqueCEMTechData.Technique.Code,
              },
            };
            self.selectedCemTech = self.newCEMTechniqueData.Techniques.find(
              (tech) =>
                tech.Code ===
                model.updatedCEMTechniqueCEMTechData.Technique.Code
            ).Desc;
          } else {
            self.newCEMTechniqueData = {
              ...self.newCEMTechniqueData,
              CEMTechniqueCEMTechData: {
                Technique: undefined,
                ContrastAgent: undefined,
                Dosage: undefined,
                Volume: undefined,
                Vein: undefined,
                CatheterGauge: undefined,
                ComplicationsAndReaction: undefined,
                ReactionType: undefined,
                Note: undefined,
              },
            };
            self.selectedCemTech = undefined;
          }
        };

        self.showFilmsComparedModal = async function () {
          if (!self.patient || !self.patient.Ssn || !self.patient.Study || !self.patient.Study.SDate) {
            modalService.showAlert('Cannot open Films Compared modal. Patient data is not available.');
            return;
          }
          
          const studyDate = self.study && self.study.StudyDate ? self.study.StudyDate : null;
          const result = await filmsComparedService.showFilmsComparedModal(
            self.priorFilms,
            self.locations,
            self.patient.Ssn,
            self.patient.Study.SDate,
            studyDate,
            self.selectedFilmsComparedData // Pass saved data to restore state
          );

          if (result) {
            self.selectedFilmsCompared = result.displayText;
            self.selectedFilmsComparedData = result.data;
          }
        };

        self.selectedRepeatFilmsSummary = "";

        self.shouldShowRepeatFilm = function () {
          return !!(self.techpadConfig.settings
            && self.techpadConfig.settings.ShowRepeat
            && self.techpadConfig.settings.ShwRepFilm);
        };

        self.loadRepeatFilmsSummary = async function () {
          if (!self.patient || !self.patient.Ssn || !self.patient.Study || !self.patient.Study.SDate) {
            self.selectedRepeatFilmsSummary = "";
            return;
          }

          try {
            self.selectedRepeatFilmsSummary = await repeatFilmService.buildSummary(
              self.patient.Ssn,
              self.patient.Study.SDate
            );
          } catch (error) {
            modalService.showErrorMessage(error.data || 'Error loading Repeat Films.', error.status);
          }
        };

        self.showRepeatFilmModal = async function () {
          if (!self.patient || !self.patient.Ssn || !self.patient.Study || !self.patient.Study.SDate) {
            modalService.showAlert('Cannot open Repeat Films. Patient data is not available.');
            return;
          }

          const result = await repeatFilmService.showRepeatFilmModal(
            self.patient.Ssn,
            self.patient.Study.SDate
          );

          if (result && result.saved) {
            self.selectedRepeatFilmsSummary = result.summary;
          }
        };

        self.filterDiagramProblemsIfNeeded = function (problems) {

          const settings = self.techpadConfig.settings.NewDiagramFeatureEnabled ? self.diagramPaperSettings.large : self.diagramPaperSettings.small;
          const diagramSettings = self.techpadConfig.settings.DiagramSettings || [];

          //filter out problems whose custom type no longer exists in problemSettings
          problems = problems.filter(problem => {
            const problemType = problem.Type;
            const problemSetting = diagramSettings.find(setting => setting.Type === problemType);
            
            if (!problemSetting) {
              return false;
            }
            return true;
          });

          //filter out duplicated side bad data for reduction scar and mastectomy
          let leftReductionScarExists = false;
          let rightReductionScarExists = false;
          let leftMastectomyExists = false;
          let rightMastectomyExists = false;
          problems = problems.filter(problem => {
            if (problem.Type === 'ReductionScar' && problem.Settings.x < (settings.width / 2)) {
              if (!leftReductionScarExists) {
                leftReductionScarExists = true;
                return true;
              } else {
                return false;
              }
            }
            if (problem.Type === 'ReductionScar' && problem.Settings.x > (settings.width / 2)) {
              if (!rightReductionScarExists) {
                rightReductionScarExists = true;
                return true;
              } else {
                return false;
              }
            }
            if (problem.Type === 'Mastectomy' && problem.Settings.x < (settings.width / 2)) {
              if (!leftMastectomyExists) {
                leftMastectomyExists = true;
                return true;
              } else {
                return false;
              }
            }
            if (problem.Type === 'Mastectomy' && problem.Settings.x > (settings.width / 2)) {
              if (!rightMastectomyExists) {
                rightMastectomyExists = true;
                return true;
              } else {
                return false;
              }
            }
            return true;
          });

          return problems;
        }

        self.updateOnlineStatus = function (data) {
          self.checkViewOnly();
          if (!self.isInitialViewOnly) {
            showAlert(data);
          }

          function showAlert(data) {
            if (data.isOnline) {
              modalService.showAlert('Connection established. You are in online mode.', undefined, 'offline-mode-message');
            } else {
              if (data.internetAvailable) {
                modalService.showAlert('Connection to Portal is not available. Going to offline mode.', undefined, 'offline-mode-message');
              } else {
                modalService.showAlert('Internet connection is not available. Going to offline mode.', undefined, 'offline-mode-message');
              }
            }
          }
        };

        self.showMessage = (message) => {
          return modalService.showAlertAsync(message);
        };

        self.onDiagramError = (message) => {
          if (!message)
            return;

          console.log('on diagram error', message);
          modalService.showAlert(message, undefined);
        };

        self.showConfirmationMessage = (message) => {
          return modalService.showConfirmationAsync(message);
        };

        self.refresh = async function (isSkipConfirmation, isNotHideLoader = false) {
          if (self.tab === self.tabs.SurveyHistory && self.isSurveyStarted) {
            let confirmed = await modalService.showConfirmation(null, 'You didn\'t complete the survey. Are you sure you want to refresh?');
            if (!confirmed) {
              return;
            } else {
              self.isSurveyStarted = false;
            }
          }

          if (self.isChanged() && !isSkipConfirmation) {
            let confirmed = await modalService.showConfirmation(null, 'You have unsaved changes. Are you sure you want to refresh?');
            if (!confirmed) {
              return;
            }
          }
          self.hideDiagram = true;

          $ionicLoading.show({
            template: 'Loading...'
          });

          if(self.techpadConfig.settings.IsShowPriorStudiesTabInExamMode){
            self.tabs = {
              PriorStudies: 4,
              ...self.tabs
            };
          }

          if (self.worklistId) {
            try {
              const resp = await dataRetrieverService.cachedProxy('worklist-patient-info-' + self.worklistId, 0, () => Worklist.getPatientInfo(self.worklistId));
              if (self.patient && self.patient.Sex !== resp.data.Sex) {
                self.patientSexChanged = true;
              } else {
                self.patientSexChanged = false;
              }
              self.patient = resp.data;
              self.setupCEMTechniqueConfigs(resp.data.CEMTechniqueData, resp.data.Study);

              self.patientCopy = angular.copy(resp.data);
              self.updateMyriadStatusProperties();

              if(self.techpadConfig.settings.ShowStudyComparison){
                self.loadShouldShowFilmsCompared();

                if (resp.data.FilmsCompared) {
                  self.selectedFilmsComparedData = self.convertApiFilmsComparedToInternal(resp.data.FilmsCompared);
                  self.selectedFilmsCompared = self.getFilmsComparedDisplayText(self.selectedFilmsComparedData);
                  self.selectedFilmsComparedDataCopy = angular.copy(self.selectedFilmsComparedData);
                }
              }

              if (self.shouldShowRepeatFilm()) {
                self.loadRepeatFilmsSummary();
              }

              if (!self.initialStatus) {
                self.initialStatus = resp.data.Status;
              }

              self.setDefaultViews();
              self.fillViewsSidesDictionary();

              self.moveCorrectTimeStamps();

              if (self.canShowUltrasoundOptions()) {
                self.fillStudyUTechniques();
              }

              self.fillDiagramProblems(self.patient.Problems);
              $timeout(() => {
                self.hideDiagram = false;

                let isOldMode;
                if (self.diagramEditor != null) {
                  isOldMode = self.diagramEditor.oldMode === true || typeof (self.diagramEditor.oldMode) === 'undefined';
                } else {
                  isOldMode = !self.techpadConfig.settings.NewDiagramFeatureEnabled;
                }

                if (!isOldMode) {
                  self.diagramEditor.redrawElements();
                } else {
                  self.fillDiagramProblems(self.patient.Problems);
                  self.problemsList = angular.copy(self.problemsListCopy);
                }
              }, 0);
              self.initialComments = {};

              self.techpadConfig.settings.CommentsSettings.forEach((setting) => {
                self.initialComments[setting.Field] = self.patient.Study.Comments[setting.Field];
              });

              // follow up is needed for finishing exam logic, so we need to load it first.
              self.loadFollowUps();

              // only wait for history data to be loaded
              await self.loadHistoryPages(isNotHideLoader);

              if(self.techpadConfig.settings.IsShowPriorStudiesTabInExamMode){
                await self.loadStudies();
                await self.setStudies();
              }

              self.refreshData(isNotHideLoader);

              if (resp.data.ImagePath) {
                self.diagramImage = authService.currentMagViewUrl() + resp.data.ImagePath;
              }
              const response = await self.loadUltraSoundScanResults(resp.data.Study.SSN, resp.data.Study.SDate)
              self.scanResults = response.data.Records || [];

            } catch (error) {
              self.failLoading(error);
            } finally {
              if(!isNotHideLoader) {
                $ionicLoading.hide();
              }
            }
          } else {
            if(!isNotHideLoader) {
              $ionicLoading.hide();
            }
          }
        };

        self.setupCEMTechniqueConfigs = function (cemTechniqueData, study) {
          if(!cemTechniqueData || !study) {
            return;
          }

          self.selectedCemTech = !cemTechniqueData.CEMTechniqueCEMTechData.Technique ? undefined : cemTechniqueData.Techniques.find(tech => tech.Code === cemTechniqueData.CEMTechniqueCEMTechData.Technique).Desc || "";
          self.initialCEMTechniqueData = angular.copy(cemTechniqueData);
          self.newCEMTechniqueData = angular.copy(self.initialCEMTechniqueData);
          self.shouldShowCEMTechnique = study.Procedures.some(p => p.Cem) && cemTechniqueData.CemTechStu && $rootScope.techpadSettings.IsCEMTechniqueEnabled;
          self.isCemTechniqueRequired = cemTechniqueData.CemReqTech;

          $rootScope.$watchCollection(
            function () {
              return self.patient.Study.Procedures;
            }.bind(this),
            function (newVal, oldVal) {
              self.shouldShowCEMTechnique = newVal.some(p => p.Cem) && cemTechniqueData.CemTechStu;
            }.bind(this)
          );
        };

        self.loadUltraSoundScanResults = async function(ssn, sDate) {
              $ionicLoading.show({
                template: 'Loading...'
              });
              return await Worklist.getUltraSoundScanResults(ssn, sDate);
        }

        self.fillProcedureSideDictionary = function() {
          self.procedures.forEach(procedure => {
            self.procedureSideDictionary[procedure.Key] = self.getProcedureSides(procedure.Key);
          });
        }

        self.fillViewsSidesDictionary = function() {
          self.patient.Study.Views.forEach(view => {
            self.viewsSidesDictionary[view.Code] = self.getViewSides(view);
          });
        }

        self.setDefaultViews = function () {
          if (self.wasViewsChanged || self.patient.Study.Views && self.patient.Study.Views.length) {
            return;
          }

          self.patient.Study.Views = [];
          const proceduresSelected = self.patient.Study.Procedures;
          const selectedProceduresConfigurations = self.procedures.filter(procedure => proceduresSelected.some(selectedProcedure => selectedProcedure.Code === procedure.Key) && procedure.Type === 'M');
          if (self.patient.Study.Views && self.patientCopy.Study.Views && !self.patientCopy.Study.Views.length && selectedProceduresConfigurations && selectedProceduresConfigurations.some(proc => !!proc.DefualtViews)) {
            let defaultViews = [];
            selectedProceduresConfigurations.forEach(procedureConfiguration => {
              const selectedProcedureSide = proceduresSelected.find(proc => proc.Code === procedureConfiguration.Key).Side;
              procedureConfiguration.DefualtViews.split(';').forEach(defaultView => {
                const defaultViewsParts = defaultView.split(',');

                const sideCode = defaultViewsParts[0];
                const resultSideCode = sideCode === selectedProcedureSide || selectedProcedureSide === 'B' ? sideCode :
                  sideCode === 'B' && selectedProcedureSide !== 'U' ? selectedProcedureSide : '';
                if (!resultSideCode) {
                  return;
                }
                const viewCode = defaultViewsParts[1];
                const viewType = (defaultViewsParts.length > 2 ? defaultViewsParts[2] : 'N') || 'N';
                const existingDefaultView = defaultViews.find(view => view.viewCode === viewCode && view.viewType === viewType);
                if (!existingDefaultView) {
                  defaultViews.push({ viewCode, sideCode: resultSideCode, viewType });
                } else if (existingDefaultView.sideCode !== sideCode) {
                  existingDefaultView.sideCode = 'B';
                }
              })
            });
            defaultViews.forEach(defaultView => {
              self.patient.Study.Views.push({ Code: defaultView.viewCode, Side: defaultView.sideCode, Type: defaultView.viewType });
            });
          }
        }

        self.getLocalTimeString = function (utcTimeString) {
          let date = new Date();
          date.setUTCHours(utcTimeString.split(":")[0]);
          date.setUTCMinutes(utcTimeString.split(":")[1]);
          date.setUTCSeconds(utcTimeString.split(":")[2]);
          let hours = date.getHours();
          let minutes = date.getMinutes().toString();
          if (minutes.length < 2) {
            minutes = '0' + minutes;
          }
          let seconds = date.getSeconds().toString();
          if (seconds.length < 2) {
            seconds = '0' + seconds;
          }
          return `${hours}:${minutes}:${seconds}`;
        }

        self.hasNoneCheckbox = function (modalControllers) {
          if (modalControllers && _.isArray(modalControllers)) {
            var none = modalControllers.find((x) => x.Name === 'None');
            if (none) {
              return true;
            }
          }
          return false;
        }

        self.moveCorrectTimeStamps = function () {
          if (self.patientCopy.ExamBeginTime) {
            self.patientCopy.ExamBeginTime = self.getLocalTimeString(self.patientCopy.ExamBeginTime);
          }
          if (self.patientCopy.ExamEndTime) {
            self.patientCopy.ExamEndTime = self.getLocalTimeString(self.patientCopy.ExamEndTime);
          }
        }

        self.getLocalTimeString = function (utcTimeString) {
          let date = new Date();
          date.setUTCHours(utcTimeString.split(":")[0]);
          date.setUTCMinutes(utcTimeString.split(":")[1]);
          date.setUTCSeconds(utcTimeString.split(":")[2]);
          let hours = date.getHours();
          let minutes = date.getMinutes().toString();
          if (minutes.length < 2) {
            minutes = '0' + minutes;
          }
          let seconds = date.getSeconds().toString();
          if (seconds.length < 2) {
            seconds = '0' + seconds;
          }
          return `${hours}:${minutes}:${seconds}`;
        }

        self.hasUnknownCheckbox = function (modalControllers) {
          if (modalControllers && _.isArray(modalControllers)) {
            var unknown = modalControllers.find((x) => x.Name === 'Unkowns');
            if (unknown) {
              return true;
            }
          }
          return false;
        }

        self.showTCSurveyNotFound = function () {
          $ionicLoading.hide();
          modalService.showErrorMessage("Family Tree survey not found. Please configure it first and try again.");
        }

        self.getSurveyIdentity = function (ssn, sDate, surveyDefId, surveyLogId, callback) {
          SurveyService.getAllSurveys().then((resp) => {
            if (resp && resp.data && resp.data.length > 0) {
              let availableSurveys = resp.data;
              var survey = availableSurveys.find((survey) => {
                return survey.IsFamilyTreeSurvey === true
              });
              if (!survey) {
                self.showTCSurveyNotFound();
                return;
              }
              Study.generatePinNumber(ssn, sDate).then((resp) => {
                self.surveyIdentity = {
                  pin: resp.data,
                  surveyDefId: survey.Id,
                  surveyDataId: `${ssn}|${sDate}`,
                  surveyLogId: surveyLogId,
                  surveyQueueId: "",
                  mode: "SurveyQuickAccess",
                  authorized: true,
                  isEmbeddedPrestartedSurvey: false,
                  authToken: authService.getAuthToken()
                };
                if (callback) {
                  callback();
                }
              });
            } else {
              self.showTCSurveyNotFound();
            }
          });
        }

        self.loadHistoryPages = async function (isNotHideLoader = false) {
          $ionicLoading.show({
            template: 'Loading History...'
          });

          try {
            let rightHistoryTypes = [];

            const isIncudeConfig = !self.historyConfig || self.patientSexChanged;
            let isIncudeImplants = false;
            if (self.historyConfig) {
              rightHistoryTypes = self.historyConfig.rightHistoryTypes;
              isIncudeImplants = !!self.historyConfig.leftHistoryConfig.find(column => column.find(config => config.Id == 'IMPLANTS'));
            }

            const worklistHistory = await dataRetrieverService.cachedProxy('worklist-history-config-' + self.patient.Ssn, 0,
              () => Worklist.getHistoryConfigAndData(self.patient.Ssn, self.patient.Study.SDate, rightHistoryTypes, isIncudeConfig, isIncudeImplants)
            );

            if (worklistHistory.data.leftHistoryConfig && worklistHistory.data.leftHistoryConfig.length) {
              self.historyConfig = self.prepareHistoryConfig(worklistHistory.data);
            }

            self.leftHistoryData = worklistHistory.data.leftHistoryData;
            self.rightHistoryData = worklistHistory.data.rightHistoryData;

            self.fillDescriptionForRightSide();
            self.processRightHistoryNoneAndUnknownConfig();

            if (self.rightHistoryData && self.rightHistoryData.length) {
              const configurations = _.flatten(self.historyConfig.rightHistoryConfig);
              configurations.forEach(config => {
                if (config.Type === 'Finding') {
                  const historyItem = self.rightHistoryData.find(item => item.name === config.Id);
                  if (historyItem) {
                    self.processFindingConfig(config, historyItem);
                  }
                }
              });
            }

            self.leftHistoryDataCopy = _.cloneDeep(self.leftHistoryData);
            self.rightHistoryDataCopy = _.cloneDeep(self.rightHistoryData);

            if (worklistHistory.data.implantsData) {
              self.implantData = worklistHistory.data.implantsData.Implant;
              self.implantDataCopy = _.cloneDeep(worklistHistory.data.implantsData.Implant);
              self.implantString = self.getImplantString();
            }

            if ($rootScope.techpadSettings.NccnPat) {
              self.nccnGuideline = worklistHistory.data.nccnGuideline;
              self.initNccnDateFields();
              self.nccnGuidelineCopy = _.cloneDeep(self.nccnGuideline);

              if (worklistHistory.data.myriadLastSentDate &&
                worklistHistory.data.myriadLastSentDate !== commonConstants.defaultDateTimeSqlMinValue &&
                worklistHistory.data.myriadLastSentDate !== commonConstants.defaultDateTimeMinValue) {
                self.lastSentDateToMyriad = worklistHistory.data.myriadLastSentDate;
              }

              if (worklistHistory.data.trfLastPrintDate &&
                worklistHistory.data.trfLastPrintDate !== commonConstants.defaultDateTimeSqlMinValue &&
                worklistHistory.data.trfLastPrintDate !== commonConstants.defaultDateTimeMinValue) {
                self.trfLastPrintDate = worklistHistory.data.trfLastPrintDate;
              }

              self.detectMyriadFailureState();
            }

            self.initPersonalBRCAValues();

            self.examUfieldsData = worklistHistory.data.examUfieldsData;
            self.examUfieldsDataCopy = _.cloneDeep(self.examUfieldsData);
            if(!isNotHideLoader) {
              $ionicLoading.hide();
            }
          } catch (error) {
            console.error(error);
            if(!isNotHideLoader) {
              $ionicLoading.hide();
            }            
            self.callWorklistDetailsRefreshException(error);
          }
        };

        self.saveAndReloadRisk = async function () {
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();

          if (isNotOffline) {
            self.saveChanges(() => {
              $ionicLoading.hide();
            });
          } else {
            $ionicLoading.hide();
          }
        }

        self.isGcTestResultsChanged = function () {
          if (!self.nccnGuidelineCopy || !self.nccnGuidelineCopy.Elements || !self.nccnGuideline || !self.nccnGuideline.Elements) {
            return false;
          }

          const originalGcElement = self.nccnGuidelineCopy.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcTestResultsProperty = originalGcElement &&
            originalGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcTestResultsPropertyId);
          
          if (!originalGcTestResultsProperty || !originalGcTestResultsProperty.Options) {
            return false;
          }

          const originalGcTestResultsOptions = originalGcTestResultsProperty.Options.filter(option => !option.AffectAllSiblings);
          const currentGcElement = self.nccnGuideline.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const currentGcTestResultsProperty = currentGcElement &&
            currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcTestResultsPropertyId);

          if (!currentGcTestResultsProperty || !currentGcTestResultsProperty.Options) {
            return false;
          }

          const currentGcTestResultsOptions = currentGcTestResultsProperty.Options.filter(option => !option.AffectAllSiblings);
          const isChanged = !angular.equals(originalGcTestResultsOptions, currentGcTestResultsOptions);
          return isChanged;
        }

        self.initNccnDateOffered = function(date) {
          const currentGcElement = self.nccnGuideline.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const currentGcTestDateOfferedProperty = currentGcElement
            && currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateOfferedPropertyId);
          
          const originalGcElement = self.nccnGuidelineCopy.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcTestDateOfferedProperty = originalGcElement
            && originalGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateOfferedPropertyId);

          const formattedDateString = dateFormattingHelper.formatDateStringToUSFormat(date);
          if(currentGcTestDateOfferedProperty) {
            currentGcTestDateOfferedProperty.Response = formattedDateString;
          }
          if(originalGcTestDateOfferedProperty) {
            originalGcTestDateOfferedProperty.Response = formattedDateString;
          }
        }
        
        self.initNccnDateResponded = function(date) {
          const currentGcElement = self.nccnGuideline.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const currentGcTestDateRespondedProperty = currentGcElement
            && currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateRespondedPropertyId);

          const originalGcElement = self.nccnGuidelineCopy.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcTestDateRespondedProperty = originalGcElement
            && originalGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateRespondedPropertyId);

          const formattedDateString = dateFormattingHelper.formatDateStringToUSFormat(date);
          if(currentGcTestDateRespondedProperty) {
            currentGcTestDateRespondedProperty.Response = formattedDateString;
          }
          if(originalGcTestDateRespondedProperty) {
            originalGcTestDateRespondedProperty.Response = formattedDateString;
          }
        }

        self.initNccnDateFields = function () {
          const currentGcElement = self.nccnGuideline.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
          const currentGcTestDateOfferedProperty = currentGcElement
            && currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateOfferedPropertyId);
          const currentGcTestDateRespondedProperty = currentGcElement
            && currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDateRespondedPropertyId);
          const currentGcTestDatePerformedProperty = currentGcElement 
            && currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDatePerformedPropertyId);

          if (currentGcTestDateOfferedProperty && currentGcTestDateOfferedProperty.Response === commonConstants.DEFAULT_FOX_PRO_EMPTY_DATE) {
            currentGcTestDateOfferedProperty.Response = commonConstants.DEFAULT_TECHPAD_CONTROL_DATE_EMPTY_DATE;
          }

          if (currentGcTestDateRespondedProperty && currentGcTestDateRespondedProperty.Response === commonConstants.DEFAULT_FOX_PRO_EMPTY_DATE) {
            currentGcTestDateRespondedProperty.Response = commonConstants.DEFAULT_TECHPAD_CONTROL_DATE_EMPTY_DATE;
          }

          if (currentGcTestDatePerformedProperty && currentGcTestDatePerformedProperty.Response === commonConstants.DEFAULT_FOX_PRO_EMPTY_DATE) {
            currentGcTestDatePerformedProperty.Response = commonConstants.DEFAULT_TECHPAD_CONTROL_DATE_EMPTY_DATE;
          }
        }

        self.callWorklistDetailsRefreshException = async function (error) {
          if (self.historyLoadRetries <= 0) {
            await modalService.showErrorMessage((error && error.data) || error, error && error.status);
            let model = new RefreshWorklistDetailsDialogModel(self.refresh);
            let closeByButtonsClickOnly = true;
            await modalService.showDialogWindow('views/templates/refreshWorklistDetailsDialog.html', model, closeByButtonsClickOnly);
            self.historyLoadRetries = $rootScope.techpadSettings.HistoryLoadRetries;
          } else {
            self.historyLoadRetries--;
            let isSkipConfirmation = true;
            await self.refresh(isSkipConfirmation);
          }
        };

        self.getRightHistoryConfigByName = function(rightHistoryItemName) {
          const configurations = _.flatten(self.historyConfig.rightHistoryConfig);
          const config = configurations.find(property => property.Id === rightHistoryItemName);

          return config;
        };

        self.processRightHistoryNoneAndUnknownConfig = function() {
          const configurations = _.flatten(self.historyConfig.rightHistoryConfig);
          configurations.forEach(config => {            
            config.hasNone = self.hasNoneCheckbox(config.ModelController);
            config.hasUnknown = self.hasUnknownCheckbox(config.ModelController);
          });            
        }

        self.getRequiredParametersForRightHistoryDescription = function(config) {
          const type = config.Type;
            
          const typeFieldConfig = config.ModelController.find(fieldConfig => 
            fieldConfig.Caption === examConstants.RH_CONFIG_TYPE_CAPTION
            || (type === examConstants.RH_CONFIG_PROCEURE_TYPE 
                && fieldConfig.Caption === examConstants.RH_CONFIG_PROCEURE_TYPE_CAPTION));
          const types = typeFieldConfig && typeFieldConfig.Options;

          const procResultFieldConfig = config.ModelController.find(fieldConfig => 
            type === examConstants.RH_CONFIG_PROCEURE_TYPE && fieldConfig.Caption === examConstants.RH_CONFIG_PROCEURE_RESULT_CAPTION);
          const procResults = procResultFieldConfig && procResultFieldConfig.Options;

          const relativeTypeFieldConfig = config.ModelController.find(fieldConfig => 
            fieldConfig.Caption === examConstants.RH_CONFIG_RELATIVE_CAPTION);
          const relativeTypes = relativeTypeFieldConfig && relativeTypeFieldConfig.Options;

          return {
            types,
            relativeTypes,
            procResults,
          };
        };

        self.getRightHistoryParetTypes = function(record, relativeTypes) {
          const selectedRelativeConfig = 
            relativeTypes 
            && relativeTypes.find(option => option.Code === record.Relative 
                                            && option.AskParent === true.toString());
          const parentTypes = selectedRelativeConfig ? selectedRelativeConfig.ParentsList.Options : null;
          return parentTypes;
        };

        self.fillDescriptionForRightSide = function () {
          _.each(self.rightHistoryData, function (rightHistoryDataItem) {

            const currentRightHistoryConfig = self.getRightHistoryConfigByName(rightHistoryDataItem.name);
            const type = currentRightHistoryConfig.Type;

            const descriptionParameters = self.getRequiredParametersForRightHistoryDescription(currentRightHistoryConfig);

            if (type === examConstants.RH_CONFIG_CANCER_TYPE) {
              rightHistoryDataItem.data.forEach(record => {
                descriptionParameters.parentTypes = self.getRightHistoryParetTypes(record, descriptionParameters.relativeTypes);
                record.Description = self.getCancerDescription(record, descriptionParameters);
              });
            }
            if (type === examConstants.RH_CONFIG_PROCEURE_TYPE) {
              rightHistoryDataItem.data.forEach(record => {
                record.Description = self.getProcedureDescription(rightHistoryDataItem.name, record, descriptionParameters);
              });
            }
            if (type === examConstants.RH_CONFIG_HORMONE_TYPE) {
              rightHistoryDataItem.data.forEach(record => {
                record.Description = self.getHormoneDescription(record, descriptionParameters);
              });
            }
            if (type === examConstants.RH_CONFIG_BRCA_TYPE) {
              rightHistoryDataItem.data.forEach(record => {
                descriptionParameters.parentTypes = self.getRightHistoryParetTypes(record, descriptionParameters.relativeTypes);
                record.Description = self.getFBRCADescription(record, descriptionParameters);
              });
            }
          });
        };

        self.getFBRCADescription = function (record, descriptionParameters) {
          let relativeTypeDescription = '';
          let relative = descriptionParameters.relativeTypes.find((type) => type.Code === record.Relative);
          relativeTypeDescription = relative && relative.Desc || '';

          if (record.Parent && descriptionParameters.parentTypes && descriptionParameters.parentTypes.length) {
            const parentConfig = descriptionParameters.parentTypes.find(parent => parent.Code === record.Parent);
            relativeTypeDescription += parentConfig ? ` (Parent: ${parentConfig.Desc}) ` : '';
          }

          let brcaDescription = '';
          if (record.Brca1 == record.Brca2) {
            brcaDescription = `BRCA1, BRCA2: ${(record.Brca1 == '0' ? 'Not Tested' : record.Brca1 == '1' ? 'Tested, Positive' : 'Tested, Negative')}`;
          } else {
            brcaDescription = `BRCA1: ${(record.Brca1 == '0' || record.Brca1 === "" ? 'Not Tested' : record.Brca1 == '1' ? 'Tested, Positive' : 'Tested, Negative')}`;
            brcaDescription += `, BRCA2: ${(record.Brca2 == '0' || record.Brca2 === "" ? 'Not Tested' : record.Brca2 == '1' ? 'Tested, Positive' : 'Tested, Negative')}`;
          }

          return relativeTypeDescription + (brcaDescription ? ', ' + brcaDescription : '');
        };

        self.getHormoneDescription = function (record, descriptionParameters) {

          let filteredType = descriptionParameters.types.find((type) => type && type.Code === record.Type);

          let typeDescription = filteredType && filteredType.Desc || "";

          let started = '';
          if (record.FAge) {
            started = ' from ' + record.FAge;
          } else if (record.FYear) {
            if (record.FYear === '-1' || record.FYear === '-2') {
              started = ' beginning at an unknown time';
            } else if (record.FYear === '>10') {
              started = ' beginning more than 10 years ago';
            } else {
              if (record.FMonth && record.FMonth !== '-1') {
                if (record.FDay) {
                  started = ' beginning from ' + record.FMonth + '/' + record.FDay + '/' + record.FYear;
                } else {
                  started = ' beginning in ' + self.monthNames[record.FMonth - 1] + ' ' + record.FYear;
                }
              } else {
                started = ' beginning in ' + record.FYear
              }
            }
          }

          let until = '';
          if (record.CurrentUsing === 'Y') {
            until = ' to present';
          } else {
            if (record.LAge) {
              until = ' to age ' + record.LAge;
            } else if (record.LYear) {
              if (record.LYear === '-2' || record.LYear === '-1') {
                until = ' to an unknown time';
              } else if (record.LYear === '>10') {
                until = ' ending more than 10 years ago';
              } else if (record.LYear === -1) {
                until = ' at unknown age';
              } else {
                if (record.LMonth && record.LMonth !== '-1') {
                  if (record.LDay) {
                    until = ' to ' + record.LMonth + '/' + record.LDay + '/' + record.LYear;
                  } else {
                    until = ' to ' + self.monthNames[record.LMonth - 1] + ' ' + record.LYear;
                  }
                } else {
                  until = ' to ' + record.LYear
                }
              }
            }
            if (record.CurrentUsing === 'N') {
              until += ' in the past';
            }
          }

          let duration = '';
          let durationParts = [];

          if (record.DYear || record.DMonth || record.DWeek) {
            if (record.ContinuousUse === 'Y') {
              duration = ', continuously';
            }

            if (record.DYear > 0) {
              let yearText = `${record.DYear} year`;
              if (record.DYear !== 1) yearText += 's';
              durationParts.push(yearText);
            }

            if (record.DMonth > 0) {
              let monthText = `${record.DMonth} month`;
              if (record.DMonth !== 1) monthText += 's';
              durationParts.push(monthText);
            }

            if (record.DWeek > 0) {
              let weekText = `${record.DWeek} week`;
              if (record.DWeek !== 1) weekText += 's';
              durationParts.push(weekText);
            }

            if (durationParts.length > 0) {
              duration += ` for ${durationParts.join(' and ')}`;
            }
          }

          return record.Notes
            ? `${typeDescription}${started}${until}${duration} - ${record.Notes}`
            : `${typeDescription}${started}${until}${duration}`;
        };

        self.getProcedureDescription = function (category, record, descriptionParameters) {
          let filteredType = descriptionParameters.types.find((type) => type && type.Code === record.List);

          let typeDescription = filteredType && filteredType.Desc || "";

          let side = '';

          if (category === 'GS') {
            if (record.Side === 'L') {
              side = ', left';
            } else if (record.Side === 'R') {
              side = ', right';
            } else if (record.Side === 'B') {
              side = ', bilateral';
            }
          } else {
            if (record.Side === 'L') {
              side = ' in the left breast';
            } else if (record.Side === 'R') {
              side = ' in the right breast';
            } else if (record.Side === 'B') {
              side = ', bilateral';
            }
          }

          let when = '';
          let year = record.DiagnosisYear || record.Year;
          let month = record.DiagnosisYear || record.Month;
          if (record.Date && record.Date !== '/  /' && record.Date !== '//') {
            let date = new Date(record.Date);
            when = ' on ' + self.monthNames[date.getMonth()] + ' ' + date.getDate() + ' ' + date.getFullYear();
          } else if (record.Age) {
            when = ' at age ' + record.Age;
          } else if (year) {
            if (year === '-1') {
              when = ' at an unknown age';
            } else if (year === '-2') {
              when = ' other year';
            } else if (year === '>10') {
              when = ' more than 10 years ago';
            } else if (year === -1) {
              when = ' at an unknown age';
            } else {
              if (month && month !== '-1') {
                when = ' in ' + self.monthNames[month - 1] + ' ' + year;
              } else {
                when = ' in ' + year
              }
            }
          }

          let procResultDescription = '';
          if (record.Result) {
            procResultDescription = ' - ' + descriptionParameters.procResults.find(result => {
              return result.Code == record.Result
            }).Desc;
          }

          return record.Notes ? typeDescription + side + when + ' - ' + record.Notes : typeDescription + side + when + procResultDescription;
        };

        self.getCancerDescription = function (record, descriptionParameters) {
          let includeRelative = !!descriptionParameters.relativeTypes;
          let relativeTypeDescription = '';
          if (includeRelative && descriptionParameters.relativeTypes && descriptionParameters.relativeTypes.length) {
            let relative = descriptionParameters.relativeTypes.find((type) => type.Code === record.Relative);
            relativeTypeDescription = relative && relative.Desc || '';
          }

          let filteredType = descriptionParameters.types.find((type) => type && type.Code === record.Type);
          let typeDescription = filteredType && filteredType.Desc || '';

          if (record.Parent && descriptionParameters.parentTypes && descriptionParameters.parentTypes.length) {
            const parentConfig = descriptionParameters.parentTypes.find(parent => parent.Code === record.Parent);
            relativeTypeDescription += parentConfig ? ` (Parent: ${parentConfig.Desc}) ` : '';
          }

          let side = '';
          if (record.Side === 'L') {
            side = ' in the left breast';
          } else if (record.Side === 'R') {
            side = ' in the right breast';
          } else if (record.Side === 'B') {
            side = ' bilateral';
          }

          let when = '';
          if (record.Date && record.Date !== '/  /' && record.Date !== '//') {
            let date = new Date(record.Date);
            when = ' on ' + self.monthNames[date.getMonth()] + ' ' + date.getDate() + ' ' + date.getFullYear();
          } else if (record.Age) {
            when = ' at age ' + record.Age;
          } else if (record.DiagnosisYear) {
            if (record.DiagnosisYear === '-1') {
              when = ' at an unknown age';
            } else if (record.DiagnosisYear === '-2') {
              when = ' other year';
            } else if (record.DiagnosisYear === '>10') {
              when = ' more than 10 years ago';
            } else if (record.DiagnosisYear === -1) {
              when = ' at an unknown age';
            } else {
              if (record.DiagnosisMonth && record.DiagnosisMonth !== '-1') {
                when = ' in ' + self.monthNames[record.DiagnosisMonth - 1] + ' ' + record.DiagnosisYear;
              } else {
                when = ' in ' + record.DiagnosisYear
              }
            }
          }
          let result = typeDescription + side + when;
          if (record.Bilateral === 'Y') {
            result += ' - Bilateral';
          }
          if (record.Menopausal === 'Y' && record.Bilateral === 'Y') {
            result += ', Pre-Menopausal';
          } else if (record.Menopausal === 'Y' && record.Bilateral !== 'Y') {
            result += ' - Pre-Menopausal';
          }

          result = includeRelative ? relativeTypeDescription + ': ' + result : result;

          return record.Notes ? result + ' - ' + record.Notes : result;
        };

        self.monthNames = ["January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];

        self.getImplantString = function () {

          if (!self.implantData) {
            return null;
          }

          let leftImplantSelected = self.implantData.Left.filter((implantOption) => implantOption.Value)
            .map(self.getImplantLabelValue);
          let rightImplantSelected = self.implantData.Right.filter((implantOption) => implantOption.Value)
            .map(self.getImplantLabelValue);

          let implantString = 'THERE ARE ';
          let rightBreastImplantsHasData = false;
          let resultImplants = [];
          let firstResultImplants = [];
          let middleResultImplants = [];
          let lastResultImplants = [];

          if (self.implantData.SameInBoth === 'True') {
            //No implants
            if (rightImplantSelected.indexOf('No Implant') > -1) {
              return implantString + 'NO IMPLANTS PRESENT';
            }
            //Type not specified
            resultImplants = rightImplantSelected.filter((implant) => implant !== 'Implant - type not specified');
            firstResultImplants = resultImplants.filter((implant) => implant === 'Pre-pectoral' || implant === 'Retro-pectoral');
            middleResultImplants = resultImplants.filter((implant) => implant === 'Saline' || implant === 'Silicone Gel' || implant === 'Double Lumen');
            lastResultImplants = resultImplants.filter((implant) => implant === 'Augmentation mammoplasty');
            implantString += 'BILATERAL ';
            implantString += firstResultImplants.join(' AND ');
            implantString += ' ';
            implantString += middleResultImplants.join(' AND ');
            implantString += ' IMPLANTS';
            if (lastResultImplants.length > 0) {
              implantString += ' WITH ' + lastResultImplants[0];
            }
          } else {
            if (!rightImplantSelected.length && !leftImplantSelected.length ||
              !rightImplantSelected.length && leftImplantSelected.indexOf('No Implant') > -1 ||
              rightImplantSelected.indexOf('No Implant') > -1 && !leftImplantSelected.length ||
              rightImplantSelected.indexOf('No Implant') > -1 && leftImplantSelected.indexOf('No Implant') > -1) {
              return implantString + 'NO IMPLANTS PRESENT';
            }
            if (rightImplantSelected.indexOf('No Implant') === -1) {
              resultImplants = rightImplantSelected.filter((implant) => implant !== 'Implant - type not specified');
              firstResultImplants = resultImplants.filter((implant) => implant === 'Pre-pectoral' || implant === 'Retro-pectoral');
              middleResultImplants = resultImplants.filter((implant) => implant === 'Saline' || implant === 'Silicone Gel' || implant === 'Double Lumen');
              lastResultImplants = resultImplants.filter((implant) => implant === 'Augmentation mammoplasty');
              if (firstResultImplants.length === 1 && middleResultImplants.length < 2) {
                implantString = 'THERE IS ';
              }
              implantString += firstResultImplants.join(' AND ');
              implantString += ' ';
              implantString += middleResultImplants.join(' AND ');
              implantString += resultImplants.length === 0 || firstResultImplants.length === 1 && middleResultImplants.length < 2 ? ' IMPLANT' : ' IMPLANTS';
              if (lastResultImplants.length > 0) {
                implantString += ' WITH ' + lastResultImplants[0];
              }
              implantString += ' IN THE RIGHT BREAST';
              rightBreastImplantsHasData = true;
            }

            if (leftImplantSelected.indexOf('No Implant') === -1) {
              if (rightBreastImplantsHasData) {
                implantString += ' AND ';
              }
              resultImplants = leftImplantSelected.filter((implant) => implant !== 'Implant - type not specified');
              firstResultImplants = resultImplants.filter((implant) => implant === 'Pre-pectoral' || implant === 'Retro-pectoral');
              middleResultImplants = resultImplants.filter((implant) => implant === 'Saline' || implant === 'Silicone Gel' || implant === 'Double Lumen');
              lastResultImplants = resultImplants.filter((implant) => implant === 'Augmentation mammoplasty');
              if (!rightBreastImplantsHasData && firstResultImplants.length === 1 && middleResultImplants.length < 2) {
                implantString = 'THERE IS ';
              }
              implantString += firstResultImplants.join(' AND ');
              implantString += ' ';
              implantString += middleResultImplants.join(' AND ');
              implantString += resultImplants.length === 0 || firstResultImplants.length === 1 && middleResultImplants.length < 2 ? ' IMPLANT' : ' IMPLANTS';
              if (lastResultImplants.length > 0) {
                implantString += ' WITH ' + lastResultImplants[0];
              }
              implantString += ' IN THE LEFT BREAST';
            }
          }
          return implantString.toUpperCase();
        };

        self.getImplantLabelValue = function (implant) {
          return implant.Label || implant.Lable;
        };

        self.prepareHistoryConfig = function (source) {

          let minLeftHistoryColumnItems = 8;
          let minRightHistoryColumnItems = 4;
          let minExamUfieldsColumnItems = 1;

          let leftHistoryItems = _.sortBy(source.leftHistoryConfig, (x) => x.Column * 1000 + x.Order);

          let rightHistoryItems = _.sortBy(source.rightHistoryConfig, (x) => x.Order);

          let rightHistoryTypes = _.map(rightHistoryItems, (x) => x.Id);

          let examUfieldsConfig = _.sortBy(source.examUfieldsConfig, (x) => x.Order);

          let historyFieldsConfiguration = {
            leftHistoryConfig: self.splitIntoTwoColumns(leftHistoryItems, minLeftHistoryColumnItems),
            rightHistoryConfig: self.splitIntoTwoColumns(rightHistoryItems, minRightHistoryColumnItems),
            rightHistoryTypes: rightHistoryTypes,
            examUfieldsConfig: self.splitIntoTwoColumns(examUfieldsConfig, minExamUfieldsColumnItems)
          };

          let aAgeConfig = _.find(source.leftHistoryConfig, (config) => config.Id === constantStrings.aAgeConfigId);
          if (aAgeConfig) {
            aAgeConfig.OPTIONS = self.getAAgeConfigOptions();
          }

          return historyFieldsConfiguration;
        };

        self.getAAgeConfigOptions = function () {
          const patientAge = self.calculateAge(self.patient.DateOfBirth);
          let options = [];
          for (let i = 5; i < patientAge + 1; ++i) {
            options.push({ Code: i, Desc: i + '' });
          }
          return options;
        }

        self.openImplantsRecord = async function () {
          let model = new ImplantsRecordDetailDialogModel(self.implantData);

          let closeByButtonsClickOnly = true;
          await modalService.showDialogWindow('views/templates/implantsEditDialog.html', model, closeByButtonsClickOnly);

          if (!model.cancelled && self.implantData !== model.dataCopy) {
            self.implantData = model.dataCopy;
            self.implantString = self.getImplantString();
          }
        };

        self.openRightHistoryFindingRecord = async function (config, data) {
          if (self.isViewOnly) {
            return;
          }
          const editMode = !!data;
          if (!data) {
            data = {};
          }
          let title = config.Caption;
          let modalConfig = {
            _editorType: config
          };

          config.ModelController.forEach((x) => {
            modalConfig[x.Name] = x;
          });

          if (_.isEmpty(data)) {
            _.forOwn(modalConfig, function (value, key) {
              if (key !== "_editorType") {
                if (value.Caption === examConstants.RH_CONFIG_TYPE_CAPTION) {
                  data[value.Caption] = '';
                } else {
                  data[value.Name] = '';
                }
              }
            });
          }

          if (config.Type === examConstants.RH_CONFIG_PROCEURE_TYPE_CAPTION) {
            modalConfig.IsValidateHistoryResultField = techpadConfig.settings.IsValidateHistoryResultField;
          }

          let model = new RightHistoryRecordDetailDialogModel(modalConfig, data, editMode, title, self.patient.DateOfBirth, techpadConfig.settings.PatientHistoryDynamicLabels, $rootScope);
          let closeByButtonsClickOnly = true;

          let options = new Object();
          options.afterWindowShown = function () {
            model.dataCopy = _.cloneDeep(model.data);
          }

          await modalService.showDialogWindow(self.getTemplateNameByConfig(config.Type), model, closeByButtonsClickOnly, options);

          if (editMode && model.deleted) { // delete mode
            if (!data.Id) {
              var rightHistoryDataItem = self.rightHistoryData.find(function (item) {
                return item.name === config.Id;
              });

              if (rightHistoryDataItem) {
                rightHistoryDataItem.data = _.without(rightHistoryDataItem.data, data);
              }
            } else {
              data.IsDeleted = true;
            }
          }

          if (!model.cancelled && !editMode) { // create mode
            var rightHistoryDataItem = self.rightHistoryData.find(function (item) {
              return item.name === config.Id;
            });

            if (rightHistoryDataItem) {
              rightHistoryDataItem.data.push(data);
            }
          }

          self.processFindingConfig(config, data)
        }

        self.editDateRecord = async function (array, property) {
          let model = new DateRecordEditDialogModel();

          let closeByButtonsClickOnly = true;
          await modalService.showDialogWindow('views/templates/dateRecordEditDialog.html', model, closeByButtonsClickOnly);

          if (model.dateString) {
            array[property] = model.dateString;
          }
        };

        self.openRightHistoryRecord = async function (config, data) {
          if (self.isViewOnly) {
            return;
          }
          const editMode = !!data;
          if (!data) {
            data = {};
          }
          let title = config.Caption;
          let modalConfig = {
            _editorType: config
          };

          config.ModelController.forEach((x) => {
            modalConfig[x.Name] = x;
          });

          if (config.Type === examConstants.RH_CONFIG_BRCA_TYPE) {
            modalConfig = this.processBRCAUnambiguousRelative(modalConfig, data);
          }

          if (_.isEmpty(data)) {
            _.forOwn(modalConfig, function (value, key) {
              if (key !== "_editorType") {
                if (value.Caption === examConstants.RH_CONFIG_TYPE_CAPTION) {
                  data[value.Caption] = '';
                } else {
                  data[value.Name] = '';
                }
              }
            });
          }

          if (config.Type === examConstants.RH_CONFIG_HORMONE_TYPE) {
            delete data['FDate'];
            delete data['LDate'];
          }

          if (config.Type === examConstants.RH_CONFIG_PROCEURE_TYPE_CAPTION){
            modalConfig.IsValidateHistoryResultField = techpadConfig.settings.IsValidateHistoryResultField;
          }

          let model = new RightHistoryRecordDetailDialogModel(modalConfig, data, editMode, title, self.patient.DateOfBirth, techpadConfig.settings.PatientHistoryDynamicLabels, $rootScope);
          let closeByButtonsClickOnly = true;

          let options = new Object();
          options.afterWindowShown = function () {
            model.dataCopy = _.cloneDeep(model.data);
          }

          await modalService.showDialogWindow(self.getTemplateNameByConfig(config.Type), model, closeByButtonsClickOnly, options);

          if (editMode && model.deleted) { // delete mode
            if (!data.Id) {
              var rightHistoryDataItem = self.rightHistoryData.find(function (item) {
                return item.name === config.Id;
              });

              if (rightHistoryDataItem) {
                rightHistoryDataItem.data = _.without(rightHistoryDataItem.data, data);
              }
            } else {
              data.IsDeleted = true;
            }
          }

          if (!model.cancelled && !editMode) { // create mode
            var rightHistoryDataItem = self.rightHistoryData.find(function (item) {
              return item.name === config.Id;
            });

            if (rightHistoryDataItem) {
              rightHistoryDataItem.data.push(data);
            }
          }

          const descriptionParameters = self.getRequiredParametersForRightHistoryDescription(config);
                    
          if (!model.cancelled && config.Type === examConstants.RH_CONFIG_CANCER_TYPE) {
            descriptionParameters.parentTypes = self.getRightHistoryParetTypes(data, descriptionParameters.relativeTypes);
            data.Description = self.getCancerDescription(data, descriptionParameters);
          }
          if (!model.cancelled && config.Type === examConstants.RH_CONFIG_PROCEURE_TYPE) {
            data.Description = self.getProcedureDescription(config.Id, data, descriptionParameters);
          }
          if (!model.cancelled && config.Type === examConstants.RH_CONFIG_HORMONE_TYPE) {
            data.Description = self.getHormoneDescription(data, descriptionParameters);
          }
          if (!model.cancelled && config.Type === examConstants.RH_CONFIG_BRCA_TYPE) {
            descriptionParameters.parentTypes = self.getRightHistoryParetTypes(data, descriptionParameters.relativeTypes);
            data.Description = self.getFBRCADescription(data, descriptionParameters);
          }
        };

        self.processBRCAUnambiguousRelative = function (modalConfig, record) {
          let self = this;
          //checking if unambiguous relatives records exists

          var brcaDataItem = _.find(self.rightHistoryData, function (item) {
            return item.name === 'BRCA';
          });

          let usedUnambiguousRelativeRecords = brcaDataItem.data.filter(item => {
            return self.unambiguousRelativeCodeList.indexOf(item.Relative) > -1
          });
          //if unambiguous records exists we would remove unambiguous relatives from the dropdown
          if (usedUnambiguousRelativeRecords && usedUnambiguousRelativeRecords.length) {
            let usedUnambiguousRelativeCodes = usedUnambiguousRelativeRecords.map(x => {
              return x.Relative
            });
            let newModalConfig = angular.copy(modalConfig);
            let options = [];
            //filtering out unambiguous relatives from the config so that no duplication happen on creating new record,
            // or allowig relative option if editing
            newModalConfig.Relative.Options.forEach(function (option) {
              if (usedUnambiguousRelativeCodes.indexOf(option.Code) == -1 || (record && option.Code === record.Relative)) {
                options.push(option);
              }
            });
            newModalConfig.Relative.Options = options;
            return newModalConfig;
          }
          return modalConfig;
        }

        self.getTemplateNameByConfig = function (type) {
          return 'views/templates/history' + type + 'EditDialog.html';
        };

        self.splitIntoTwoColumns = function (items, minColumnItemsCount) {
          let half = Math.round(items.length / 2);
          let colCount = half > minColumnItemsCount ? half : minColumnItemsCount;
          let result = [
            [],
            []
          ];

          items.forEach((item, index) => {
            if (index < colCount) {
              result[0].push(item);
            } else {
              result[1].push(item);
            }
          });
          return result;
        };

        //#region Study tab
        self.getNoStudyMessage = function () {
          return 'There is no prior study for this patient';
        };

        self.setStudies = function () {
          if (!self.studies){
            return null;
          }

          const studiesToDisplay = StudyDisplayHelpers.transformStudiesForDisplay(self.studies.data, {
            locations: self.locations,
            visitTypes: enums.visitTypes,
            visitReasons: self.visitReasons,
            dStatusTypes: enums.dStatusType,
            biRads: enums.biRads,
            procTypes: self.procTypes,
            viewsTypes: self.viewsTypes,
          });

          self.studiesToDisplay  =  studiesToDisplay;
        }

        self.getLocations = function () {
          if (!self.locations){
            return null
          }

          const locationsToDisplay = self.locations.data;
          return locationsToDisplay;
        }

        self.loadStudies = async function () {
          self.studies = await Study.loadPriorStudies(self.patient.Ssn, self.patient.SDate);
          self.studiesLoaded = true;
        };

        self.shouldShowFilmsComparedValue = null;
        self.isFilmsComparedEnabledValue = null;
        self.isLoadingShouldShowFilmsCompared = false;

        self.getProceduresString = function () {
          if (!self.patient || !self.patient.Study || !self.patient.Study.Procedures || !self.patient.Study.Procedures.length) {
            return null;
          }
          
          return self.patient.Study.Procedures
            .map(p => {
              const side = p.Side || 'B';
              return `${p.Code}-${side}`;
            })
            .join(',');
        };

        self.loadShouldShowFilmsCompared = async function () {
          if (!self.patient || !self.patient.Ssn || !self.patient.SDate) {
            self.shouldShowFilmsComparedValue = false;
            self.isFilmsComparedEnabledValue = false;
            self.isLoadingShouldShowFilmsCompared = false;
            return false;
          }

          if (self.isLoadingShouldShowFilmsCompared) {
            return false;
          }

          self.isLoadingShouldShowFilmsCompared = true;

          try {
            const proceduresStr = self.getProceduresString();
            const response = await Study.getFilmsComparedButtonState(proceduresStr, null, self.patient.Ssn, self.patient.SDate);
            const buttonState = response.data;
            self.shouldShowFilmsComparedValue = buttonState.ShouldShow === true;
            self.isFilmsComparedEnabledValue = buttonState.IsEnabled === true;
            self.isLoadingShouldShowFilmsCompared = false;
            return self.shouldShowFilmsComparedValue;
          } catch (error) {
            modalService.showErrorMessage(error.data || 'Error checking if Films Compared should be shown.', error.status);
            self.shouldShowFilmsComparedValue = false;
            self.isFilmsComparedEnabledValue = false;
            self.isLoadingShouldShowFilmsCompared = false;
            return false;
          }
        };

        self.shouldShowFilmsCompared = function () {
          if (self.shouldShowFilmsComparedValue === null && self.patient && self.patient.Ssn && self.patient.SDate && !self.isLoadingShouldShowFilmsCompared) {
            self.loadShouldShowFilmsCompared();
            return false;
          }
          return self.shouldShowFilmsComparedValue === true;
        };

        self.isFilmsComparedEnabled = function () {
          if (self.isFilmsComparedEnabledValue === null && self.patient && self.patient.Ssn && self.patient.SDate && !self.isLoadingShouldShowFilmsCompared) {
            self.loadShouldShowFilmsCompared();
            return false;
          }
          return self.isFilmsComparedEnabledValue === true;
        };

        self.viewReport = async function (study) {
          let document = null;
          try {
            document = await documentsSvc.getRadReportBySsnAndSDate(study.Ssn,study.SDate );
          } catch (error) {
            modalService.showAlert(
              commonConstants.STUDY_REPORT_UNAVAILABLE,
              undefined,
              undefined,
              commonConstants.REPORT_UNAVAILABLE,
              commonConstants.advancedConfirmationCancelButtonText);
            return;
          }
          await self.showDocument(document.data);
        }

        //#region Follow-up tab
        self.showResolvedFollowup = false;

        self.getNoFollowUpMessage = function () {
          if (self.showResolvedFollowup || !self.followUps) {
            return 'There is no follow-up for this patient';
          }

          return 'There is no open follow-up for this patient';
        };

        self.hasOpenedFollowUps = function () {
          if (!self.followUps || !self.followUps.length)
            return false;

          return self.followUps.some((followUpItem) => followUpItem.FUReason.trim() === "");
        };

        self.getFollowUps = function () {
          if (!self.followUps)
            return null;

          let followUpsToDisplay = self.followUps.filter((followUpItem) => self.showResolvedFollowup || !followUpItem || !followUpItem.FUReason || followUpItem.FUReason.trim() === "");

          return followUpsToDisplay;
        };

        self.loadFollowUps = async function () {
          try {
            if (!self.recommendations || self.recommendations.length === 0) {
              try {
                self.recommendations = await FollowUpsDomain.getRecommendations();
              } catch (error) {
                console.warn('Could not load recommendations:', error);
                self.recommendations = [];
              }
            }

            self.followUps = await FollowUpsDomain.getFollowUps(self.patient.Ssn);
            let nextLetterTypesMap = {};
            
            try {
              const nextLetterTypes = await FollowUpsDomain.getNextLetterTypes(self.patient.Ssn);
              if (nextLetterTypes && nextLetterTypes.length) {
                nextLetterTypes.forEach(item => {
                  const sDateKey = new Date(item.SDate).toISOString();
                  nextLetterTypesMap[sDateKey] = item.NextLetterType;
                });
              }
            } catch (error) {
              console.warn('Could not load next letter types:', error);
            }
            
            if (self.followUps && self.followUps.length) {
              self.followUps.forEach(followUp => {
                self.enhanceFollowUpData(followUp, nextLetterTypesMap);
              });
            }
            
            self.followUpsLoaded = true;
          } catch (error) {
            console.error('Error loading follow-ups:', error);
            self.followUps = [];
            self.followUpsLoaded = true;
          }
        };

        self.enhanceFollowUpData = function (followUp, nextLetterTypesMap = {}) {
          if (!followUp.ExamDescription) {
            followUp.ExamDescription = followUp.StudyDescription || followUp.Modality || '';
          }
          
          if (followUp.FindingsCount === undefined) {
            followUp.FindingsCount = followUp.NumberOfFindings || 0;
          }
          
          if (followUp.IsDue === undefined) {
            const today = new Date();
            const recallDate = new Date(followUp.RecallDate);
            followUp.IsDue = recallDate <= today && (!followUp.FUReason || followUp.FUReason.trim() === '');
          }
          
          if (!followUp.LettersSent) {
            followUp.LettersSent = self.getLettersDescription(followUp.RecLet || 0);
          }
          
          if (!followUp.NextLetterDate && followUp.NextLetterDateString) {
            followUp.NextLetterDate = new Date(followUp.NextLetterDateString);
          }
          
          if (followUp.SDate && nextLetterTypesMap) {
            const sDateKey = new Date(followUp.SDate).toISOString();
            if (nextLetterTypesMap[sDateKey]) {
              followUp.NextLetterType = nextLetterTypesMap[sDateKey];
            }
          }

          if (followUp.Recommendation) {
            followUp.RecommendationDescription = self.getRecommendationDescription(followUp.Recommendation);
          }
        };

        self.getRecommendationDescription = function (recommendationCode) {
          if (!recommendationCode || !self.recommendations || self.recommendations.length === 0) {
            return recommendationCode;
          }

          const formattedCode = recommendationCode.trim();
          const recommendation = FollowUpHelpers.findRecommendationByCode(self.recommendations, formattedCode);

          return recommendation && recommendation.Description || formattedCode;
        };

        // Follow-up tab Type column / column-visibility config (see Portal Techpad General tab).
        self.isShowBiradsAssessmentOnFollowUp = function () {
          return !!($rootScope.techpadSettings && $rootScope.techpadSettings.IsShowBiradsAssessmentOnFollowUpTab === true);
        };

        self.getFollowUpTypeDisplay = function (followUp) {
          if (self.isShowBiradsAssessmentOnFollowUp()) {
            return followUp.AssessmentDescription || followUp.Assessment;
          }
          return followUp.RecommendationDescription || followUp.Recommendation;
        };

        self.isFollowUpColumnVisible = function (columnKey) {
          const settings = $rootScope.techpadSettings;
          if (!settings) {
            return true;
          }
          switch (columnKey) {
            case 'findings':
              return settings.IsShowFollowUpFindingsColumn !== false;
            case 'due':
              return settings.IsShowFollowUpDueColumn !== false;
            case 'lettersent':
              return settings.IsShowFollowUpLetterSentColumn !== false;
            case 'nextletter':
              return settings.IsShowFollowUpNextLetterColumn !== false;
            default:
              return true;
          }
        };

        self.getLettersDescription = function (recLet) {
          const letterCode = parseInt(recLet) || 0;
          switch (letterCode) {
            case commonConstants.DEFAULT_FU_LETTERS_NONE_CODE:
              return commonConstants.DEFAULT_FU_LETTERS_NONE_DESCRIPTION;
            case commonConstants.DEFAULT_FU_LETTERS_FIRST_CODE:
              return commonConstants.DEFAULT_FU_LETTERS_FIRST_DESCRIPTION;
            case commonConstants.DEFAULT_FU_LETTERS_SECOND_CODE:
              return commonConstants.DEFAULT_FU_LETTERS_SECOND_DESCRIPTION;
            case commonConstants.DEFAULT_FU_LETTERS_THIRD_CODE:
              return commonConstants.DEFAULT_FU_LETTERS_THIRD_DESCRIPTION;
            default:
              if (letterCode > 3) {
                return `${letterCode}${self.getOrdinalSuffix(letterCode)}`;
              }
              return commonConstants.DEFAULT_FU_LETTERS_NONE_DESCRIPTION;
          }
        };

        self.getOrdinalSuffix = function (number) {
          const lastDigit = number % 10;
          const lastTwoDigits = number % 100;
          
          if (lastTwoDigits >= 11 && lastTwoDigits <= 13) {
            return 'th';
          }
          
          switch (lastDigit) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        };

        self.addFollowUp = function () {
          return self.editFollowUp(null);
        };

        self.editFollowUp = async function (followUp) {
          return followUpOperations.editFollowUp(
            self.patient,
            followUp,
            self.isViewOnly,
            self.checkIfNotOffline,
            self.loadFollowUps
          );
        };

        self.detailFollowUp = function (followUp) {
          if (self.isViewOnly) {
            self.editFollowUp(followUp);
          }
        };

        self.resolveFollowUp = async (followUp) => {
          return followUpOperations.resolveFollowUp(
            self.patient,
            followUp,
            self.tab,
            self.tabs.FollowUps,
            self.checkIfStillOwningAndNotOffline,
            self.loadFollowUps
          );
        };

        self.reopenFollowUp = function (followUp) {
          return followUpOperations.reopenFollowUp(
            self.patient.Ssn,
            followUp,
            self.checkIfNotOffline,
            self.loadFollowUps
          );
        };

        self.deleteFollowUp = function (followUp) {
          return followUpOperations.deleteFollowUp(
            followUp,
            self.checkIfNotOffline,
            self.loadFollowUps
          );
        };

        //#endregion

        self.refreshData = function () {
          if (!self.patient.Study) {
            modalService.showAlert('This study record not found in database');
            self.goToReturnUrl();
            return;
          }

          if (self.patient.Study.IsLinked) {
            self.isLinked = true;
          }

          self.patient.Study.Problems.forEach(problem => {
            let item = self.findByCode(problem.Code, self.problems);
            if (!item) {
              return;
            }
            item.IsRight = problem.IsRight;
            item.IsLeft = problem.IsLeft;
            item.IsBoth = problem.IsBoth;
            item.IsUnspecified = problem.IsUnspecified;
            item.Location = problem.Location;
          });
          self.problemsCopy = angular.copy(self.problems);
          self.selectedProblems = self.getSelectedProblems(self.problems);

          self.updateProceduresBasedValidationRules();
        };

        self.tab = 0;
        self.flags = {};
        self.newProblem = null;

        self.onDocumentsCreated = async function (worklist) {
          if ('' + worklist.Id !== id) {
            return;
          }

          const res = await self.loadDocumentsData();
          self.documents = [];
          self.documentsCopy = angular.copy(res.data);
          self.filteredDocuments = self.getFilteredDocuments();
          self.remainingFilteredDocuments = _.cloneDeep(self.filteredDocuments);
          self.documentPageIndex = 0;
          self.loadMoreDocuments();
        };

        let documentsCreateRegistration = documentsSvc.registerOnDocumentsCreate(self.onDocumentsCreated);

        self.editComment = function (commentSetting, cancel) {
          if (self.isViewOnly || self.shouldDisableControls()){
            return;
          }

          const model = new CannedNotesModel({
            title: "Enter Text",
            comment: self.patient.Study.Comments[commentSetting.Field],
            noteItems: techpadConfig.settings.CannedNotes.filter(x => x.CommentId === commentSetting.Id),
          });

          modalService
            .showPopupFromUrl('views/templates/commentsDialog.html', model, `Enter ${commentSetting.Title}`)
            .then(comment => {
              if (comment === null) {
                return;
              }

              if (!self.patient.Study.Comments[commentSetting.Field] && !comment) {
                return;
              }

              if ((self.patient.Study.Comments[commentSetting.Field] || "").trim() === (comment || "").trim()) {
                return;
              }

              self.patient.Study[commentSetting.Field] = comment;
              self.patient.Study.Comments[commentSetting.Field] = comment;
            });
        };

        self.editTyrerCuzickFamilyTree = function () {
          self.viewMode = false;
          vm.isTyrerCuzickFullScreen = true;
        }

        self.changeTab = async function (tab) {
          tab = parseInt(tab);

          if (tab === self.tab && tab !== self.tabs.TyrerCuzick) {
            return;
          }

          self.canLoadSurveyTheme = false;
          self.canLoadTyrerCuzickContent = false;

          if (tab === self.tabs.TyrerCuzick) {
            var setSurveyConfigFn = window['setSurveyConfig'];

            setSurveyConfigFn({
              serverUrl: self.currenntMagViewUrl
            });

            $ionicLoading.show({
              template: 'Loading Family Tree...'
            });

            if (self.isViewOnly === true) {
              self.viewMode = true;
            }

            self.getSurveyIdentity(self.patient.Ssn, self.patient.SDate, self.patient.Id, self.patient.SurveyLogId, function cb() {
              self.tab = tab;
              self.canLoadSurveyTheme = true;
              setTimeout(function () {
                $rootScope.$apply();
                self.checkViewOnly();

                if (self.saved) {
                  self.saved = false;
                }
                $ionicLoading.hide();
                self.canLoadTyrerCuzickContent = true;
              }, 500);
            });

          } else {
            if (tab === self.tabs.Documents && (techpadConfig.settings.IsLoadDocumentsOnEachTabClick || !self.documentsLoaded)) {
              $ionicLoading.show({
                template: 'Loading documents...'
              });
              await self.getPatientDocuments();
              $ionicLoading.hide();
            }

            if (self.tab === self.tabs.SurveyHistory && self.isSurveyStarted) {
              let confirmed = await modalService.showConfirmation(null, 'You didn\'t complete the survey. Are you sure you want to change the tab?');
              if (!confirmed) {
                return;
              } else {
                self.isSurveyStarted = false;
              }
            }

            if (!tab) {
              tab = self.tabs.Exam;
            }

            if (tab === self.tabs.FollowUps) {
              self.isFollowUpTabVisited = true;
            }

            if (!self.isTabAvailable(tab)) {
              return;
            }

            if (tab === self.tabs.Documents && !self.documentsLoaded) {
              self.getPatientDocuments();
            }

            if (tab === self.tabs.Diagram) {
              if (this.patient.IsSDiagramNotCarriedForward) {
                modalService.showAlert('SDiagram carry forward image is missing.');
              }
            }

            self.tab = tab;
            $rootScope.safeApply();

            self.checkViewOnly();

            if (self.saved) {
              self.saved = false;
            }
          }
        };

        self.storeRiskEnabled = function (storeRisk) {
          if (!self.patient.StoreRisks || !self.patient.StoreRisks.length)
            return false;
          let enabled = self.patient.StoreRisks.indexOf(storeRisk) > -1;
          return enabled;
        };

        self.shouldDisableRecalculateRisks = function () {
          return !self.isOnline() || self.isViewOnly;
        };

        self.shouldDisableMyriadButton = function (property) {
          if (!property || !property.Options) {
            return false;
          }

          if(!property.Response || property.Response === '' || property.Response === riskPropertyConstants.noneAnswerValue) {
            return true;
          }
          return false;
        }

        self.areGenesAnswersIncomplete = function() {
          let incomplete = false;
          if (self.nccnGuidelineCopy && self.nccnGuidelineCopy.Elements) {
            const nccnGeneticCounselingElement = self.nccnGuidelineCopy.Elements.find(e => e.Id == riskPropertyConstants.geneticCounselingElementId);
            if (nccnGeneticCounselingElement) {
              const testResultProperty = nccnGeneticCounselingElement.Properties.find(p => p.Id == riskPropertyConstants.gcTestResultsPropertyId);
              if (testResultProperty && testResultProperty.Options) {
                incomplete = testResultProperty.Options.some(option => !option.Response && option.Id !== riskPropertyConstants.testResultAllId) 
                             && testResultProperty.Options.some(option => !!option.Response);
              }
            }
          }

          return incomplete;
        }

        self.recalculateRisks = async function () {
          let isCanceledOrErrored = false;
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();

          if (isNotOffline) {
            isCanceledOrErrored = await self.checkChangesAndSaveIfConfirmedOrRevert(commonConstants.ON_RISK_UPDATE_CHANGES_FOUND_CONFIRMATION_MESSAGE,
              commonConstants.ON_RISK_UPDATE_CONFIRMATION_BUTTON_TEXT);
          } else {
            isCanceledOrErrored = !isNotOffline;
          }
          $ionicLoading.hide();

          if (!isCanceledOrErrored) {
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_CALC_RISK_LOADING_MESSAGE
              });
              if(!self.patient.IsRiskOptIn){
                const resp = await Worklist.recalculateRisks(self.patient.Id)
                $ionicLoading.hide();
                self.patient.StoreRiskResults = resp.data.StoreRiskResults;
                self.patient.StoreRiskCustomResults = resp.data.StoreRiskCustomResults;
              }
            } catch (errorResponse) {
              isCanceledOrErrored = true;
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_CALC_RISK_ERROR_MESSAGE);
              $ionicLoading.hide();
            }
          }

          if (!isCanceledOrErrored) {
            await self.refresh();
            self.changeTab( self.patient.IsRiskOptIn ? self.tabs.Exam : self.tabs.RiskAssessments);
          }
        }

        self.checkViewOnly = function () {
          self.isViewOnly = self.isOnline() ? self.isInitialViewOnly : true;
        };

        self.shouldDisableControls = function () {
          let shouldDisable = !self.patient || !self.patient.Status || !self.isOnline();

          return shouldDisable;
        };

        self.isSeparator = function (item) {
          return !!(item && item.Value.indexOf("----") !== -1);
        };

        self.isChanged = function () {
          for (let property in self.leftHistoryDataCopy) {
            if (self.leftHistoryDataCopy[property] === '/  /') {
              self.leftHistoryDataCopy[property] = '//'
            }
            if (self.leftHistoryData[property] == undefined) {
              self.leftHistoryData[property] = '';
            }
            let propertyConfig = null;
            self.historyConfig.leftHistoryConfig.forEach(column => column.forEach(config => {
              if (config.Id == property) propertyConfig = config;
            }));
            if (propertyConfig && (propertyConfig.Type === "AGE" || propertyConfig.Type === "NUM") &&
              (self.leftHistoryDataCopy[property] === 0 || self.leftHistoryDataCopy[property] === '')) {
              self.leftHistoryDataCopy[property] = null;
            }
            if (propertyConfig && (propertyConfig.Type === "AGE" || propertyConfig.Type === "NUM") &&
              (self.leftHistoryData[property] === 0 || self.leftHistoryData[property] === '')) {
              self.leftHistoryData[property] = null;
            }
            if (propertyConfig && propertyConfig.Type === "POP" && self.leftHistoryDataCopy[property] === '') {
              self.leftHistoryDataCopy[property] = null;
            }
            if (propertyConfig && propertyConfig.Type === "POP" && self.leftHistoryData[property] === '') {
              self.leftHistoryData[property] = null;
            }
          }

          for (let property in self.examUfieldsDataCopy) {
            if (self.examUfieldsDataCopy[property] === '/  /') {
              self.examUfieldsDataCopy[property] = '//'
            }
            if (self.examUfieldsData[property] == undefined) {
              self.examUfieldsData[property] = '';
            }
          }

          let isChanged = false;
          if (!self.patient || !self.patient.Study) {
            return false;
          }

          function cleanObject(obj) {
            if (!obj || typeof obj !== 'object') return obj;
            
            if (Array.isArray(obj)) {
              return obj.map(cleanObject);
            }
            
            const cleaned = {};
            for (const key in obj) {
              if (key.startsWith('$$') || key === 'IsSelected') {
                continue;
              }
              cleaned[key] = cleanObject(obj[key]);
            }
            return cleaned;
          }

          if (!angular.equals(cleanObject(self.patient.Study), cleanObject(self.patientCopy.Study)) ||
              !angular.equals(cleanObject(self.problems), cleanObject(self.problemsCopy)) ||
              !angular.equals(cleanObject(self.leftHistoryDataCopy), cleanObject(self.leftHistoryData)) ||
              !angular.equals(cleanObject(self.rightHistoryDataCopy), cleanObject(self.rightHistoryData)) ||
              !angular.equals(cleanObject(self.examUfieldsDataCopy), cleanObject(self.examUfieldsData)) ||
              !angular.equals(cleanObject(self.implantDataCopy), cleanObject(self.implantData)) ||
              !angular.equals(cleanObject(self.nccnGuidelineCopy), cleanObject(self.nccnGuideline)) ||
              !angular.equals(self.patient.IsRiskOptOut, self.patientCopy.IsRiskOptOut) ||
              !angular.equals(cleanObject(self.selectedFilmsComparedDataCopy), cleanObject(self.selectedFilmsComparedData)) ||
              self.isDiagramChanged()) {
            isChanged = true;
          }

          return isChanged;
        };

        self.isDiagramChanged = function () {
          let includeIndexProperty;
          if (self.problemsList && self.problemsListCopy && self.problemsList.length && self.problemsListCopy.length) {
            includeIndexProperty = self.problemsList[0].index && self.problemsListCopy[0].index;
          }
          let problemsListMapped = self.mapProblemsForComparison(self.problemsList, includeIndexProperty);
          let problemsListCopyMapped = self.mapProblemsForComparison(self.problemsListCopy, includeIndexProperty);
          return !angular.equals(problemsListMapped, problemsListCopyMapped);
        };

        self.mapProblemsForComparison = function (problemsList, includeIndexProperty) {
          return problemsList.map(function (el) {
            let mappedObject = {
              Comments: el.Comments,
              Settings: {
                height: el.Settings.height,
                scale: el.Settings.scale,
                path: el.Settings.path,
                width: el.Settings.width,
                x: el.Settings.x,
                y: el.Settings.y
              },
              Type: el.Type
            };
            if (includeIndexProperty)
              mappedObject["index"] = el.index;
            return mappedObject;
          });
        };

        self.updateProblemUnspecified = function (p) {
          if (p.IsUnspecified) {
            p.IsLeft = false;
            p.IsRight = false;
            p.IsBoth = false;
          }
          self.validateProblems();
        };

        self.updateProblemSide = function (p) {
          if (p.IsLeft || p.IsRight || p.IsBoth) {
            p.IsUnspecified = false;
          }
          self.validateProblems();
        };

        self.onMarkedSurveyAsReviewed = function () {

          self.patient.SurveyReviewed = true;
          self.patientCopy.SurveyReviewed = true;

          if (techpadConfig.settings.HideStartAndEndButtons) {
            self.patient.Status = enums.worklistStatuses.ExamInProgress;

            Worklist.updateStatus(self.patient.Id, enums.worklistStatuses.ExamInProgress).then(() => {
              self.changeTab(self.techpadConfig.settings.DefaultWorklistTab);
              self.refreshPatientAndTime();
            });
          } else {
            // if exam is in progress
            if (self.patient.Status === enums.worklistStatuses.ExamInProgress) {
              self.changeTab(self.techpadConfig.settings.DefaultWorklistTab);
              return;
            }

            self.patient.Status = enums.worklistStatuses.ExamWaiting;
            Worklist.updateStatus(self.patient.Id, enums.worklistStatuses.ExamWaiting).then(() => {
              self.changeTab(self.techpadConfig.settings.DefaultWorklistTab);
            });

          }
        };


        self.refreshComments = function () {
          Worklist.getPatientComments(self.worklistId).then(function (resp) {
            const commentsFromDB = resp.data;
            let commentsChangedInDB = false;
            let message = '<strong>Comments were recently changed. Do you want to keep your current comments or reload the changes?</strong>';

            self.techpadConfig.settings.CommentsSettings.forEach((setting) => {
              if (self.patient.Study.Comments[setting.Field] !== commentsFromDB[setting.Field] && setting.IsReadonly) {
                self.patient.Study.Comments[setting.Field] = commentsFromDB[setting.Field];
                self.initialComments[setting.Field] = commentsFromDB[setting.Field];
              }
              if (self.initialComments[setting.Field] !== commentsFromDB[setting.Field] &&
                self.patient.Study.Comments[setting.Field] !== commentsFromDB[setting.Field]) {
                commentsChangedInDB = true;
                if (self.patient.Study.Comments[setting.Field] === null) {
                  self.patient.Study.Comments[setting.Field] = "";
                }
                message += `<br /><br /> Recent ${setting.Title}: "${commentsFromDB[setting.Field]}", your ${setting.Title}: "${self.patient.Study.Comments[setting.Field]}".`;
              }
            });

            if (commentsChangedInDB) {
              modalService.showAdvancedConfirmation(
                constantStrings.CommentsRefreshConfirmation,
                message, [{
                  text: constantStrings.NoDiscardCommentsMessage,
                  onTap: function (e) {
                    self.patient.Study.Comments = commentsFromDB;
                  }
                }, {
                  text: constantStrings.YesDiscardCommentsMessage,
                  type: constantStrings.AssertiveButton,
                  onTap: function (e) { }
                }]);
            }
          });
        };

        self.hasIncompleteRequiredRiskFields = function () {
          if (!self.nccnGuideline || !self.nccnGuideline.Elements) {
            return false;
          }
          
          let hasIncomplete = false;
          self.nccnGuideline.Elements.forEach(element => {
            if (element.Properties) {
              element.Properties.forEach(property => {
                var isRequired = property.Required === true || (property.Required && property.Required.toLowerCase && property.Required.toLowerCase() === (true).toString());
                var isEmpty = !property.Response || property.Response === '' || property.Response === riskPropertyConstants.noneAnswerValue;
                if (isRequired && isEmpty) {
                  hasIncomplete = true;
                }
              });
            }
          });
          
          return hasIncomplete;
        };

        self.showRiskValidationAfterSave = function () {
          if (self.hasIncompleteRequiredRiskFields()) {
            if (self.nccnGuideline && self.nccnGuideline.Elements) {
              self.nccnGuideline.Elements.forEach(element => {
                if (element.Properties) {
                  element.Properties.forEach(property => {
                    var isRequired = property.Required === true || (property.Required && property.Required.toLowerCase && property.Required.toLowerCase() === (true).toString());
                    var isEmpty = !property.Response || property.Response === '' || property.Response === riskPropertyConstants.noneAnswerValue;
                    self.notValidRiskProperties[property.Id] = isRequired && isEmpty;
                  });
                }
              });
            }
            
            self.showValidationErrors = true;
          }
        };

        self.triggerMyriadReferralAfterAction = async function () {
          return await self.handleMyriadReferral();
        };

        self.handleMyriadReferral = async function () {
          if (shouldSkipMyriadReferral()) {
            return { redirected: false, userInteracted: false };
          }

          if (!isPatientQualifiedForReferral()){
            return { redirected: false, userInteracted: false };
          }
        
          const currentGcElement = getGeneticCounselingElement();
          if (!currentGcElement) return { redirected: false, userInteracted: false };

          const patientAgreementProperty = findPatientAgreementProperty(currentGcElement);
          if (!patientAgreementProperty) return { redirected: false, userInteracted: false };

          const originalGcElement = self.nccnGuidelineCopy && self.nccnGuidelineCopy.Elements && 
            self.nccnGuidelineCopy.Elements.find(element => 
              element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalPatientAgreementProperty = originalGcElement && originalGcElement.Properties && 
            originalGcElement.Properties.find(property => 
              property.Id === riskPropertyConstants.gcPatientAgreementPropertyId);

          if (!$rootScope.techpadSettings.ShowMyriadButton && patientAgreementProperty && originalPatientAgreementProperty && self.isPatientAgreementChanged &&
              patientAgreementProperty.Response !== '' && patientAgreementProperty.Response !== riskPropertyConstants.noneAnswerValue) {
            const isSendToMyriad = patientAgreementProperty.Options.find(opt => opt.Value == patientAgreementProperty.Response).SendToMyriad;
            if(isSendToMyriad){
              await self.sendToMyriad();
              self.isPatientAgreementChanged = false;
              return { redirected: false, userInteracted: true };
            }
          }

          if ($rootScope.techpadSettings.IsShowMyriadReferralModalOnSubsequentExamSaves) {
            if (hasSendToMyriadResponse(patientAgreementProperty)) {
              return { redirected: false, userInteracted: false };
            }

            if (hasCompletedMyriadResponse(patientAgreementProperty)) {
              const dateRespondedProperty = currentGcElement.Properties.find(
                prop => prop.Id === riskPropertyConstants.gcDateRespondedPropertyId
              );
              const dateOfferedProperty = currentGcElement.Properties.find(
                prop => prop.Id === riskPropertyConstants.gcDateOfferedPropertyId
              );

              const respondedDate = dateRespondedProperty && dateRespondedProperty.Response
                ? new Date(dateRespondedProperty.Response)
                : null;
              const offeredDate = dateOfferedProperty && dateOfferedProperty.Response
                ? new Date(dateOfferedProperty.Response)
                : null;
              const today = new Date();
              today.setHours(0, 0, 0, 0);

              if (respondedDate) respondedDate.setHours(0, 0, 0, 0);
              if (offeredDate) offeredDate.setHours(0, 0, 0, 0);

              if ((respondedDate && respondedDate >= today) || (offeredDate && offeredDate >= today)) {
                return { redirected: false, userInteracted: false };
              }
            }
          } else {
            if (hasCompletedMyriadResponse(patientAgreementProperty)) {
              return { redirected: false, userInteracted: false };
            }
          }

          const response = await promptForMyriadDecision(patientAgreementProperty);

          if (response && response.skipped) {
            return { redirected: false, userInteracted: true };
          }

          if (response &&
              (response.response === commonConstants.MYRIAD_MODAL_CONFIRM ||
              response.selectedOption === commonConstants.MYRIAD_MODAL_REVIEW_OPTION)
            ) {
            return { redirected: true, userInteracted: true };
          }

          return { redirected: false, userInteracted: false };
        };

        self.isMyriadSentError = false;
        self.isMyriadSentSuccessfully = false;

        self.updateMyriadStatusProperties = function() {
          self.isMyriadSentError = self.patient.GeneticCounselingDataStatus === commonConstants.NETWORK_ERROR_DURING_SEND_TO_MYRIAD;
          self.isMyriadSentSuccessfully = self.patient.GeneticCounselingDataStatus === commonConstants.SUCCESSFULLY_SENT_TO_MYRIAD;
        };

        function shouldSkipMyriadReferral() {
          const shouldSkip = !self.nccnGuideline ||
                 !!self.lastSentDateToMyriad ||
                 !$rootScope.techpadSettings.Myriad ||
                 (self.patient.IsRiskOptOut &&
                  (!isPatientQualifiedForReferral() ||
                   !$rootScope.techpadSettings.ShowMyriad));

          return shouldSkip;
        }

        function getGeneticCounselingElement() {
          return self.nccnGuideline.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);
        }

        function findPatientAgreementProperty(gcElement) {
          return gcElement.Properties.find(property => 
            property && property.Id === self.riskPropertyConstants.gcPatientAgreementPropertyId);
        }

        function isPatientQualifiedForReferral() {
          const nccnElement = getGeneticCounselingElement();
          return self.isPatientQualified(nccnElement);
        }

        function hasCompletedMyriadResponse(patientAgreementProperty) {
          if (!patientAgreementProperty.Response || patientAgreementProperty.Response.trim() === '') {
            return false;
          }

          const validOption = patientAgreementProperty.Options &&
            patientAgreementProperty.Options.find(opt => opt.Value === patientAgreementProperty.Response);

          return !!validOption;
        }

        function hasSendToMyriadResponse(patientAgreementProperty) {
          if (!patientAgreementProperty.Response || patientAgreementProperty.Response.trim() === '') {
            return false;
          }

          const selectedOption = patientAgreementProperty.Options &&
            patientAgreementProperty.Options.find(opt => opt.Value === patientAgreementProperty.Response);

          return !!(selectedOption && selectedOption.SendToMyriad);
        }

        function shouldHideGeneticCounselingControls() {
          const gcElement = getGeneticCounselingElement();
          if (!gcElement) return false;

          const patientAgreementProperty = findPatientAgreementProperty(gcElement);
          if (!patientAgreementProperty) return false;

          const isResponseOneOrThree = patientAgreementProperty.Response === '1' || patientAgreementProperty.Response === '3';
          const isMyriadSent = !!self.lastSentDateToMyriad;
          const isDataStatusTwo = gcElement.DataStatus === 2;

          return isResponseOneOrThree && (isMyriadSent || isDataStatusTwo);
        }

        async function promptForMyriadDecision(patientAgreementProperty) {
          const oldAnswer = patientAgreementProperty.Response;
          let previousSelection = null;

          if (oldAnswer) {
            const matchingOption = patientAgreementProperty.Options.find(opt => opt.Value === oldAnswer);
            if (matchingOption) {
              previousSelection = matchingOption.Value;
            }
          }

          const response = await modalService.showMyriadReferral({
            text: commonConstants.PATIENT_GENETIC_TESTING,
            title: commonConstants.MYRIAD_REFERRAL,
            description: commonConstants.MYRIAD_MODAL_DESCRIPTION,
            options: patientAgreementProperty.Options || [],
            previousSelection: previousSelection
          });
          
          if (response.response === commonConstants.MYRIAD_MODAL_SKIP) {
            if (response.shouldCloseWorklist) {
              await Worklist.skippedSendToMyriad(self.patient.Ssn, self.patient.SDate);
              self.goToReturnUrl();
            }
            return response;
          }

          if (response.selectedOption === commonConstants.MYRIAD_MODAL_REVIEW_OPTION) {
            self.changeTab(self.tabs.RiskAssessments);
            return response;
          }
          
          let responseId = null;
          if (response.response === commonConstants.MYRIAD_MODAL_CONFIRM) {
            if (response.selectedOption && patientAgreementProperty.Options) {
              patientAgreementProperty.Options.forEach(option => {
                option.IsSelected = option.Value === response.selectedOption;
                if(option.IsSelected) {
                  responseId = option.Id;
                }
              });
            }

            const isSendToMyriad = patientAgreementProperty.Options
              .find(option => option.Id === responseId).SendToMyriad;

            patientAgreementProperty.Response = (!response.selectedOption || response.selectedOption === riskPropertyConstants.noneAnswerValue) ? '' : response.selectedOption;

            if(isSendToMyriad){
              const referralResult = await handleReferToMyriad(patientAgreementProperty, response.selectedOption);
              if (!referralResult) {
                response.skipped = true;
              }
            }
            else{
              await self.saveWorklistChangesAsync();
            }
          }

          return response;
        }

        async function handleReferToMyriad(){

          await self.saveWorklistChangesAsync();
          const isOfferedDateChanged = true;

          let result = null;
          if($rootScope.techpadSettings && !$rootScope.techpadSettings.ShowMyriadButton){
            result = await self.sendToMyriad(isOfferedDateChanged);
          }
          
          return result && !result.skipped;
        }

        self.saveChanges = async function (cb, isSkipRefresh, cbAfterReload, context, isNotHideLoader = false) {
          // Any validation failure here must drop the loader and release a caller awaiting
          // completion (see checkChange), otherwise the save overlay wedges on end-exam.
          const notifyNotSaved = function () {
            $ionicLoading.hide();
            if (context && context.onSaveNotCompleted) {
              context.onSaveNotCompleted();
            }
          };

          if (
            self.newCEMTechniqueData &&
            self.newCEMTechniqueData.CemTechStu &&
            $rootScope.techpadSettings.IsCEMTechniqueEnabled &&
            self.isCemTechniqueRequired &&
            (!self.newCEMTechniqueData.CEMTechniqueCEMTechData ||
              !self.newCEMTechniqueData.CEMTechniqueCEMTechData.Technique)
          ) {
            notifyNotSaved();
            modalService.showAlert("CEM Technique is required.");
            return;
          }

          self.saving = true;
          $ionicLoading.show({
            template: 'Saving History...'
          });

          if (
            self.leftHistoryData[commonConstants.MENARCHE_AGE_FIELD_ID] &&
            self.leftHistoryData[commonConstants.MENARCHE_AGE_FIELD_ID] > 0 &&
            self.leftHistoryData[commonConstants.FIRST_PREGNANT_FIELD_ID] &&
            self.leftHistoryData[commonConstants.FIRST_PREGNANT_FIELD_ID] > 0
          ) {
            const menarcheFirstPregnantNotValid =
              self.leftHistoryData[commonConstants.MENARCHE_AGE_FIELD_ID] >
              self.leftHistoryData[commonConstants.FIRST_PREGNANT_FIELD_ID];
            if (menarcheFirstPregnantNotValid) {
              const validationResult = {
                isValid: false,
                message:
                  constantStrings.AgeOfFirstPregnancyCanNotBeGreaterThanAgeAtMenarche,
                goToTab: self.tabs.Demographic,
              };
              self.handleNotValidExamEnd(validationResult);
              self.notValidLeftHistory[commonConstants.MENARCHE_AGE_FIELD_ID] = true;
              self.notValidLeftHistory[commonConstants.FIRST_PREGNANT_FIELD_ID] = true;
              self.showValidationErrors = true;
              notifyNotSaved();
              return;
            } else {
              self.notValidLeftHistory[commonConstants.MENARCHE_AGE_FIELD_ID] = false;
              self.notValidLeftHistory[commonConstants.FIRST_PREGNANT_FIELD_ID] = false;
            }
          }

          if (techpadConfig.settings.IsValidateReqiuredFieldsOnEverySave) {
            let validationResult = self.validateExamEnd();

            if (!validationResult.isValid) {
              self.handleNotValidExamEnd(validationResult);
              notifyNotSaved();
              return;
            }
          }

          if (self.viewDuplicates && self.viewDuplicates.length) {
            notifyNotSaved();
            self.saving = false;
            await self.showViewsDuplicatesDetectedAlert();
            await self.changeTab(self.tabs.Exam);
            return;
          }

          try {
            const resp = await Worklist.getPatientComments(self.worklistId);
            let commentsFromDB = resp.data;
            let commentsChangedInDB = false;
            let message =
              '<strong>Comments were recently changed. Do you want to overwrite with your comments?</strong>';

            self.techpadConfig.settings.CommentsSettings.forEach((setting) => {
              if (
                self.patient.Study.Comments[setting.Field] !==
                  commentsFromDB[setting.Field] &&
                setting.IsReadonly
              ) {
                self.patient.Study.Comments[setting.Field] =
                  commentsFromDB[setting.Field];
                self.initialComments[setting.Field] = commentsFromDB[setting.Field];
              }
              if (
                self.initialComments[setting.Field] !== commentsFromDB[setting.Field] &&
                self.patient.Study.Comments[setting.Field] !==
                  commentsFromDB[setting.Field]
              ) {
                commentsChangedInDB = true;
                message += `<br /><br /> Recent ${setting.Title}: "${commentsFromDB[setting.Field]}".`;
              }
            });

            if (commentsChangedInDB) {
              if(!isNotHideLoader) {
                $ionicLoading.hide();
              }
              modalService.showAdvancedConfirmation('Comments Changed Confirmation', message, [
                {
                  text: 'No, discard my comments',
                  onTap: async (e) => {
                    $ionicLoading.show({
                      template: 'Saving History...',
                    });
                    self.patient.Study.Comments = commentsFromDB;
                    self.initialComments = angular.copy(commentsFromDB);
                    await self.executeSaveChanges(cb, isSkipRefresh, cbAfterReload, context, isNotHideLoader);
                  },
                },
                {
                  text: 'Yes, overwrite recently updated comments',
                  type: 'button-assertive',
                  onTap: async (e) => {
                    $ionicLoading.show({
                      template: 'Saving History...',
                    });
                    await self.executeSaveChanges(cb, isSkipRefresh, cbAfterReload, context, isNotHideLoader);
                  },
                },
              ]);
            } else {
              await self.executeSaveChanges(cb, isSkipRefresh, cbAfterReload, context, isNotHideLoader);
            }
          } catch (error) {
            notifyNotSaved();
            console.error(error);
            modalService.showErrorMessage(error.data, error.status);
          }
        };

        self.getDiagramBase64String = async function () {
          if (!self.diagramEditor) {
            return null;
          }
          const diagramImage = await self.diagramEditor.getDiagramImage();
          return diagramImage;
        };

        self.getDiagramSvgString = async function () {
          if (!self.diagramEditor) {
            return null;
          }
          if (!self.diagramEditor.getDiagramImageSvgString) {
            return null;
          }
          const svgString = await self.diagramEditor.getDiagramImageSvgString();
          return svgString;
        };

        self.getFilteredProblemsForFutureDiagram = function () {
          return self.problemsList.filter(problem => {
            const diagramSettings = self.techpadConfig.settings.DiagramSettings || [];
            const problemConfig = diagramSettings.find(setting => setting.Type === problem.Type);

            if (problemConfig) {
              return !problemConfig.DisabledCarryForward;
            }
            return true;
          });
        };

        self.stringifyProblemsSettings = function () {
          let isOldMode;
          if (self.diagramEditor != null) {
            isOldMode = self.diagramEditor.oldMode === true || typeof (self.diagramEditor.oldMode) === 'undefined';
          } else {
            isOldMode = !self.techpadConfig.settings.NewDiagramFeatureEnabled;
          }
          let problems = self.problemsList.map((item) => {
            const diagramSettings = self.techpadConfig.settings.DiagramSettings || [];
            const problemSetting = diagramSettings.find(setting => setting.Type === item.Type);
            
            const problem = {
              Settings: JSON.stringify(Object.assign({}, item.Settings, {newMode: !isOldMode})),
              Type: item.Type,
              index: item.index
            };
            
            if (item.CustomType !== undefined && item.CustomType !== null) {
              problem.CustomType = item.CustomType;
              if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType) {
                problem.Type = problemSetting.BaseType;
              }
            } else if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType) {
              problem.CustomType = item.Type;
              problem.Type = problemSetting.BaseType;
            }
            
            if (item.Id !== undefined && item.Id !== null) {
              problem.Id = item.Id;
            }
            if (item.Color !== undefined) {
              problem.Color = item.Color;
            }
            if (item.Comments !== undefined) {
              problem.Comments = item.Comments;
            }
            if (item.strokeWidth !== undefined) {
              problem.strokeWidth = item.strokeWidth;
            }
            return problem;
          });
          self.patient.Problems = problems;
        };

        self.areProblemsValid = function () {
          let enabledProblems = self.problems.filter((item) => item.IsRight || item.IsLeft || item.IsBoth || item.IsUnspecified);
          let selectedReasonVisit = self.visitReasons.find(reason => reason.Key == self.patient.Study.VisitReason);
          let areProblemsValidResult = !selectedReasonVisit || !(selectedReasonVisit.RequireProblems && enabledProblems.length <= 0)

          return areProblemsValidResult
        }

        self.detectRiskDateChanges = function() {
          const result = {
            isDateOfferedChanged: false,
            isDateRespondedChanged: false,
          };

          const currentGcElement = self.nccnGuideline && self.nccnGuideline.Elements && self.nccnGuideline.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcElement = self.nccnGuidelineCopy && self.nccnGuidelineCopy.Elements && self.nccnGuidelineCopy.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);

          if (!currentGcElement || !originalGcElement) {
            return result;
          }

          const currentDateOfferedProperty = currentGcElement.Properties && currentGcElement.Properties.find(property => 
            property.Id === riskPropertyConstants.gcDateOfferedPropertyId);
          const originalDateOfferedProperty = originalGcElement.Properties && originalGcElement.Properties.find(property => 
            property.Id === riskPropertyConstants.gcDateOfferedPropertyId);

          const currentDateRespondedProperty = currentGcElement.Properties && currentGcElement.Properties.find(property => 
            property.Id === riskPropertyConstants.gcDateRespondedPropertyId);
          const originalDateRespondedProperty = originalGcElement.Properties && originalGcElement.Properties.find(property => 
            property.Id === riskPropertyConstants.gcDateRespondedPropertyId);

          if (currentDateOfferedProperty && originalDateOfferedProperty) {
            result.isDateOfferedChanged = currentDateOfferedProperty.Response !== originalDateOfferedProperty.Response || !self.isAnsweredInModal;
          }

          if (currentDateRespondedProperty && originalDateRespondedProperty) {
            result.isDateRespondedChanged = currentDateRespondedProperty.Response !== originalDateRespondedProperty.Response;
          }

          return result;
        }

        self.formatFilmsComparedForSave = function(filmsComparedData) {
          if (!filmsComparedData) {
            return null;
          }
          
          return {
            NoPriorFilmsCompared: filmsComparedData.noPriorFilmsCompared === true,
            NoPriorFilmsAvailable: filmsComparedData.noPriorFilmsAvailable === true,
            Reviewed: filmsComparedData.reviewed === true,
            ComparedDatesNotSpecified: filmsComparedData.comparedDatesNotSpecified === true,
            ComparedToStudiesDatingBack: filmsComparedData.comparedToStudiesDatingBack === true,
            DatingBackTo: filmsComparedData.datingBackTo || '',
            ToBeObtainedFrom: filmsComparedData.toBeObtainedFrom === true,
            ObtainedFrom: filmsComparedData.obtainedFrom || '',
            ObtainedFromLocationKey: filmsComparedData.obtainedFromLocationKey || '',
            BaselineXRT: filmsComparedData.baselineXRT === true,
            BaselineStudy: filmsComparedData.baselineStudy === true,
            NoChange: filmsComparedData.noChange === true,
            IncludeCadStatement: filmsComparedData.includeCadStatement === true,
            SelectedFilms: filmsComparedData.selectedFilms || []
          };
        };

        self.convertApiFilmsComparedToInternal = function(apiFilmsCompared) {
          if (!apiFilmsCompared) {
            return null;
          }

          return {
            noPriorFilmsCompared: apiFilmsCompared.NoPriorFilmsCompared === true,
            noPriorFilmsAvailable: apiFilmsCompared.NoPriorFilmsAvailable === true,
            reviewed: apiFilmsCompared.Reviewed === true,
            comparedDatesNotSpecified: apiFilmsCompared.ComparedDatesNotSpecified === true,
            comparedToStudiesDatingBack: apiFilmsCompared.ComparedToStudiesDatingBack === true,
            datingBackTo: apiFilmsCompared.DatingBackTo || '',
            toBeObtainedFrom: apiFilmsCompared.ToBeObtainedFrom === true,
            obtainedFrom: apiFilmsCompared.ObtainedFrom || '',
            obtainedFromLocationKey: apiFilmsCompared.ObtainedFromLocationKey || '',
            baselineXRT: apiFilmsCompared.BaselineXRT === true,
            baselineStudy: apiFilmsCompared.BaselineStudy === true,
            noChange: apiFilmsCompared.NoChange === true,
            includeCadStatement: apiFilmsCompared.IncludeCadStatement === true,
            selectedFilms: apiFilmsCompared.SelectedFilms || []
          };
        };

        self.getFilmsComparedDisplayText = function(filmsComparedData) {
          if (!filmsComparedData) {
            return '';
          }

          if (filmsComparedData.toBeObtainedFrom === true) {
            return 'To be obtained';
          }

          const selectedFilms = filmsComparedData.selectedFilms || [];
          
          if (selectedFilms.length > 0) {
            const dates = selectedFilms.map(function(film) {
              return film.StudyDate ? dateFormattingHelper.formatDateForDisplay(film.StudyDate) : '';
            }).filter(function(d) { return d; });
            
            if (dates.length > 0) {
              if (filmsComparedData.reviewed === true) {
                return 'Reviewed ' + dates.join(', ');
              }
              return 'Compared ' + dates.join(', ');
            }
            if (filmsComparedData.reviewed === true) {
              return 'Reviewed';
            }
            return 'Compared';
          }
          
          if (filmsComparedData.noPriorFilmsCompared === true) {
            return 'Not compared';
          }
          
          if (filmsComparedData.noPriorFilmsAvailable === true) {
            return 'Not available';
          }
          
          if (filmsComparedData.reviewed === true) {
            return 'Reviewed';
          }
          
          if (filmsComparedData.comparedDatesNotSpecified === true) {
            return 'Compared';
          }
          
          if (filmsComparedData.comparedToStudiesDatingBack === true && filmsComparedData.datingBackTo) {
            return 'Dating back to ' + filmsComparedData.datingBackTo;
          }
          
          if (filmsComparedData.baselineXRT === true) {
            return 'Baseline XRT';
          }
          
          if (filmsComparedData.baselineStudy === true) {
            return 'Baseline study';
          }
          
          return '';
        };

        self.prepareSaveWorklistModel = async function () {
          let riskDateChanges = self.detectRiskDateChanges();

          if(self.isAnsweredInModal) {
            riskDateChanges = {
              ...riskDateChanges,
              shouldUpdateDates: true
            };
            self.isAnsweredInModal = false;
          }

          const diagramBase64String = await self.getDiagramBase64String();
          let svgDiagramImage = await self.getDiagramSvgString();

          let saveWorklistModel = {
            Id: self.patient.Id,
            FirstName: self.patient.FirstName,
            LastName: self.patient.LastName,
            Study: angular.copy(self.patient.Study),
            DemographicInitial: self.leftHistoryDataCopy,
            HistoryInitial: self.rightHistoryDataCopy,
            History: angular.copy(self.rightHistoryData),
            ExamUfieldsDataInitial: self.examUfieldsDataCopy,
            ImplantDataInitial: self.implantDataCopy,
            Base64String: diagramBase64String,
            SvgDiagramImage: svgDiagramImage,
            IsDiagramChanged: self.isDiagramChanged(),
            IsDiagramEmpty: self.problemsList && self.problemsList.length === 0,
            IsFutureDiagramEmpty: self.problemsList && self.problemsList.length === 0,
            NccnGuidelineInitial: self.nccnGuidelineCopy,
            NccnGuideline: angular.copy(self.nccnGuideline),
            IsRiskOptIn: self.patient.IsRiskOptIn,
            RiskDateChanges: riskDateChanges,
            CEMTechniqueData: self.newCEMTechniqueData ? self.newCEMTechniqueData.CEMTechniqueCEMTechData : null,
            FilmsCompared: self.selectedFilmsComparedData ? self.formatFilmsComparedForSave(self.selectedFilmsComparedData) : null,
          };

          if (self.techpadConfig.settings.IsGenerateFutureDiagrams) {
            const originalProblems = self.problemsList;
            const filteredProblems = self.getFilteredProblemsForFutureDiagram();

            $rootScope.safeApply(() => {
              self.problemsList = filteredProblems;
            });

            saveWorklistModel.SvgFutureDiagramImage = await self.diagramEditor.getDiagramImageSvgString();
            saveWorklistModel.Base64FutureDiagramString = await self.diagramEditor.getImageFromSvg(saveWorklistModel.SvgFutureDiagramImage);

            $rootScope.safeApply(() => {
              self.problemsList = originalProblems;
            });
          }

          if(!self.patient.Study.Technologist){
            Worklist.unassignFromMe(self.patient.Id);
          }
          saveWorklistModel = await Diagram.prepareSaveModelWithDiagramImage(saveWorklistModel, self.patient.Problems);

          //preparing study problems
          saveWorklistModel.Study.Problems = [];
          let enabledProblems = self.problems.filter((item) => item.IsRight || item.IsLeft || item.IsBoth || item.IsUnspecified);
          for (let index in enabledProblems) {
            saveWorklistModel.Study.Problems.push({
              Code: enabledProblems[index].Key,
              IsLeft: enabledProblems[index].IsLeft,
              IsRight: enabledProblems[index].IsRight,
              IsBoth: enabledProblems[index].IsBoth,
              IsUnspecified: enabledProblems[index].IsUnspecified,
              Location: enabledProblems[index].Location
            });
          }

          //preparing diagram problems
          self.stringifyProblemsSettings();
          saveWorklistModel.Problems = angular.copy(self.patient.Problems);

          //preparing left history data
          for (let property in self.leftHistoryData) {
            if (!self.leftHistoryData[property]) {
              self.leftHistoryData[property] = '';
            }
          }
          saveWorklistModel.Demographic = angular.copy(self.leftHistoryData);

          //preparing exam UDF data
          for (let property in self.examUfieldsData) {
            if (!self.examUfieldsData[property]) {
              self.examUfieldsData[property] = '';
            }
          }
          saveWorklistModel.ExamUfieldsData = angular.copy(self.examUfieldsData);

          //preparing implants data
          const isImplantConfig =
            self.historyConfig
            && self.historyConfig.leftHistoryConfig.some(side => side.some(config => config.Type === IMPLANTS_TYPE));
          if (isImplantConfig) {
            let newLeftImplantArray = [];
            let newRightImplantArray = [];
            self.implantData.Left.forEach((object) => {
              object = _.omit(object, [commonConstants.IMPLANTS_OMIT_ITEMS_ARRAY]);
              newLeftImplantArray.push(object);
            });
            self.implantData.Right.forEach((object) => {
              object = _.omit(object, [commonConstants.IMPLANTS_OMIT_ITEMS_ARRAY]);
              newRightImplantArray.push(object);
            });

            saveWorklistModel.ImplantData = angular.copy(self.implantData);
            saveWorklistModel.ImplantData.Left = newLeftImplantArray;
            saveWorklistModel.ImplantData.Right = newRightImplantArray;
          }

          return saveWorklistModel;
        }

        self.executeSaveChanges = async function (cb, isSkipRefresh, cbAfterReload, context, isNotHideLoader = false) {
          // Set once the save actually succeeds. Every other exit is a failure that must
          // drop the loader and release any caller awaiting completion (see checkChange),
          // otherwise the "Processing" overlay wedges and the app has to be killed.
          let reachedSave = false;
          const notifyNotSaved = function () {
            $ionicLoading.hide();
            if (context && context.onSaveNotCompleted) {
              context.onSaveNotCompleted();
            }
          };

          //Check if still owning
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();
          if (!isNotOffline) {
            notifyNotSaved();
            self.saving = false;
            return;
          }

          let saveWorklistModel = await self.prepareSaveWorklistModel();
          const pregnant = saveWorklistModel.Demographic.PREGNANT;
          const menopauseAge = saveWorklistModel.Demographic.M_AGE;

          const patientAge = self.getPatientsAge();
          const isFemalePatient = self.patient && self.patient.Sex === commonConstants.femaleGenderCode;
          const isPreMenopausalOrUnknownAge = isFemalePatient && (!menopauseAge || patientAge < menopauseAge);

          if($rootScope.techpadSettings.IsStudyRequiresPregnancy && isPreMenopausalOrUnknownAge && !pregnant){
            notifyNotSaved();

            modalService.showAlert('Pregnancy information is required to save the exam.');

            self.saving = false;
            return;
          }

          const procedures = saveWorklistModel.Study.Procedures;
          if($rootScope.techpadSettings.IsStudyRequiresProcedure && (!procedures || procedures.length === 0)){
            notifyNotSaved();

            modalService.showAlert('At least one procedure is required to save the exam.');

            self.saving = false;
            return;
          }

          const proceduresDefinitions = (procedures || [])
            .map((x) => self.procedures.find((proc) => proc.Key === x.Code))
            .filter(Boolean);

          const hasRequiredSideProcedures = proceduresDefinitions
            .filter((pd) => pd.RequireSide)
            .filter((proc) => {
              const selectedProcedure = procedures.find(
                (p) => p.Code === proc.Key,
              );

              if (
                selectedProcedure &&
                selectedProcedure.Side === commonConstants.SIDE_UNKNOWN_KEY
              ) {
                return true;
              }

              return false;
            });

          if (hasRequiredSideProcedures.length > 0) {
            notifyNotSaved();
            modalService.showAlert(
              "Side is required for procedures: " + hasRequiredSideProcedures.map((p) => p.Value).join(', ')
            );
            self.saving = false;
            return;
          }

          if ($rootScope.techpadSettings.ReqHGPNone) {
            const hasEmptyDataItem = self.rightHistoryData.some(item =>
              item.none === false &&
              item.unknown === false &&
              Array.isArray(item.data) &&
              item.data.length === 0
            );

            if (hasEmptyDataItem) {
              notifyNotSaved();

              modalService.showAlert('You must either enter a history record or select "None" for each history group.');

              self.saving = false;
              return;
            }
          }

          const canSave = await self.validateLeftHistoryForSave();
          if (!canSave) {
            notifyNotSaved();
            return;
          }

          const hasProblemsSelected = saveWorklistModel.Study.Problems && saveWorklistModel.Study.Problems.length > 0;
          const selectedVisitReason = self.visitReasons.find(reason => reason.Key === saveWorklistModel.Study.VisitReason);
          const isLinkedStudy = saveWorklistModel.Study.IsLinked === true;
          if (!isLinkedStudy && selectedVisitReason.RequireProblems && !hasProblemsSelected) {
            notifyNotSaved();

            modalService.showAlert('At least one problem must be selected');
            self.isProblemsValid = false;
            self.showValidationErrors = true;

            self.saving = false;
            return;
          }

          self.saving = true;
          self.saved = false;
          try {
            let saveChangesResult = await Worklist.saveChanges(saveWorklistModel);

            if (saveChangesResult.data.NeedGeneratedImageFromClient) {
              saveWorklistModel = await self.fillSaveWorklistModelWithDiagramImage(saveWorklistModel);

              await Worklist.saveChanges(saveWorklistModel);
            }

            self.saving = false;
            self.saved = true;
            self.saveFailed = false;
            reachedSave = true;
            let beginTime = self.patientCopy.ExamBeginTime;
            let endTime = self.patientCopy.ExamEndTime;
            self.patientCopy = angular.copy(self.patient);
            self.patientCopy.ExamBeginTime = beginTime;
            self.patientCopy.ExamEndTime = endTime;
            self.moveCorrectTimeStamps();
            self.problemsCopy = angular.copy(self.problems);
            self.problemsListCopy = angular.copy(self.problemsList);
            self.examUfieldsDataCopy = _.cloneDeep(self.examUfieldsData);
            self.leftHistoryDataCopy = _.cloneDeep(self.leftHistoryData);
            self.rightHistoryDataCopy = _.cloneDeep(self.rightHistoryData);
            self.implantDataCopy = _.cloneDeep(self.implantData);
            self.nccnGuidelineCopy = _.cloneDeep(self.nccnGuideline);
            self.selectedFilmsComparedDataCopy = angular.copy(self.selectedFilmsComparedData);
            if(!isNotHideLoader) {
              $ionicLoading.hide();
            }
            self.saving = false;
            if (cb && !cbAfterReload) {
              cb();
            }
            if (!isSkipRefresh) {
              await self.refresh(false, isNotHideLoader);
              self.showRiskValidationAfterSave();
            }
            if (cb && cbAfterReload) {
              cb();
            }
            self.hideDiagram = false;
          } catch (resp) {
            self.hideDiagram = false;
            self.saving = false;
            self.saved = false;
            self.saveFailed = true;
            self.myriadSkippedFlag = false;
            if (resp.data.exception && resp.data.exception.ClassName === commonConstants.STUDY_LOCAKED_EXCEPTION_CLASS_NAME) {
              $ionicLoading.hide();
              modalService.showAdvancedConfirmation(
                commonConstants.STUDY_MODIFIED_EXCEPTION_MESSAGE,
                `${resp.data.message}`, [{
                  text: commonConstants.ALERT_CLOSE_BUTTON_TEXT,
                  type: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS,
                  onTap() {
                  }
                }]
              );

              return;
            }

            if (resp.data.exception && resp.data.exception.ClassName === commonConstants.STUDY_MODIFIED_EXCEPTION_CLASS_NAME) {
              console.log(resp.data);
              $ionicLoading.hide();
              modalService.showAdvancedConfirmation(
                commonConstants.STUDY_MODIFIED_EXCEPTION_MESSAGE,
                `${resp.data.message}`, [{
                  text: commonConstants.ALERT_CLOSE_BUTTON_TEXT,
                  type: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS,
                  onTap() {
                  }
                }
              ]
              );

              return;
            }

            modalService.showErrorMessage(resp.data, resp.status);
            $ionicLoading.hide();
          } finally {
            if (self.tab === self.tabs.Diagram) {
              self.changeTab(self.tabs.Exam);
            }
            if (!reachedSave) {
              // Server-side save failed (catch above): drop the loader and release any
              // caller awaiting completion so end-exam doesn't hang.
              notifyNotSaved();
            } else if (!isNotHideLoader) {
              $ionicLoading.hide();
            }
          }
        };

        self.refreshPatientAndTime = async function () {
          try {
            const resp = await Worklist.getPatientInfo(id);
            self.setupCEMTechniqueConfigs(resp.data.CEMTechniqueData, resp.data.Study);

            self.patient = angular.copy(resp.data);
            self.patientCopy = angular.copy(resp.data);
            self.patient.Status = self.patientCopy.Status;
            self.patient.StartTime = self.patientCopy.StartTime;
            self.patient.ElapsedTime = self.patientCopy.ElapsedTime;
            self.updateMyriadStatusProperties();
            self.moveCorrectTimeStamps();

            if(self.techpadConfig.settings.ShowStudyComparison && resp.data.FilmsCompared) {
              self.selectedFilmsComparedData = self.convertApiFilmsComparedToInternal(resp.data.FilmsCompared);
              self.selectedFilmsCompared = self.getFilmsComparedDisplayText(self.selectedFilmsComparedData);
              self.selectedFilmsComparedDataCopy = angular.copy(self.selectedFilmsComparedData);
            }
          } catch (error) {
            $ionicLoading.hide();
            if (error.status === 409) {
              modalService.showAlert(error.data, self.refreshPage);
            } else {
              modalService.showErrorMessage(error.data, error.status);
            }
          }
        };

        self.startExam = async function () {
          $ionicLoading.show({ template: 'Processing...' });
          await self.updateStatus(self.worklistStatuses.ExamInProgress);
          $ionicLoading.hide();
        };

        self.pauseExam = async function () {
          if (!self.pauseStarted && !self.shouldDisablePauseExam()) {
            try {
              self.pauseStarted = true;
              $ionicLoading.show({ template: 'Processing...' });
              await self.updateStatus(self.worklistStatuses.ExamPaused);
            } catch (error) {
            }
            $ionicLoading.hide();
            self.pauseStarted = false;
          }
        };

        self.updateStatus = async function (status) {
          const executeSaveChangesParameters = { status };
          executeSaveChangesParameters.isNotHideLoader = false;

          if (status === self.worklistStatuses.ExamInProgress) {
            executeSaveChangesParameters.isStartExamTriggered = true;
          }
          await self.checkChange(
            self.executeUpdateStatus,
            'You have not saved data here. Do you want to save your changes?',
            (status == 'ExamPaused') ? 'Pause' : (self.isExamStarted()) ? 'Resume' : 'Start',
            executeSaveChangesParameters);
        };

        self.executeUpdateStatus = async function (parameters) {
          if (!parameters || !parameters.status) {
            throw new Error('parameters are invalid');
          }
          let status = parameters.status;
          self.saving = true;
          try {
            const resp = await Worklist.updateStatus(id, status);
            self.saving = false;
            if (resp.data.Success) {
              if (status === self.worklistStatuses.Finished) {
                self.goToReturnUrl();
              }

              await self.refreshPatientAndTime();
            } else {
              // TODO: unable to change status, show warning
            }
          } catch (error) {
            self.saving = false;
            modalService.showErrorMessage(error.data, error.status);
          }
        };

        self.skipSurvey = async function () {
          // check for changes
          self.checkChange(() => {
            let ssn = self.patientCopy.Ssn;
            let sDate = self.patientCopy.Study.SDate;

            modalService.showConfirmation(() => {
              const isCurrentStatusInExamState = self.checkCurrentStatusInExamState();
              let newState = self.worklistStatuses.ExamWaiting;

              if (isCurrentStatusInExamState) {
                newState = self.patient.Status;
              } else if (techpadConfig.settings.HideStartAndEndButtons) {
                newState = self.worklistStatuses.ExamInProgress;
              }

              Study.skipSurveyAndStartExam(ssn, sDate, newState, true)
                .then((resp) => {
                  self.refresh().finally(() => {
                    self.changeTab(self.techpadConfig.settings.DefaultWorklistTab);
                  });
                });
            }, 'Are you sure you want to skip the survey?');
          }, 'You have not saved data here. Do you want to save your changes before skipping survey?', 'Continue');


        };

        self.checkCurrentStatusInExamState = function () {
          let inExamState = false;

          if (self.patient.Status !== self.worklistStatuses.ExamInProgress.status &&
            self.patient.Status !== self.worklistStatuses.ExamPaused.status &&
            self.patient.Status !== self.worklistStatuses.ExamStopped.status &&
            self.patient.Status !== self.worklistStatuses.Finished.status &&
            self.patient.Status !== self.worklistStatuses.ExamIncomplete.status) {
            inExamState = true;
          }

          return inExamState;
        }

        self.showPatClipPopup = async function () {
          if (self.patient == null) {
            self.patient = {};
          }
          if (self.patient.Clip == null) {
            self.patient.Clip = {};
          }
          const cliFlag = self.patient.Clip.Flag || '';
          const clipData = `<span class ="whitespace-normal confirmation-wrap"><b>Flag:</b> ${cliFlag}</span>`;
          if (!self.isOnline()) {
            modalService.showAlert(clipData, '', '', 'Techpad', 'CANCEL');
            return;
          }

          const params = { title: 'Techpad', okText: 'MODIFY', cancelText: 'CANCEL' };
          const isConfirmed = await modalService.showConfirmationAsync(clipData, params);
          if (isConfirmed) {
            const ifNotOffline = await self.checkIfNotOffline();
            if (ifNotOffline) {
              const patientDetailsModel = new patientDetailsViewModel(self.patient.PatientAccessToken, self.isViewOnly);
              await patientDetailsModel.initializeData();
              await patientDetailsModel.clipboardClicked();
              self.patient.Clip.Flag = patientDetailsModel.ClipboardFlagTitle;
            }
          }
        }

        self.onSaveDiagramException = (diagramSaveResp) => {
          self.saving = false;

          let exceptionMessage = diagramSaveResp.data;
          let exceptionStatus = diagramSaveResp.status;

          modalService.showErrorMessage(exceptionMessage, exceptionStatus);
        }

        self.processProblemsForSavingDiagram = (problems) => {
          problems.forEach(problem => {
            if (typeof problem.Settings === constantStrings.ObjectName) {
              problem.Settings = JSON.stringify(problem.Settings);
            }
            if (problem.Id === undefined || problem.Id === null) {
              delete problem.Id;
            }
            if (problem.Color === undefined || problem.Color === null || problem.Color === '') {
              delete problem.Color;
            }
          });
        }

        self.getSaveDiagramModel = async () => {
          let digramBase64String = await self.getDiagramBase64String();
          
          let problems = [];
          if (self.problemsList && self.problemsList.length > 0) {
            const diagramSettings = self.techpadConfig.settings.DiagramSettings || [];
            problems = self.problemsList
              .filter((item) => {
                const problemType = item.Type;
                const problemSetting = diagramSettings.find(setting => setting.Type === problemType);
                
                if (!problemSetting) {
                  return false;
                }
                return true;
              })
              .map((item) => {
                const problemSetting = diagramSettings.find(setting => setting.Type === item.Type);
                
                const problem = {
                  Settings: item.Settings,
                  Type: item.Type,
                  index: item.index
                };
                
                if (item.CustomType !== undefined && item.CustomType !== null) {
                  problem.CustomType = item.CustomType;
                  if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType) {
                    problem.Type = problemSetting.BaseType;
                  }
                } else if (problemSetting && problemSetting.IsManuallyAdded && problemSetting.BaseType) {
                  problem.CustomType = item.Type;
                  problem.Type = problemSetting.BaseType;
                }
                
                if (item.Id !== undefined && item.Id !== null) {
                  problem.Id = item.Id;
                }
                if (item.Color !== undefined) {
                  problem.Color = item.Color;
                }
                if (item.Comments !== undefined) {
                  problem.Comments = item.Comments;
                }
                if (item.strokeWidth !== undefined) {
                  problem.strokeWidth = item.strokeWidth;
                }
              return problem;
            });
          }
          
          const saveDiagramModel = {
            ssn: self.patient.Ssn,
            sdate: self.patient.Study.SDate,
            worklistId: self.worklistId,
            base64String: digramBase64String,
            problems: problems
          };

          return saveDiagramModel;
        }

        self.saveDiagramOnly = async () => {
          let isDiaramSaved = false;
          try {
            const saveDiagramModel = await self.getSaveDiagramModel();

            self.processProblemsForSavingDiagram(saveDiagramModel.problems);

            await self.diagramDomain.save(self.worklistId, saveDiagramModel)
              .catch((diagramSaveResp) => {
                self.onSaveDiagramException(diagramSaveResp)
              });
            isDiaramSaved = true;
          } catch (error) {
            console.error(error);
            self.saving = false;
            modalService.showErrorMessage(error);
          }
          return isDiaramSaved;
        }

        self.processSavingDiagramOnEndExam = async function (params) {
          let isDiaramSaved = false;
          if (!params || !params.isSaveTriggered) {
            isDiaramSaved = await self.saveDiagramOnly();
            if (!isDiaramSaved) {
              throw SAVE_DIAGRAM_ERROR_MESSAGE;
            }
          }
          return isDiaramSaved;
        }

        self.processStatusUpdateOnEndExam = async function () {
          if (techpadConfig.settings.HideStartAndEndButtons) {
            await self.updateStatus(self.worklistStatuses.Finished);
          } else {
            await self.refreshPatientAndTime();
            await self.refresh();
          }
        }

        self.onEndExamSuccessResponse = async function (params, resp) {
          self.saving = false;
          if (resp.data.Success) {
            await self.processSavingDiagramOnEndExam(params);
            await self.processStatusUpdateOnEndExam();
          } else {
            // refresh status b/c it may already be finished
            // we go to this line only if current status is not ExamInProgress or ExamPaused
            await self.refresh(false, params.isNotHideLoader);
          }
        }

        self.onEndExamErrorResponse = function (resp) {
          self.saving = false;
          modalService.showErrorMessage(resp.data, resp.status);
        }

        self.stopAndAskUlrtasound = async function (params) {
          try {
            self.saving = true;
            self.diagramDomain = Diagram;

            const resp = await Worklist.endExam(id);
            await self.onEndExamSuccessResponse(params, resp);
          } catch (error) {
            console.error(error);
            self.saving = false;
            modalService.showErrorMessage(error);
          }
        };

        self.validateLeftHistoryForSave = async function () {
          const data = self.leftHistoryData;

          if (self.historyConfig && self.historyConfig.leftHistoryConfig) {
            const heightField = _.flatten(self.historyConfig.leftHistoryConfig).find(
              (config) => config.Type === commonConstants.HEIGHT_FIELD_ID
            );
            if (heightField && data[heightField.Id]) {
              const heightVal = data[heightField.Id];
              const feet = parseInt(heightVal.heightFeet, 10) || 0;
              const inches = parseInt(heightVal.heightInches, 10) || 0;
              const totalInches = feet * 12 + inches;
              if (totalInches < 0 || totalInches > commonConstants.MAX_HEIGHT_INCHES) {
                modalService.showAlert(constantStrings.HeightOutOfRange);
                self.notValidLeftHistory[commonConstants.HEIGHT_FIELD_ID] = true;

                self.saving = false;
                self.showValidationErrors = true;

                return false;
              }
            }
          }

          const menarcheAge = data[commonConstants.MENARCHE_AGE_FIELD_ID];
          const firstPregnancyAge = data[commonConstants.FIRST_PREGNANT_FIELD_ID];
          const menopauseAge = data[commonConstants.MENOPAUSE_AGE_FIELD_ID];

          // P_AGE/A_AGE/M_AGE store -1 (and sometimes 0) as a "not applicable" sentinel.
          // Treat any non-positive/blank/non-numeric value as "not answered" so it never
          // participates in the age comparisons below.
          const toPositiveAge = function (raw) {
            const parsed = parseInt(raw, 10);
            return parsed > 0 ? parsed : null;
          };

          const numMenarche = toPositiveAge(menarcheAge);
          const numFirstPregnancy = toPositiveAge(firstPregnancyAge);
          const numMenopause = toPositiveAge(menopauseAge);

          const validationResultShape = {
            isValid: false,
            Exam: [],
            Demographic: [],
            Risk: [],
            goToTab: self.tabs.Demographic,
          };

          if (numMenarche != null && numFirstPregnancy != null && numMenarche > numFirstPregnancy) {
            self.handleNotValidExamEnd({
              ...validationResultShape,
              message: constantStrings.AgeAtMenarcheExceedsFirstPregnancy,
            });
            self.notValidLeftHistory[commonConstants.MENARCHE_AGE_FIELD_ID] = true;
            self.notValidLeftHistory[commonConstants.FIRST_PREGNANT_FIELD_ID] = true;
            self.showValidationErrors = true;
            self.saving = false;
            return false;
          }

          if (numMenarche != null && numMenopause != null && numMenarche > numMenopause) {
            self.handleNotValidExamEnd({
              ...validationResultShape,
              message: constantStrings.AgeAtMenarcheExceedsMenopause,
            });
            self.notValidLeftHistory[commonConstants.MENARCHE_AGE_FIELD_ID] = true;
            self.notValidLeftHistory[commonConstants.MENOPAUSE_AGE_FIELD_ID] = true;
            self.showValidationErrors = true;
            self.saving = false;
            return false;
          }

          if (numFirstPregnancy != null && numMenopause != null && numFirstPregnancy > numMenopause) {
            self.handleNotValidExamEnd({
              ...validationResultShape,
              message: constantStrings.AgeAtFirstPregnancyExceedsMenopause,
            });
            self.notValidLeftHistory[commonConstants.FIRST_PREGNANT_FIELD_ID] = true;
            self.notValidLeftHistory[commonConstants.MENOPAUSE_AGE_FIELD_ID] = true;
            self.showValidationErrors = true;
            self.saving = false;
            return false;
          }

          if (
            numMenopause != null &&
            self.patient && self.patient.DateOfBirth &&
            data[commonConstants.LAST_MENSTRUAL_PERIOD_FIELD_ID]
          ) {
            const lmpRaw = data[commonConstants.LAST_MENSTRUAL_PERIOD_FIELD_ID];
            if (lmpRaw !== '' && lmpRaw !== self.techpadConfig.settings.DefaultTechpadDateStringValue) {
              const menopauseDate = moment(self.patient.DateOfBirth).add(numMenopause, 'years');
              const lmpDate = moment(lmpRaw, [moment.ISO_8601, 'MM/DD/YYYY', 'YYYY-MM-DD', 'MM-DD-YYYY'], true);
              if (lmpDate.isValid() && lmpDate.isAfter(menopauseDate)) {
                const confirmed = await modalService.showConfirmationAsync(
                  constantStrings.LastMenstrualPeriodAfterMenopauseWarning
                );
                if (!confirmed) {
                  self.saving = false;
                  return false;
                }
              }
            }
          }

          return true;
        };

        self.handleNotValidExamEnd = function (validationResult) {
          let message = validationResult && validationResult.message ? validationResult.message : 'You have not answered all required fields.' + self.getEmptyRequiredFiledsHintString(validationResult);
          let gotToTabFunc =
            validationResult.goToTab ? () => {
              self.changeTab(validationResult.goToTab);
            }
              :
              undefined;
          modalService.showAlert(message, gotToTabFunc, 'modal-md');
          self.saving = false;
          self.saved = false;
          self.saveFailed = true;
        };

        self.finishExam = async function () {
          $ionicLoading.show({ template: 'Processing...' });

          if (techpadConfig.settings.HideStartAndEndButtons) {
            let validationResult = self.validateExamEnd();
            if (!validationResult.isValid) {
              $ionicLoading.hide();
              self.handleNotValidExamEnd(validationResult);
              return;
            }
          }

          if (!self.isFollowUpTabVisited && self.tab !== self.tabs.FollowUps) {
            let isShowFollowUpsUponSaving = false;
            if (techpadConfig.settings.SFUWarn === 'A') {
              isShowFollowUpsUponSaving = true;
            } else if (techpadConfig.settings.SFUWarn === 'O') {
              isShowFollowUpsUponSaving = self.hasOpenedFollowUps();
            }
            if (isShowFollowUpsUponSaving) {
              $ionicLoading.hide();
              if (!techpadConfig.settings.SFUMess) {
                self.changeTab(self.tabs.FollowUps);
              }
              else {
                modalService.showAdvancedConfirmation(
                  'Follow-ups',
                  techpadConfig.settings.SFUMess, [{
                    text: 'OK',
                    type: 'button-positive',
                    onTap: function () {
                      self.changeTab(self.tabs.FollowUps);
                    }
                  }]
                );
              }
              return;
            }
          }

          $ionicLoading.hide();
          $ionicLoading.hide();

          self.checkChange(
            self.finishExamConfirmed,
            'You have not saved data here. Do you want to save your changes before finish this exam?',
            ''
          );
        };

        self.finishExamConfirmed = async function (params) {
          $ionicLoading.show({ template: 'Processing...' });
          if (!techpadConfig.settings.HideStartAndEndButtons) {
            await self.updateStatus(self.worklistStatuses.Finished);
          }
          self.stopExamIfNeeded(params);
          $ionicLoading.hide();
        };

        self.stopExamIfNeeded = function (params) {
          if (!techpadConfig.settings.HideStartAndEndButtons)
            return;

          // TODO: End exam
          self.endExam(params);
        };

        self.updateProceduresBasedValidationRules = function () {
          let notFoundProcedureKeys = [];
          let proceduresDefinitions = self.patient.Study.Procedures.map((x) => {
            let procedureDefinition = self.procedures.find((proc) => proc.Key === x.Code);
            if (!procedureDefinition) {
              notFoundProcedureKeys.push(x.Code);
            }
            return procedureDefinition;
          });
          if (notFoundProcedureKeys.length) {
            modalService.showAlert(`Procedure not found by Key = ${JSON.stringify(notFoundProcedureKeys)}.`, undefined, 'modal-md');
            return;
          }

          self.isProblemsRequired = proceduresDefinitions.some(_ => _.RequireProblem);

          self.isViewsRequired = proceduresDefinitions.some(_ => _.RequireViews);

          self.isSideRequired = proceduresDefinitions.some(_ => _.RequireSide);

          self.validateProblems();
          self.validateViews();
          self.validateSide();
        };

        self.validateProblems = function () {
          if (!self.areProblemsValid()) {
            self.isProblemsValid = false;
            return;
          }
          if (self.isProblemsRequired && self.patient.AllowSProb) {
            self.isProblemsValid = self.problems.filter((item) => item.IsRight || item.IsLeft || item.IsBoth || item.IsUnspecified).length > 0;
          } else {
            self.isProblemsValid = true;
          }
        };

        self.validateViews = function () {
          if (!techpadConfig.settings.IsHideViewsFromExamTab && self.isViewsRequired && !self.canShowUltrasoundOptions()) {
            self.isViewsValid = self.patient.Study.Views.length > 0;
          } else {
            self.isViewsValid = true;
          }
        };

        self.validateSide = function () {
          if (self.isSideRequired) {
            self.isSideValid = !self.patient.Study.Procedures.some(p => !p.Side);
          } else {
            self.isSideValid = true;
          }
        };

        self.validateExamEnd = function () {

          let validationResult = {
            isValid: true,
            Exam: [],
            Demographic: [],
            Risk: [],
            message: '',
            goToTab: ''
          };

          if (!techpadConfig.settings.DisableRequiringStudyFields) {
            self.validateProblems();
            self.validateViews();
            self.validateSide();
            self.invalidReasonForVisit = !self.patient.Study.VisitReason;

            if (!self.isProblemsValid || !self.isViewsValid || !self.isSideValid || !self.patient.Study.VisitReason ||
              (techpadConfig.settings.ReqICP && !self.patient.Study.IsInfectionControlProcedureDone)) {

              validationResult.isValid = false;

              if (!self.isProblemsValid) {
                validationResult.Exam.push(commonConstants.PROBLEMS_DATA);
              }
              if (!self.isViewsValid) {
                validationResult.Exam.push(commonConstants.VIEWS_OBTAINED_DATA);
              }
              if (!self.isSideValid) {
                validationResult.Exam.push(commonConstants.PROCEDURE_SIDE_DATA);
              }
              if (!self.patient.Study.VisitReason) {
                validationResult.Exam.push(commonConstants.REASON_FOR_VISIT_DATA);
              }
              if (techpadConfig.settings.ReqICP && !self.patient.Study.IsInfectionControlProcedureDone) {
                validationResult.Exam.push(commonConstants.INFECTION_CONTROL_DATA);
              }
            }
          }

          self.historyConfig.leftHistoryConfig.forEach(col => {
            col.forEach(field => {
              //TODO: make .Required boolean
              var isRequired = field.Required && field.Required.toLowerCase() === (true).toString();
              var isEmpty;
              var isDefaultValue = false;

              if (field.Id.toLowerCase() === commonConstants.PERSONAL_BRCA_FIELD_ID) {
                isEmpty = !self.leftHistoryData[commonConstants.PERSONAL_BRCA1_ANSWER_KEY] || !self.leftHistoryData[commonConstants.PERSONAL_BRCA2_ANSWER_KEY];
              } else {
                isEmpty = !self.leftHistoryData[field.Id] || self.leftHistoryData[field.Id] === '';
              }
              if (field.Type === constantStrings.DATE_OBJECT_TYPE.toUpperCase()) {
                isDefaultValue = self.leftHistoryData[field.Id] === self.techpadConfig.settings.DefaultTechpadDateStringValue;
              }

              self.notValidLeftHistory[field.Id] = isRequired && (isEmpty || isDefaultValue);
              if (isRequired && (isEmpty || isDefaultValue)) {
                validationResult.Demographic.push(field.Caption);
                validationResult.isValid = false;
                validationResult.message = constantStrings.YouHaveNotReviewedDemographicTabDefaultMessage;
              }
            });
          });

          self.historyConfig.examUfieldsConfig.forEach(col => {
            col.forEach(field => {
              //TODO: make .Required boolean
              var isRequired = field.Required && field.Required.toLowerCase() === (true).toString();
              var isEmpty = !self.examUfieldsData[field.Id] || self.examUfieldsData[field.Id] === '';
              var isDefaultValue = false;
              if (field.Type === constantStrings.DATE_OBJECT_TYPE.toUpperCase()) {
                var isDefaultValue = self.examUfieldsData[field.Id] === self.techpadConfig.settings.DefaultTechpadDateStringValue;
              }

              self.notValidExamUfields[field.Id] = isRequired && (isEmpty || isDefaultValue);
              if (isRequired && (isEmpty || isDefaultValue)) {
                validationResult.Exam.push(field.Caption);
                validationResult.isValid = false;
                validationResult.message = self.getValidationResultMessageForExamTab(validationResult);
              }
            });
          });

          if (self.nccnGuideline && self.nccnGuideline.Elements) {
            self.nccnGuideline.Elements.forEach(element => {
              if (element.Properties) {
                element.Properties.forEach(property => {
                  var isRequired = property.Required === true || (property.Required && property.Required.toLowerCase && property.Required.toLowerCase() === (true).toString());
                  var isEmpty = !property.Response || property.Response === '' || property.Response === riskPropertyConstants.noneAnswerValue;

                  self.notValidRiskProperties[property.Id] = isRequired && isEmpty;
                });
              }
            });
          }

          if (!validationResult.isValid && validationResult.Exam.length) {
            self.changeTab(self.tabs.Exam);
            $ionicLoading.hide();
            self.showValidationErrors = true;
            validationResult.message = self.getValidationResultMessageForExamTab(validationResult);
          } else if (!validationResult.isValid && validationResult.Demographic.length) {

            self.changeTab(self.tabs.Demographic);
            $ionicLoading.hide();
            self.showValidationErrors = true;
          }

          self.showValidationErrors = !validationResult.isValid;

          return validationResult;
        };

        self.getValidationResultMessageForExamTab = function (validationResult) {
          let message = "";

          if (!validationResult.Exam || validationResult.Exam.length == 0) {
            message = constantStrings.YouHaveNotReviewedExamTabDefaultMessage;

          } else if (validationResult.Exam.includes("Problems")) {
            message = constantStrings.YouHaveNotReviewedProblemsOnExamTabMessage
          }

          if (message == "") {
            message = constantStrings.YouHaveNotReviewedExamTabDefaultMessage;
          }

          return message;
        }

        self.getEmptyRequiredFiledsHintString = function (validationResult) {
          let emptyRequiredFieldsHintString = '';
          if (validationResult.Exam.length) {
            emptyRequiredFieldsHintString += '<br/><br/>Exam: <br/>&emsp;';
            emptyRequiredFieldsHintString += validationResult.Exam.join(',<br/>&emsp;')
          }
          if (validationResult.Demographic.length) {
            emptyRequiredFieldsHintString += '<br/><br/>Demographic: <br/>&emsp;';
            emptyRequiredFieldsHintString += validationResult.Demographic.join(',<br/>&emsp;')
          }
          if (validationResult.Risk.length) {
            emptyRequiredFieldsHintString += '<br/><br/>Risk Assessment: <br/>&emsp;';
            emptyRequiredFieldsHintString += validationResult.Risk.join(',<br/>&emsp;')
          }
          return emptyRequiredFieldsHintString;
        };

        self.endExam = async function (params) {
          if (self.isProcessing) {
            return;
          }

          self.isProcessing = true;
          $ionicLoading.show({ template: 'Processing...' });

          try {
            if (!self.isOnline()) {
              $ionicLoading.hide();
              self.isProcessing = false;
              await modalService.showAlertAsync(`You are currently offline, please check your network settings and try again`);

              if (!self.reconnectTimeout) {
                self.reconnectTimeout = setTimeout(() => {
                  signalrService.tryReconnectAgain();
                  clearTimeout(self.reconnectTimeout);
                }, 10000);
              }
              return;
            }

            let validationResult = self.validateExamEnd();
            if (!validationResult.isValid) {
              $ionicLoading.hide();
              self.isProcessing = false;
              self.handleNotValidExamEnd(validationResult);
              return;
            }
            
            const stopAndTriggerMyriad = async function(params) {
              await self.stopAndAskUlrtasound(params);
              await self.triggerMyriadReferralAfterAction();
            };

            await self.checkChange(
              stopAndTriggerMyriad,
              'You have not saved data here. Do you want to save your changes before ending exam?',
              '',
              { isNotHideLoader: true }
            );

          } catch (error) {
            console.error('Error ending exam:', error);
            await modalService.showAlertAsync('An error occurred while processing your request. Please try again.');
          } finally {
            $ionicLoading.hide();
            self.isProcessing = false;
          }
        };

        self.revertAllChanges = function () {
          self.patient = angular.copy(self.patientCopy);
          self.problems = angular.copy(self.problemsCopy);
          self.selectedProblems = self.getSelectedProblems(self.problems);
          self.problemsList = angular.copy(self.problemsListCopy);
          self.examUfieldsData = _.cloneDeep(self.examUfieldsDataCopy);
          self.leftHistoryData = _.cloneDeep(self.leftHistoryDataCopy);
          self.initPersonalBRCAValues();
          self.rightHistoryData = _.cloneDeep(self.rightHistoryDataCopy);
          self.implantData = _.cloneDeep(self.implantDataCopy);
          self.implantString = self.getImplantString();
          self.nccnGuideline = angular.copy(self.nccnGuidelineCopy);
          self.selectedFilmsComparedData = angular.copy(self.selectedFilmsComparedDataCopy);
          self.selectedFilmsCompared = undefined;
          self.notValidRiskProperties = [];
          self.myriadSkippedFlag = false;
        }

        self.checkChange = async function (callback, message, nextAction, callbackParameters, isSkipRefresh, cbAfterReload) {
          if (self.isChanged()) {
            modalService.showAdvancedConfirmation_Deprecated({
              exitButtonText: "Discard changes",
              exitAction: async function () {
                $ionicLoading.show({ template: 'Processing...' });
                await self.revertAllChanges();
                $ionicLoading.hide();
              },
              saveButtonText: "Save & " + (nextAction || "End"),
              saveAction: async function () {
                $ionicLoading.show({ template: 'Saving...' });
                let saveSucceeded = false;
                await new Promise(resolve => {
                  self.saveChanges(() => {
                    saveSucceeded = true;
                    resolve();
                  }, isSkipRefresh, cbAfterReload, { onSaveNotCompleted: resolve }, callbackParameters ? callbackParameters.isNotHideLoader : false );
                });
                if (saveSucceeded) {
                  await callback(callbackParameters);
                }
              },
              text: message
            });
          } else {
            await callback(callbackParameters);
          }
        };

        //region disable/enable start/end/pause exam

        self.shouldDisableStartExam = function () {
          return !!(self.isInitialViewOnly || !self.isOnline() || !self.patientCopy);
        };

        self.isExamStopped = function () {
          if (!self.patientCopy)
            return false;

          let isExamStopped = self.worklistStatuses.ExamStopped === self.patientCopy.Status;
          return isExamStopped;
        };

        self.isExamStarted = function () {
          if (!self.patientCopy)
            return false;

          return self.patientCopy.ElapsedTime || _.includes([
            self.worklistStatuses.InProgress,
            self.worklistStatuses.Paused
          ], self.patientCopy.Status);
        };

        self.shouldDisablePauseExam = function () {
          let shouldDisablePauseButton = self.isInitialViewOnly || !self.isOnline() || !self.patientCopy;

          return shouldDisablePauseButton || !_.includes([self.worklistStatuses.ExamInProgress, self.worklistStatuses.ExamStopped], self.patientCopy.Status);
        };

        self.shouldDisableEndExam = function () {
          if (self.isInitialViewOnly || !self.isOnline() || !self.patientCopy) {
            return true;
          }

          let shouldDisableEndExamButton = !_.includes([
            self.worklistStatuses.ExamInProgress,
            self.worklistStatuses.ExamPaused
          ], self.patientCopy.Status);

          return shouldDisableEndExamButton;
        };

        self.shouldDisableCompleteExam = function () {
          if (self.isViewOnly || !self.patientCopy) {
            return true;
          }
          let shouldDisableCompleteExamButton = {}
          if (techpadConfig.settings.HideStartAndEndButtons) {
            shouldDisableCompleteExamButton = !_.includes([
              self.worklistStatuses.ExamInProgress,
              self.worklistStatuses.ExamPaused
            ], self.patientCopy.Status);
          } else {
            shouldDisableCompleteExamButton = self.patientCopy.Status !== self.worklistStatuses.ExamStopped;
          }

          return shouldDisableCompleteExamButton;
        };

        self.shouldHideStartExam = function () {
          if (self.isInitialViewOnly || !self.patientCopy || techpadConfig.settings.HideStartAndEndButtons || (self.patientCopy.Status === self.worklistStatuses.ExamStopped))
            return true;

          return self.patientCopy.Status === self.worklistStatuses.ExamInProgress || self.patientCopy.Status === self.worklistStatuses.Finished;
        };

        self.shouldHidePauseExam = function () {
          if (self.isInitialViewOnly || !self.patientCopy || techpadConfig.settings.HideStartAndEndButtons)
            return true;

          return self.patientCopy.Status !== self.worklistStatuses.ExamInProgress;
        };

        self.shouldHideEndExam = function () {
          if (self.isInitialViewOnly || !self.patientCopy || techpadConfig.settings.HideStartAndEndButtons)
            return true;

          return self.patientCopy.Status !== self.worklistStatuses.ExamInProgress || self.patientCopy.Status === self.worklistStatuses.Finished;
        };

        //endregion

        self.getUltrasoundTechniqueLabel = function () {
          if (self.scanResults.length > 1) {
            return constantStrings.UltrasoundScanTechniqueMultipleScans;
          }
          if (self.scanResults.length == 1) {
            return self.scanResults[0].Desc;
          }
          return constantStrings.UltrasoundScanTechninqueNoScans;
        }

        self.getLabel = function (value, collection, key, property) {

          let selectedItem = collection.find(x => x && x[key || 'Key'] !== undefined && x[key || 'Key'] === value);

          if (!selectedItem) {
            selectedItem = {};
          }

          return selectedItem[property || 'Value'];
        };

        self.getProcedureSides = function (procedureCode) {
          const selectedItem = self.procedures.find(x => x && x['Key'] !== undefined && x['Key'] === procedureCode);
          let result;

          if (selectedItem && !selectedItem.AskSide) {
            return self.sidesOnlyUnknown;
          } else if (selectedItem && selectedItem.RequireSide && selectedItem.Unilateral) {
            result = self.sidesWithoutBilateral.filter(side => side.Key !== SIDE_UNKNOWN_KEY);
          } else if (selectedItem && selectedItem.RequireSide) {
            result = self.sidesWithoutUnknown;
          } else if (selectedItem && selectedItem.Unilateral) {
            result = self.sidesWithoutBilateral;
          }

          return result || self.sides;
        };

        self.getViewSides = function (view) {
          if (techpadConfig.settings.LimitViews && self.patient.Study.Procedures && self.patient.Study.Procedures.length) {
            const singleProcedure = self.patient.Study.Procedures.length == 1;
            const singleProcedureSideSelectedNotBilateral = singleProcedure && self.patient.Study.Procedures[0].Side &&
              self.patient.Study.Procedures[0].Side !== SIDE_BILATERAL_KEY &&
              self.patient.Study.Procedures[0].Side !== SIDE_UNKNOWN_KEY;
            let multipleProceduresWithSameSideAndNotBilateral = false;
            if (!singleProcedure) {
              const procedureSidesArray = self.patient.Study.Procedures.map(procedure => procedure.Side);
              const procedureSidesNotEqualToFirstOne = procedureSidesArray.filter(procedureSide => procedureSide !== procedureSidesArray[0]);
              if (procedureSidesNotEqualToFirstOne.length === 0 && procedureSidesArray[0] !== SIDE_BILATERAL_KEY) {
                multipleProceduresWithSameSideAndNotBilateral = true;
              }
            }
            if (singleProcedureSideSelectedNotBilateral || multipleProceduresWithSameSideAndNotBilateral) {
              const allowedSides = self.sides.filter(side => side.Key === self.patient.Study.Procedures[0].Side || side.Key === SIDE_UNKNOWN_KEY);
              if (!allowedSides.some(allowedSide => allowedSide.Key === view.Side)) {
                view.Side = '';
              }
              return allowedSides;
            }
          }

          return self.sides;
        };

        self.getTechnologist = function (key, array) {
          if (!key || !array) {
            return '';
          }
          let selectedTechnologist = array.find(item => item.Key === key);
          if (selectedTechnologist) {
            return selectedTechnologist.Value;
          }
          return '';
        };

        self.removeFirstTechnologist = function () {
          self.patient.Study.Technologist = '';
        };
        self.removeSecondTechnologist = function () {
          self.patient.Study.Technologist2 = '';
        };
        self.removeThirdTechnologist = function () {
          self.patient.Study.Technologist3 = '';
        };

        self.isSurveyHistoryTab = function () {
          return self.tab === self.tabs.SurveyHistory;
        };

        self.hideBottomBar = function () {
          return self.tab === self.tabs.SurveyHistory || self.tab === self.tabs.Diagram;
        };

        self.getDuration = function (showMilliseconds) {

          var result;

          if (showMilliseconds) {
            if (!self.patientCopy.currentTime) {
              let currentTime = (new Date()).getTime() - self.patientCopy.ElapsedTime / 10000;
              const startDate = new Date(self.patientCopy.StartTime);
              let offset = (new Date() - startDate + serverTimeService.getDiff());
              if (offset > 0) {
                currentTime -= offset;
              }
              self.patientCopy.currentTime = currentTime;
            }

            result = self.patientCopy.currentTime;
          } else {
            let seconds = self.patientCopy.ElapsedTime / 10000 / 1000;
            let hours = Math.floor(seconds / 3600);
            seconds = seconds - hours * 3600;
            let minutes = Math.floor(seconds / 60);
            seconds = Math.floor(seconds - minutes * 60);

            result = (hours < 10 ? '0' : '') + hours + ':' + (minutes < 10 ? '0' : '') + minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
          }

          return result;
        };

        self.addView = function (newView) {
          if (!newView) {
            return;
          }

          let p = {
            Code: newView,
            Side: SIDE_UNKNOWN_KEY,
            Type: 'N'
          };
          self.patient.Study.Views.push(p);
          self.fillViewsSidesDictionary();
          self.validateViews();
          self.onViewsChange();
        };

        self.removeView = function (view) {
          self.patient.Study.Views = _.without(self.patient.Study.Views, view);
          self.validateViews();
          self.onViewsChange();
          self.removeViewFromDetectedDuplicates(view);
        };

        self.addProcedure = function (procedure) {
          if (!procedure) {
            return;
          }

          const cem = self.procedures && self.procedures.some(p => p.Key === procedure) && self.procedures.find(p => p.Key === procedure).CEM;

          let p = {
            Code: procedure,
            Side: SIDE_UNKNOWN_KEY,
            Cem: cem,
          };
          self.patient.Study.Procedures.push(p);
          self.updateProceduresBasedValidationRules();
          self.onProcedureChanged();
        };

        self.removeProcedure = async function (procedure) {
          const procName = self.procedures.find(x => x.Key === procedure.Code).Value;
          const procSide = self.sides.find(x => x.Key === procedure.Side).Value;

          let procedureMessage = procedure.Side != SIDE_UNKNOWN_KEY 
                                ? `${procName} - ${procSide}`
                                : procName;

          const isConfirmed = await modalService.showConfirmationAsync(
            `Are you sure you want to remove the following procedure: ${procedureMessage.trim()}?`, {title : 'Remove Procedure'}
          );

          if(isConfirmed) {
            self.patient.Study.Procedures.splice(self.patient.Study.Procedures.indexOf(procedure), 1);
            self.updateProceduresBasedValidationRules();
            self.onProcedureChanged();
          }
        };

        self.onViewsChange = function ($event) {
          self.wasViewsChanged = true;
        }

        self.getRndInteger = function(min, max) {
          return Math.floor(Math.random() * (max - min + 1) ) + min;
        }

        self.onViewsSideChange = function($event, view) {
          let viewToCheck = _.cloneDeep(view);
          viewToCheck.Side = $event;
          self.checkForViewsDuplicatesToCurrentView(viewToCheck);
        }

        self.onViewsTypeChange = function($event, view) {
          let viewToCheck = _.cloneDeep(view);
          viewToCheck.Type = $event;
          self.checkForViewsDuplicatesToCurrentView(viewToCheck);
        }

        self.checkForViewsDuplicatesToCurrentView = function (viewToCheck) {
          if(!viewToCheck 
             || self.viewDuplicates 
                && self.viewDuplicates.some(dup => dup.Code === viewToCheck.Code 
                                                   && dup.Side === viewToCheck.Side 
                                                   && dup.Type === viewToCheck.Type 
                                                   && dup.$$hashKey === viewToCheck.$$hashKey)) {
            return;
          }

          let isNewDuplicate = false;

          if(!self.viewDuplicates) {
            self.viewDuplicates = [];
          } else {
            self.viewDuplicates = self.viewDuplicates.filter(v => v.$$hashKey !== viewToCheck.$$hashKey);
          }

          const duplicate = self.patient.Study.Views.some(v => v.Code === viewToCheck.Code && v.Type === viewToCheck.Type && v.Side === viewToCheck.Side && v.$$hashKey !== viewToCheck.$$hashKey);            
          if(duplicate && !self.viewDuplicates.some(v => v.Type === viewToCheck.Type && v.Side === viewToCheck.Side && v.Code === viewToCheck.Code)) {
            self.viewDuplicates.push(viewToCheck);
            isNewDuplicate = true;
          }

          if(isNewDuplicate && self.viewDuplicates.length) {
            self.showViewsDuplicatesDetectedAlert().then(() => {
              self.viewDuplicates.forEach(dup => {
                const index = self.patient.Study.Views.findLastIndex(x => x.Type === dup.Type && x.Code === dup.Code && x.Side === dup.Side);
                self.patient.Study.Views[index].Side = SIDE_UNKNOWN_KEY;
                self.patient.Study.Views[index].Type = 'N';
              });
            });
          }
        }

        self.showViewsDuplicatesDetectedAlert = function() {
          return modalService.showAlert('A view already exists with the same Name, Side and Type selected. Please make a different selection for at least one of these fields in order to add this view.');
        }

        self.isDuplicate = function(view) {
          const isDuplicate = self.viewDuplicates && self.viewDuplicates.some(dup => dup.Code === view.Code && view.$$hashKey === dup.$$hashKey);
          return isDuplicate;
        }

        self.removeViewFromDetectedDuplicates = function (view) {
          self.viewDuplicates = self.viewDuplicates.filter(dup => dup.$$hashKey !== view.$$hashKey);
        }

        self.onProcedureChanged = function ($event) {
          setTimeout(() => {
            self.setDefaultViews();
            self.fillViewsSidesDictionary();
            self.shouldShowFilmsComparedValue = null;
            self.isFilmsComparedEnabledValue = null;
            self.isLoadingShouldShowFilmsCompared = false;
          }, 0);
        }

        self.changeReasonForVisit = function (value) {
          self.patient.Study.VisitReason = value;
          self.invalidReasonForVisit = !self.patient.Study.VisitReason;
        };

        self.deselectedUltrasoundTechnique = function ($type) {
          if (self.patient.Study.UTechnique.indexOf($type.Key) > -1) {
            self.studyUTechniques = [];
            const parts = self.patient.Study.UTechnique.split(',');
            parts.forEach(part => {
              if (part.trim() !== $type.Key.trim()) {
                self.studyUTechniques.push(part.trim());
              }
            });
            self.patient.Study.UTechnique = self.studyUTechniques.join(', ');
          }
        }

        self.selectedUltrasoundTechnique = function ($type) {
          if (self.patient.Study.UTechnique.indexOf($type.Key) === -1) {
            const uTechnique = `${self.patient.Study.UTechnique.length === 0 ? '' : ', '}${$type.Key}`
            self.patient.Study.UTechnique += uTechnique;
            self.fillStudyUTechniques();
          }
        }

        self.fillStudyUTechniques = function () {
          self.studyUTechniques = [];
          const parts = self.patient.Study.UTechnique.split(',');
          parts.forEach(part => {
            if (part) {
              self.studyUTechniques.push(part.trim());
            }
          });
        }

        self.changeInfectionControl = function (value) {
          self.patient.Study.IsInfectionControlProcedureDone = value;
        };

        self.changeCadControl = function (value) {
          self.patient.Study.CadState = value;
        };

        self.changeOptInOfRiskControl = async function (value) {
          if(self.techpadConfig.settings.IsRiskOOWarn && !value){
            const isConfirmed = await modalService.showConfirmationAsync(
              'Proceeding will prevent the risk calculation for the current patient. Are you sure you want to continue?'
            );

            if (!isConfirmed) {
              return;
            }
          }
          self.patient.IsRiskOptIn = value === '' ? null : value; 
        };

        self.getRiskOptInText = function () {
          if(self.patient){
            if (self.patient.IsRiskOptIn == null) {
              return '';
            }
            else if (self.patient.IsRiskOptIn) {
              return 'Yes';
            }
          }
          return 'No';
        };

        self.updateFirstTechnologist = function (value) {
          self.patient.Study.Technologist = value;
        };

        self.updateSecondTechnologist = function (value) {
          self.patient.Study.Technologist2 = value;
        };

        self.updateThirdTechnologist = function (value) {
          self.patient.Study.Technologist3 = value;
        };

        self.findByCode = function (code, list) {
          for (let key in list) {
            if (list[key].Key === code) {
              return list[key];
            }
          }

          return null;
        };

        self.showImagePreview = function (name) {
          modalService.showImagePreview(name);
        };

        self.goBack = async function () {

          if (self.tab === self.tabs.TyrerCuzick) {
            self.canLoadSurveyTheme = false;
            self.canLoadTyrerCuzickContent = false;
          }

          let isProcessed = false;
          if (self.isViewOnly) {
            self.goToReturnUrl();
            return;
          }

          if (!isProcessed && self.isSurveyStarted) {
            let confirmed = await modalService.showConfirmation(null, commonConstants.DEFAULT_NOT_COMPLETED_SURVEY_ERROR_ON_LEAVE_PAGE);
            if (!confirmed) {
              isProcessed = true;
            }
          }

          if (!isProcessed && !self.isChanged()) {
            self.goToReturnUrl();
            $rootScope.safeApply();
            isProcessed = true;
          }

          if (!isProcessed) {
            if (self.tab === self.tabs.Diagram) {
              eventsMgr.send(commonConstants.CLEAR_DIAGRAM_PROBLEM_EVENT);
              eventsMgr.send(commonConstants.LOCK_DIAGRAM_DRAGGING_EVENT);
            }

            await modalService.showAdvancedConfirmation_Deprecated({
              cancelAction: () => {
                eventsMgr.send(commonConstants.UNLOCK_DIAGRAM_DRAGGING_EVENT);
              },
              exitAction: () => {
                $location.path(self.returnUrl);
                eventsMgr.send(commonConstants.UNLOCK_DIAGRAM_DRAGGING_EVENT);
              },
              saveAction: async () => {
                self.saveChanges(() => {
                  $location.path(self.returnUrl);
                  eventsMgr.send(commonConstants.UNLOCK_DIAGRAM_DRAGGING_EVENT);
                });
              },
              text: commonConstants.DEFAULT_NOT_SAVED_DATA_ERROR_ON_LEAVE_PAGE
            });
          }
        };

        self.isTabAvailable = function (num) {

          if (num == self.tabs.Documents)
            return self.isOnline();

          return true;
        };

        self.areAllTabsEnabled = function () {
          const areAllTabsEnabled = self.techpadConfig.settings.FamilyTreeEnabled;
          return areAllTabsEnabled;
        }

        self.getExamTabAlias = function (tabLabel) {
          const tabConfig = self.techpadConfig.settings.ExamTabsAliases.find(aliasConfig => aliasConfig.Label.trim().toLowerCase() === tabLabel.trim().toLowerCase());

          return tabConfig.Value;
        }

        self.setSvgAction = function (svg) {
          self.svg = svg;
        };

        self.showDocument = async function (document) {
          if (document.Id && self.isOnline()) {
            if (document.DocumentSource === commonConstants.CONTACT_DOCUMENT_SOURCE) {
              await self.addContactDocument(document.Id);
            } else {
              $ionicLoading.show({
                template: commonConstants.DOCUMENT_LOADING_MESSAGE
              });

              try {
                let url = await documentsSvc.getDocumentUrl(document);
                if (techpadInitialConfigProvider.setFromElectron) {
                  documentPrintHelper.openDocumentElectron(url);
                } else {
                  documentPrintHelper.openDocumentBrowser(url, document, {
                    patient: self.patient
                  });
                }
              } catch (resp) {
                modalService.showErrorMessage(resp.data, resp.status);
                $ionicLoading.hide();
              }
            }
          }
        };

        async function deleteFile() {
          if (typeof cordova === 'undefined' || (!ionic.Platform.isIOS() && !ionic.Platform.isAndroid())) {
            // no need to delete files if the current environment is not mobile app
            return;
          }

          var downloadTarget = '';
          if (ionic.Platform.isIOS()) {
            downloadTarget = cordova.file.tempDirectory;
          } else {
            downloadTarget = cordova.file.externalCacheDirectory;
          }

          window.resolveLocalFileSystemURL(downloadTarget, async (d) => {
            const reader = d.createReader();
            reader.readEntries(async (entries) => {
              entries.forEach(async (entry) => {
                if (entry.isFile && entry.name.indexOf('.pdf') > -1) {
                  entry.remove(() => { }, (error) => { }, () => { });
                }
              });
            }, async (error) => {

            });
          });
        }

        let worklistDeleted = false;
        self.onWorklistRemovedStatusChanged = function (worklist) {
          if (!self.patient)
            return;

          if (worklist.Id === self.patient.Id) {
            if (worklistDeleted === false) {
              worklistDeleted = true;
              modalService.showAlert("This exam is deleted. You will be proceed to worklist");
              self.goToReturnUrl();
            } else {
              worklistDeleted = false;
            }

          }
        };

        Worklist.onItemRemovedStatusChanged(self.onWorklistRemovedStatusChanged);

        self.checkIfActionCanBePerformed = async function (worklistId, hideAlert) {
          let response = {
            isStillOwning: true
          };

          let studyLocked = await Worklist.checkStudyLock(worklistId);
          response.isStillOwning = !studyLocked.data.IsLock || studyLocked.data.CurrentUser;
          return response;
        };

        self.onDestroy = async function () {
          if (authService.loggedIn && !!authService._currentMagViewUrl) { 
            const canBePerformed = await self.checkIfActionCanBePerformed(id, true);
            if (!self.isViewOnly && self.worklistId && canBePerformed.isStillOwning) {
              Worklist.unlockMyExam(id);
            }
            techpadConfigChangeRegistration.unsubscribe();
            documentsCreateRegistration.unsubscribe();
            Worklist.onItemRemovedStatusChanged(null);
            clearInterval(self.watchJSExecutionInterval);
          }
        };

        self.handlePortalIframeMessage = async function (m) {
          if (m.data === 'surveyCompleted' || m.data === 'surveyReviewed' || m.data === 'no-survey-available') {
            self.isFullScreen = false;
            if (techpadConfig.settings.HideStartAndEndButtons) {
              self.updateStatus(self.worklistStatuses.ExamInProgress);
            }

            self.changeTab(self.tabs.SurveyHistory);
            self.isSurveyStarted = false;
            await self.refresh(true);
          }
        };

        self._initWithId = async function (worklistId) {
          self.worklistId = worklistId;

          await self.__initialize();

          self.changeTab(self.techpadConfig.settings.DefaultWorklistTab);
        };

        self.onSurveySaved = async function () {
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();

          if (isNotOffline) {
            await self.checkChangesAndSaveIfConfirmedOrRevert(commonConstants.ON_FAMILY_TREE_SAVED_CHANGES_FOUND_CONFIRMATION_MESSAGE,
              commonConstants.ON_FAMILY_TREE_SAVED_CONFIRMATION_BUTTON_TEXT);
          }
          $ionicLoading.hide();

          await self.refresh();

          self.changeTab(self.tabs.TyrerCuzick);
        }

        self._initWithPatientData = function (ssn, sdate) {
          self.ssn = ssn;
          self.sdate = sdate;

          self.__initialize();
        };

        self.initLookup = function (list) {
          return list.map(function (item) {
            item.separator = item.Value === '\\-' || item.Value.indexOf('---') >= 0;
            return item;
          });
        };

        self.getSelectedProblems = function (problems) {
          let selectedProblems = problems.filter((problem) => problem.IsLeft || problem.IsRight || problem.IsBoth || problem.IsUnspecified);
          return selectedProblems.map(p => p.Value);
        };

        self.onSelectProblemsDialogModalClosed = function (model) {
          if (model.isCancelled) {
            return;
          }
          self.selectedProblems = self.getSelectedProblems(model.problems);
          self.problems = model.problems;
          self.validateProblems();
        }

        self.selectProblems = async function () {
          let loading = await $ionicLoading.show({
            template: constantStrings.PleaseWait
          });

          let locations = [];

          await Patient.getLocations().then(function (resp) {
            locations = resp.data;
            locations = _.filter(locations, function (location) {
              return location.Value !== '\\-';
            });
          });
          let options = {
            isCancelled: false
          };
          let closeByButtonsClickOnly = true;
          let selectDialogModalOptions = {
            beforeWindowShow: () => { },
            afterWindowShown: () => {
              setTimeout(() => loading.hide(), 500);
            }
          }

          const selectedProcedures = self.patient.Study.Procedures;
          const procedures = self.procedures;

          const selectedCodes = selectedProcedures.map(procedure => procedure.Code);
          const filteredProcedures = procedures.filter(procedure => selectedCodes.includes(procedure.Key));
          let selectProblemsDialogModelInstance;

          if (filteredProcedures.some(procedure => procedure.ValidProbs === null)) {
            selectProblemsDialogModelInstance = new SelectProblemsDialogModel(self.problems, locations, options);
          }
          else {
            const uniqueValidProbsSet = new Set();

            filteredProcedures.forEach(procedure => {
                if (procedure.ValidProbs) {
                    procedure.ValidProbs.forEach(prob => uniqueValidProbsSet.add(prob));
                }
            });

            const problemsResult = self.problems.filter(problem => Array.from(uniqueValidProbsSet).includes(problem.Key));
            selectProblemsDialogModelInstance = new SelectProblemsDialogModel(problemsResult, locations, options);
          }

          modalService.showDialogWindow('views/templates/selectProblemsDialog.html', selectProblemsDialogModelInstance, closeByButtonsClickOnly, selectDialogModalOptions)
            .then(model => self.onSelectProblemsDialogModalClosed(model));
        };

        self.selectUltraSoundTechniqnue = async function () {
          if (!self.canShowUltrasoundOptions()) {
            return;
          }

          $ionicLoading.show({
            template: constantStrings.PleaseWait
          });

          let selectUltrasoundTechniqueModelInstance = new SelectUltrasoundTechniqueModel(self.patient.Ssn, self.patient.Study.SDate, self.checkIfNotOffline);
          let closeByButtonsClickOnly = true;

          modalService.showDialogWindow(
            'views/templates/ultrasoundTechniqueSelectDialog.html',
            selectUltrasoundTechniqueModelInstance,
            closeByButtonsClickOnly, {
            beforeWindowShow: () => { },
            afterWindowShown: () => { }
          })
            .then(function (model) {
              self.scanResults = model.scanResults || [];
              if (model.isCancelled) {
                return;
              }
            });
        };

        self.changeDate = function (obj, id) {
          const changeDateModel = {
            obj: obj,
            id: id
          };
          datePickerService.changeDate(changeDateModel);
        };

        self.riskTabChangeDate = function (elements, id) {
          const changeDateModel = {
            obj: elements,
            id: id,
            idProperty: riskPropertyConstants.ID_PROPERTY,
            valueProperty: riskPropertyConstants.RESPONSE_PROPERTY,
            maxDate: new Date()
          };
          datePickerService.changeDate(changeDateModel);
        };

        self.__initialize = async function () {
          $ionicLoading.show({
            template: 'Initializing...'
          });
          const includeInternal = self.techpadConfig.settings.IsShowPriorStudiesTabInExamMode;
          let promises = [
            dataRetrieverService.cachedProxy('worklist-lookups', 30, () => Worklist.getAllLookups(includeInternal))
              .then(resp => {
                self.visitReasons = self.initLookup(resp.data.visitReasons);
                self.tecknologists = resp.data.tecknologists;
                self.problems = resp.data.problems;
                self.views = self.initLookup(resp.data.views);
                self.udfs = resp.data.udfs;
                self.procedures = resp.data.procedures;
                self.fillProcedureSideDictionary();
                self.ultrasoundTechniques = resp.data.ultrasoundTechniques;
                self.locations = resp.data.locations;
              })
              .catch(error => {
                console.error(error);
              }),
            self.reloadDiagram()
          ];

          await Promise.all(promises);

          try {
            $ionicLoading.hide();
            await self.refresh();
          } catch (error) {
            self.failLoading();
          }
        };

        self.canLinkStudies = function () {
          return self.patient && self.patient.HasSameDateStudies;
        };

        self.linkStudies = async function () {
          if (self.isChanged()) {
            modalService.showAdvancedConfirmation(
              'Techpad',
              'You have not saved data here. Do you want to save your changes?', [{
                text: 'No',
                onTap: function (e) {
                }
              }, {
                text: 'Yes',
                type: 'button-positive',
                onTap: async (e) => {
                  await self.saveChanges();
                }
              }]);
          }

          const modelForLinkStudies = new linkStudiesViewModel(self.patient);

          $ionicLoading.show({
            template: commonConstants.DEFAULT_LOADER_MESSAGE
          });

          modelForLinkStudies.isIOSDevice = self.isIOSDevice;
          await modelForLinkStudies.initializeLinkedStudies();
          $ionicLoading.hide();
          await modalService.showLinkedStudiesWindow(modelForLinkStudies);

          self.isLinked = false;
          self.patient = null;
          self.patientCopy = null;
          self.__initialize();
        };

        self.updateData = function (firstName, lastName, DOB) {
          self.patient.FirstName = firstName;
          self.patient.LastName = lastName;
          self.patient.DateOfBirth = DOB;
        };

        self.openPatientDetails = function () {
          if (!self.isOnline()) return;
          self.checkChange(() => {
            let patientDetailsModel = new patientDetailsViewModel(self.patient.PatientAccessToken, self.isViewOnly);
            patientDetailsModel.initializeData();
            modalService.showPatientDetails(patientDetailsModel, self.updateData, self.refresh);
          }, 'You have not saved data here. Do you want to save your changes before changing patient details?', 'Continue');
        };

        self.getPatientsAge = function () {
          let patientsAge;

          if (self.patient && self.patient.DateOfBirth) {
            let dateOfBirth = new Date(self.patient.DateOfBirth);

            patientsAge = ageHelper.getAgeFromBirthDate(dateOfBirth);
          } else {
            patientsAge = '';
          }

          return patientsAge;
        }

        // region Document tab
        self.isShowContactsTypes = true;
        self.isShowDocumentsTypes = true;
        self.isShowLettersTypes = true;
        self.documentPageIndex = 0;
        self.remainingFilteredDocuments = [];
        self.stopInfiniteLoad = true;
        self.isRefreshingDocuments = false;
        const pageSize = 10;

        self.resizeScrollArea = function () {
          $ionicScrollDelegate.resize();
        }

        self.loadMoreDocuments = function () {
          if (!self.documents) {
            self.documents = [];
          }
          self.documentPageIndex++;

          // take { page size } of documents from the remaining filtered documents and put into documents list
          self.documents.push(..._.take(self.remainingFilteredDocuments, pageSize));

          // remove the amount of documents that are loaded into document list.
          self.remainingFilteredDocuments = _.drop(self.filteredDocuments, self.documentPageIndex * pageSize);

          self.stopInfiniteLoad = self.remainingFilteredDocuments.length === 0;
          $ionicScrollDelegate.resize();
        };

        self.refreshPatientDocuments = async function () {
          self.isRefreshingDocuments = true;
          await self.getPatientDocuments(true);
          self.isRefreshingDocuments = false;
        }

        self.getPatientDocuments = async function (highlightChanges) {
          let currentDocumentsList = [];

          if (highlightChanges) {
            currentDocumentsList = self.documentsCopy;
          }


          let worklistDocuments = await dataRetrieverService.cachedProxy('worklist-documents-' + id, 0, () => self.loadDocumentsData())
          worklistDocuments.data = worklistDocuments.data.map(document => {
            document.StudyDateTime = self.isDate(document.StudyDate) ? new Date(document.StudyDate) : '';
            return document;
          })
          self.documents = [];
          self.documentsCopy = angular.copy(worklistDocuments.data);
          self.documentsLoaded = true;
          self.filteredDocuments = self.getFilteredDocuments();
          self.remainingFilteredDocuments = _.cloneDeep(self.filteredDocuments);
          self.documentPageIndex = 0;
          self.loadMoreDocuments();

          if (highlightChanges) {
            self.highlightChangedDocuments(currentDocumentsList);
          }
        };

        self.isDate = function (date) {
          return (new Date(date) !== "Invalid Date" && !isNaN(new Date(date))) ? true : false;
        }

        self.shouldHighlight = function (documentId) {
          let shouldHighlight = self.highlightingDocumentIds.some(_ => _ === documentId);

          return shouldHighlight;
        };

        self.getHighlightDocumentClassName = function () {
          return (self.darkMode ? "darkmode-" : "") + "highlight-document";
        };

        self.highlightChangedDocuments = function (oldDocumentsList) {
          self.highlightingDocumentIds = [];

          self.documentsCopy.forEach((document) => {
            let existInOldDocumentsList = oldDocumentsList.some(_ => _.Id === document.Id);
            if (!existInOldDocumentsList) {
              self.highlightingDocumentIds.push(document.Id);
            }
          });

          setTimeout(() => {
            self.highlightingDocumentIds = [];
          }, 5000);
        };

        self.addContactDocument = async function (documentId) {
          let model = new ContactDocumentCreateDialogModel(self.patient.PatientAccessToken, documentId, self.patient.Clip, self.patient.Ssn, self.checkIfNotOffline);
          let closeByButtonsClickOnly = true;
          const responseModel = await modalService.showDialogWindow('views/templates/contactDocumentCreateDialog.html', model, closeByButtonsClickOnly);

          if (!responseModel.isCanceled || responseModel.isCreated) {
            await self.getPatientDocuments(true);
          }
          if (responseModel.isFuResolved) {
            await self.loadFollowUps();
          }
        };

        self.deleteContact = async function (document) {
          const isConfirmed = await modalService.showConfirmationAsync(commonConstants.DEFAULT_DELETE_CONTACT_CONFIRMATION_MESSAGE);
          if (isConfirmed) {
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_DELETE_CONTACT_LOADING_MESSAGE
              });

              await documentsSvc.deleteContact(document.SSN, document.Id);
              $ionicLoading.hide();

              await self.getPatientDocuments(true);
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_REMOVE_CONTACT_ERROR_MESSAGE);
            }
          }
        };

        self.addDocument = async function () {
          let modelInstance = new DocumentCreateDialogModel(self.patient.Ssn, self.patient.Study.SDate, self.checkIfNotOffline);
          let closeByButtonsClickOnly = true;
          const responseModel = await modalService.showDialogWindow('views/templates/documentCreateDialog.html', modelInstance, closeByButtonsClickOnly);
          if (responseModel && responseModel.isSaved) {
            await self.getPatientDocuments(true);
          }
        };

        self.loadDocumentsData = async function () {
          return documentsSvc.getAllBySsn(self.patient.Ssn);
        };

        self.toggleContactsTypes = function () {
          self.isShowContactsTypes = !self.isShowContactsTypes;
          self.documents = [];
          self.filteredDocuments = self.getFilteredDocuments();
          self.remainingFilteredDocuments = _.cloneDeep(self.filteredDocuments);
          self.documentPageIndex = 0;
          self.loadMoreDocuments();
        };

        self.toggleDocumentTypes = function () {
          self.isShowDocumentsTypes = !self.isShowDocumentsTypes;
          self.documents = [];
          self.filteredDocuments = self.getFilteredDocuments();
          self.remainingFilteredDocuments = _.cloneDeep(self.filteredDocuments);
          self.documentPageIndex = 0;
          self.loadMoreDocuments();
        };

        self.toggleLettersTypes = function () {
          self.isShowLettersTypes = !self.isShowLettersTypes;
          self.documents = [];
          self.filteredDocuments = self.getFilteredDocuments();
          self.remainingFilteredDocuments = _.cloneDeep(self.filteredDocuments);
          self.documentPageIndex = 0;
          self.loadMoreDocuments();
        };

        self.onRadioValueChanged = function (property, selectedOption) {
          const originalGcElement = self.nccnGuidelineCopy.Elements
              .find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);

          const originalPatientAgreementProperty = originalGcElement.Properties
              .find(element => element.Id === riskPropertyConstants.gcPatientAgreementPropertyId);

          if (property.Response === selectedOption.Value) {
            property.Response = '';
          } else {
            property.Response = selectedOption.Value;
            self.isPatientAgreementChanged = true;
          }

          var isRequired = property.Required === true ||
            (property.Required && property.Required.toLowerCase && property.Required.toLowerCase() === (true).toString());
          var isEmpty = !property.Response || property.Response === '' || property.Response === riskPropertyConstants.noneAnswerValue;
          self.notValidRiskProperties[property.Id] = isRequired && isEmpty;

          if (property.Id === riskPropertyConstants.gcPatientAgreementPropertyId &&
            selectedOption.Id === riskPropertyConstants.gcPatientAgreementNotInterestedOptionId) {
            const originalDatePerformed = originalGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDatePerformedPropertyId);
            const currentGcElement = self.nccnGuideline.Elements.find(element => element.Id === riskPropertyConstants.geneticCounselingElementId);
            const currentDatePerformed = currentGcElement.Properties.find(property => property.Id === riskPropertyConstants.gcDatePerformedPropertyId);

            if (originalDatePerformed.Response !== currentDatePerformed.Response) {
              currentDatePerformed.Response = originalDatePerformed.Response;
            }
          }
        }

        self.isPatientNotInterested = function (nccnElement) {
          const patientAgreementProperty = nccnElement &&
            nccnElement.Properties.find(property => property.Id === riskPropertyConstants.gcPatientAgreementPropertyId);
          if (patientAgreementProperty) {
            const patientNotInterestedOption = patientAgreementProperty.Options.find(
              option => option.Id === riskPropertyConstants.gcPatientAgreementNotInterestedOptionId
            );

            return patientNotInterestedOption &&
              patientAgreementProperty.Response === patientNotInterestedOption.Value;
          }
        }

        self.gcShouldHideIfPatientNotInterested = function (property) {
          let shouldHide = false;

          if (property.Id === riskPropertyConstants.gcDatePerformedPropertyId) {
            const geneticCounselingElement =
              self.nccnGuideline.Elements.find(option => option.Id === riskPropertyConstants.geneticCounselingElementId);
            const patientAgeementElement = geneticCounselingElement &&
              geneticCounselingElement.Properties.find(property => property.Id === riskPropertyConstants.gcPatientAgreementPropertyId);

            if (patientAgeementElement) {
              const patientNotInterestedValue =
                patientAgeementElement.Options.find(option => option.Id === riskPropertyConstants.gcPatientAgreementNotInterestedOptionId);
              shouldHide = patientNotInterestedValue && patientAgeementElement.Response === patientNotInterestedValue.Value;
            }
          }

          return shouldHide;
        }

        self.shouldHideGeneticCounselingControls = function () {
          return shouldHideGeneticCounselingControls();
        }

        self.openMultiRadioPopup = async function (property) {
          let model = new MultiRadioDetailsDialogModel(property, self.riskPropertyConstants.defaultSortingColumn, 'Test Results');
          const closeByButtonsClickOnly = true;
          const responseModel = await modalService.showDialogWindow('views/templates/multiRadioDetailsDialogModel.html', model, closeByButtonsClickOnly);

          if (!responseModel.isCanceled && responseModel.newProperty) {
            property.Options = responseModel.newProperty.Options;

            //check if personal BRCA left history exist and move answer there
            const brca1Option = property.Options.find(option => option.Id === riskPropertyConstants.testResultBRCA1OptionId);
            const brca2Option = property.Options.find(option => option.Id === riskPropertyConstants.testResultBRCA2OptionId);
            if (brca1Option && self.leftHistoryData && self.leftHistoryData.PERSONAL_BRCA1) {
              self.personalBRCA1Change(brca1Option.Response);
            }
            if (brca2Option && self.leftHistoryData && self.leftHistoryData.PERSONAL_BRCA2) {
              self.personalBRCA2Change(brca2Option.Response);
            }
          }
        }

        self.getMultiRadioCurrentColumnValue = function (index, optionsArray) {
          const sortedOptionsArray = _.sortBy(optionsArray, self.riskPropertyConstants.defaultSortingColumn);
          const option = sortedOptionsArray[index];
          return option.Value;
        }

        self.isPatientQualified = function (nccnElement) {
          let nccnNotQualifiedProperty = nccnElement && nccnElement.Id === riskPropertyConstants.geneticCounselingElementId &&
            nccnElement.Properties &&
            nccnElement.Properties.find(property => property.Id === riskPropertyConstants.gcPatientNotQualifiedPropertyId);

          return !nccnNotQualifiedProperty;
        }

        self.checkIfNotOffline = async function () {          
          let isOnline = true;

          if (!self.isOnline()) {
            $ionicLoading.hide();
            await modalService.showAlertAsync(constantStrings.DefaultOfflineAlertMessage);
            if (!self.reconnectTimeout) {
              self.reconnectTimeout = setTimeout(() => {
                signalrService.tryReconnectAgain();
                clearTimeout(self.reconnectTimeout);
              }, 10000);
            }
            isOnline = false;
          } 

          return isOnline;
        }

        self.checkIfStillOwningAndNotOffline = async function () {
          const isOnline = await self.checkIfNotOffline();
          if (!isOnline) {
            return false;
          }

          const actionResult = await self.checkIfActionCanBePerformed(self.worklistId, false);
          if (!actionResult.isStillOwning) {
            await modalService.showAlertAsync('You no longer own this exam.');
            return false;
          }

          return true;
        }

        self.checkChangesAndSaveIfConfirmedOrRevert = async function (confirmationMessage, confirmationNextActionName) {
          let isCanceled = false;
          const isChanged = self.isChanged();
          if (isChanged) {
            isCanceled = await self.confirmAndSaveWorklistChangesAsync(confirmationMessage, confirmationNextActionName);
          }
          return isCanceled;
        }

        self.confirmAndSaveWorklistChangesAsync = async function (confirmationMessage, confirmationNextActionName) {
          let isCanceled = false;
          const response = await modalService.showAdvancedConfirmationAsync({
            saveButtonText: `Save & ${(confirmationNextActionName || 'End')}`,
            text: confirmationMessage,
            title: confirmationNextActionName
          });

          if (response === commonConstants.advancedConfirmationSaveResponse) {
            await self.saveWorklistChangesAsync();
          } else if (response === commonConstants.advancedConfirmationDiscardResponse) {
            self.revertAllChanges();
          } else {
            isCanceled = true;
          }

          return isCanceled;
        }

        self.saveWorklistChangesAsync = async function () {
          self.saving = true;
          $ionicLoading.show({
            template: commonConstants.savingHistoryLoaderMessage
          });

          let isValid = true;
          if (techpadConfig.settings.IsValidateReqiuredFieldsOnEverySave) {
            let validationResult = self.validateExamEnd();
            isValid = validationResult.isValid;

            if (!isValid) {
              self.handleNotValidExamEnd(validationResult);
            }
          }

          if (isValid) {
            await self.checkCommentsChanges();

            $ionicLoading.show({
              template: commonConstants.savingHistoryLoaderMessage
            });
            await self.executeSaveWorklistChangesAsync();
          }
        }

        self.checkCommentsChanges = async function () {
          const commentsFromDbResponse = await Worklist.getPatientComments(self.worklistId);
          const commentsFromDb = commentsFromDbResponse.data;
          let commentsChangedInDB = false;
          let message = commonConstants.commentsChangedInDbMessage;

          self.techpadConfig.settings.CommentsSettings.forEach((setting) => {
            if (self.patient.Study.Comments[setting.Field] !== commentsFromDb[setting.Field] && setting.IsReadonly) {
              self.patient.Study.Comments[setting.Field] = commentsFromDb[setting.Field];
              self.initialComments[setting.Field] = commentsFromDb[setting.Field];
            }
            if (self.initialComments[setting.Field] !== commentsFromDb[setting.Field] &&
              self.patient.Study.Comments[setting.Field] !== commentsFromDb[setting.Field]) {
              commentsChangedInDB = true;
              message += `<br /><br /> Recent ${setting.Title}: "${commentsFromDb[setting.Field]}".`;
            }
          });

          if (commentsChangedInDB) {
            $ionicLoading.hide();
            modalService.showAdvancedConfirmation(
              commonConstants.commentsChangedPopupMessage,
              message, [{
                text: commonConstants.commentsChangedDiscardButtonText,
                onTap: (e) => {
                  self.patient.Study.Comments = commentsFromDb;
                  self.initialComments = angular.copy(commentsFromDb);
                }
              }, {
                text: commonConstants.commentsChangedConfirmButtonText,
                type: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS,
              }]);
          }
        }

        self.fillSaveWorklistModelWithDiagramImage = async function (saveModel) {
          saveModel.IsDiagramChanged = true;
          saveModel.SvgDiagramImage = await self.getDiagramSvgString();
          saveModel.Base64String = await self.getDiagramBase64String();
          saveModel = await Diagram.prepareSaveModelWithDiagramImage(saveModel);

          return saveModel;
        }

        self.processWorklistDataAfterSave = function () {
          let beginTime = self.patientCopy.ExamBeginTime;
          let endTime = self.patientCopy.ExamEndTime;
          self.patientCopy = angular.copy(self.patient);
          self.patientCopy.ExamBeginTime = beginTime;
          self.patientCopy.ExamEndTime = endTime;
          self.moveCorrectTimeStamps();
          self.problemsCopy = angular.copy(self.problems);
          self.problemsListCopy = angular.copy(self.problemsList);
          self.examUfieldsDataCopy = _.cloneDeep(self.examUfieldsData);
          self.leftHistoryDataCopy = _.cloneDeep(self.leftHistoryData);
          self.rightHistoryDataCopy = _.cloneDeep(self.rightHistoryData);
          self.implantDataCopy = _.cloneDeep(self.implantData);
          self.nccnGuidelineCopy = _.cloneDeep(self.nccnGuideline);
        }

        self.executeSaveWorklistChangesAsync = async function () {
          let saveWorklistModel = await self.prepareSaveWorklistModel();

          self.saving = true;
          self.saved = false;
          try {
            let saveChangesResult = await Worklist.saveChanges(saveWorklistModel);

            if (saveChangesResult.data.NeedGeneratedImageFromClient) {
              saveWorklistModel = await self.fillSaveWorklistModelWithDiagramImage(saveWorklistModel);
              await Worklist.saveChanges(saveWorklistModel);
            }

            self.saving = false;
            self.saved = true;
            self.saveFailed = false;
            self.processWorklistDataAfterSave();

            await self.refresh();

            self.hideDiagram = false;
          } catch (resp) {
            self.hideDiagram = false;
            self.saving = false;
            self.saved = false;
            self.saveFailed = true;
            self.myriadSkippedFlag = false;
            $ionicLoading.hide();
            self.processSaveWorklistError(resp);
          } finally {
            if (self.tab === self.tabs.Diagram) {
              self.changeTab(self.tabs.Exam);
            }
            $ionicLoading.hide();
          }
        }

        self.processSaveWorklistError = function (resp) {
          self.myriadSkippedFlag = false;
          if (resp.data && resp.data.exception && resp.data.exception.ClassName === commonConstants.STUDY_LOCAKED_EXCEPTION_CLASS_NAME) {
            modalService.showAdvancedConfirmation(
              commonConstants.STUDY_MODIFIED_EXCEPTION_MESSAGE,
              `${resp.data.message}`, [{
                text: commonConstants.ALERT_CLOSE_BUTTON_TEXT,
                type: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS,
                onTap() { }
              }]
            );
          } else if (resp.data && resp.data.exception && resp.data.exception.ClassName === commonConstants.STUDY_MODIFIED_EXCEPTION_CLASS_NAME) {
            modalService.showAdvancedConfirmation(
              commonConstants.STUDY_MODIFIED_EXCEPTION_MESSAGE,
              `${resp.data.message}`, [{
                text: commonConstants.ALERT_CLOSE_BUTTON_TEXT,
                type: commonConstants.MODAL_BUTTON_ASSERTIVE_CLASS,
                onTap() { }
              }]
            );
          } else {
            modalService.showErrorMessage(resp.data, resp.status);
          }
        }

        self.saveAndSendToMyriad = async function () {
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();

          if (isNotOffline) {
            let isCanceled = false;

            if ($rootScope.techpadSettings && $rootScope.techpadSettings.ShowMyriadButton) {
              const isChanged = self.isChanged();
              const isOnlyMyriadChanged = self.isOnlyMyriadPropertiesChanged();

              if (isChanged && !isOnlyMyriadChanged) {
                isCanceled = await self.checkChangesAndSaveIfConfirmedOrRevert(
                  riskPropertyConstants.sendToMyriadChangesFoundConfirmationMessage,
                  riskPropertyConstants.sendToMyriadConfirmationButtonText
                );
              } else if (isChanged && isOnlyMyriadChanged) {
                await self.saveWorklistChangesAsync();
              }
            } else {
              isCanceled = await self.checkChangesAndSaveIfConfirmedOrRevert(
                riskPropertyConstants.sendToMyriadChangesFoundConfirmationMessage,
                riskPropertyConstants.sendToMyriadConfirmationButtonText
              );
            }
            if (!isCanceled && !self.saveFailed) {
              await self.sendToMyriad();
            } else {
              $ionicLoading.hide();
            }
          } else {
            $ionicLoading.hide();
          }
        }

        self.detectMyriadFailureState = function () {
          if (!self.nccnGuideline) return;

          const currentGcElement = self.nccnGuideline.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);
          if (!currentGcElement) return;

          const patientAgreementProperty = currentGcElement.Properties.find(property => 
            property && property.Id === self.riskPropertyConstants.gcPatientAgreementPropertyId);
          if (!patientAgreementProperty) return;

          const patientResponse = patientAgreementProperty.Response;
          if (patientResponse) {
            const matchedOption = patientAgreementProperty.Options.find(opt => opt.Value == patientResponse);
            const isCoicedSendToMyriad = matchedOption ? matchedOption.SendToMyriad : false;
            if (isCoicedSendToMyriad && !self.lastSentDateToMyriad) {
              self.isSendToMyriadTriggered = true;
              self.isSuccessfullySentToMyriad = false;
              self.myriadButtonText = riskPropertyConstants.gcMyriadButtonTextOnResend;
            }
          }
        };

        self.isOnlyMyriadPropertiesChanged = function () {
          if (!self.nccnGuideline || !self.nccnGuidelineCopy) return false;

          const currentGcElement = self.nccnGuideline.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcElement = self.nccnGuidelineCopy.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);

          if (!currentGcElement || !originalGcElement) return false;

          const myriadPropertyIds = [
            riskPropertyConstants.gcPatientAgreementPropertyId,
            riskPropertyConstants.gcDateOfferedPropertyId,
            riskPropertyConstants.gcDateRespondedPropertyId,
            riskPropertyConstants.gcReferralMVPOPPropertyId,
            riskPropertyConstants.gcTestResultsPropertyId
          ];

          let hasMyriadChanges = false;
          let hasNonMyriadChanges = false;

          for (const propertyId of myriadPropertyIds) {
            const currentProperty = currentGcElement.Properties.find(p => p.Id === propertyId);
            const originalProperty = originalGcElement.Properties.find(p => p.Id === propertyId);

            if (currentProperty && originalProperty) {
              if (currentProperty.Response !== originalProperty.Response) {
                hasMyriadChanges = true;
                break;
              }
            }
          }

          function cleanObject(obj) {
            if (!obj || typeof obj !== 'object') return obj;
            
            if (Array.isArray(obj)) {
              return obj.map(cleanObject);
            }
            
            const cleaned = {};
            for (const key in obj) {
              if (key.startsWith('$$') || key === 'IsSelected') {
                continue;
              }
              cleaned[key] = cleanObject(obj[key]);
            }
            return cleaned;
          }

          const currentWithoutMyriad = angular.copy(self.nccnGuideline);
          const originalWithoutMyriad = angular.copy(self.nccnGuidelineCopy);

          const currentGcElementCopy = currentWithoutMyriad.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);
          const originalGcElementCopy = originalWithoutMyriad.Elements.find(element => 
            element.Id === riskPropertyConstants.geneticCounselingElementId);

          if (currentGcElementCopy && originalGcElementCopy) {
            currentGcElementCopy.Properties = currentGcElementCopy.Properties.filter(p => 
              !myriadPropertyIds.includes(p.Id));
            originalGcElementCopy.Properties = originalGcElementCopy.Properties.filter(p => 
              !myriadPropertyIds.includes(p.Id));
          }

          if (!angular.equals(cleanObject(currentWithoutMyriad), cleanObject(originalWithoutMyriad)) ||
              !angular.equals(cleanObject(self.problems), cleanObject(self.problemsCopy)) ||
              !angular.equals(cleanObject(self.leftHistoryDataCopy), cleanObject(self.leftHistoryData)) ||
              !angular.equals(cleanObject(self.rightHistoryDataCopy), cleanObject(self.rightHistoryData)) ||
              !angular.equals(cleanObject(self.examUfieldsDataCopy), cleanObject(self.examUfieldsData)) ||
              !angular.equals(cleanObject(self.implantDataCopy), cleanObject(self.implantData)) ||
              !angular.equals(self.patient.IsRiskOptOut, self.patientCopy.IsRiskOptOut) ||
              self.isDiagramChanged()
          ) {
            hasNonMyriadChanges = true;
          }

          return hasMyriadChanges && !hasNonMyriadChanges;
        };

        self.sendToMyriad = async function (isOfferedDateChanged = false) {
          $ionicLoading.hide();
          $ionicLoading.show({
            template: riskPropertyConstants.sendingToMyriadSpinnerMessage
          });
          try {
            self.isSendToMyriadTriggered = true;
            self.isSuccessfullySentToMyriad = true;
            const resp = await Worklist.sendToMyriad(self.patient.Ssn, self.patient.Study.SDate, isOfferedDateChanged);
            $ionicLoading.hide();
            const sendToMyriadResultModel = resp && resp.data;
            if (sendToMyriadResultModel) {
              self.lastSentDateToMyriad = sendToMyriadResultModel.SentDate;
              if(sendToMyriadResultModel.IsOfferedDateChanged){
                self.initNccnDateOffered(sendToMyriadResultModel.SentDate);
              }
              if(sendToMyriadResultModel.IsRespondedDateChanged){
                self.initNccnDateResponded(sendToMyriadResultModel.SentDate);
              }
              self.myriadButtonText = riskPropertyConstants.gcMyriadButtonTextOnResend;
              self.isSuccessfullySentToMyriad = true;
              self.patient.GeneticCounselingDataStatus = commonConstants.SUCCESSFULLY_SENT_TO_MYRIAD;
              self.updateMyriadStatusProperties();
              return { success: true };
            }
          } catch (errorResp) {
            $ionicLoading.hide();
            self.isSuccessfullySentToMyriad = false;
            self.myriadButtonText = riskPropertyConstants.gcMyriadButtonTextOnResend;
            self.patient.GeneticCounselingDataStatus = commonConstants.NETWORK_ERROR_DURING_SEND_TO_MYRIAD;
            self.updateMyriadStatusProperties();
            const errorData = errorResp && errorResp.data || riskPropertyConstants.gcDefaultSendToMyriadFailedMessage;
            const shouldRetry = await modalService.showConfirmationAsync(
              `Could not send data to Myriad. You may try again or skip this step and try again later.`,
              {
                title: 'Myriad Request Failed',
                okText: 'Retry',
                cancelText: 'Skip'
              }
            );
            
            if (shouldRetry) {
              return await self.sendToMyriad(isOfferedDateChanged);
            } else {
              return { success: false, skipped: true };
            }
          }
          return { success: false };
        }

        self.generateAndViewTrfForm = async function () {
          $ionicLoading.show({ template: commonConstants.processingLoaderMessage });
          const isNotOffline = await self.checkIfNotOffline();

          if (isNotOffline) {
            const isCanceled = await self.checkChangesAndSaveIfConfirmedOrRevert(riskPropertyConstants.showTrfFormChangesFoundConfirmationMessage,
              riskPropertyConstants.showTrfFormConfirmationButtonText);
            if (!isCanceled && !self.saveFailed) {
              $ionicLoading.show({
                template: commonConstants.DOCUMENT_LOADING_MESSAGE
              });
              try {
                const document = await documentsSvc.generateTrfDocument(self.patient.Ssn, self.patient.Study.SDate);
                document.SSN = self.patient.Ssn;
                document.onPrintedCallback = self.onTrfFormPrinted;
                const url = await documentsSvc.getDocumentUrl(document);
                if (techpadInitialConfigProvider.setFromElectron) {
                  documentPrintHelper.openDocumentElectron(url);
                } else {
                  documentPrintHelper.openDocumentBrowser(url, document, {
                    patient: self.patient,
                  });
                }
              } catch (resp) {
                modalService.showErrorMessage(resp.data, resp.status);
                $ionicLoading.hide();
              }
            }
          }

          $ionicLoading.hide();
        }

        self.onTrfFormPrinted = function (printer){
          documentsSvc.onTrfFormPrinted(self.patient.Ssn, printer)
          .then(resp => {
            self.trfLastPrintDate = resp;
          });
        }

        self.getFilteredDocuments = function () {
          let newDocumentsList = angular.copy(self.documentsCopy);
          if (self.isShowContactsTypes && self.isShowDocumentsTypes && self.isShowLettersTypes) {
            return newDocumentsList;
          }
          return newDocumentsList.filter(document => {
            if (!self.isShowContactsTypes && document.DocumentSource === self.documentSourceTypes.Contacts) {
              return false;
            }
            if (!self.isShowDocumentsTypes && document.DocumentSource === self.documentSourceTypes.PortalDocument) {
              return false;
            }
            if (!self.isShowLettersTypes && document.DocumentSource === self.documentSourceTypes.EnotifyAndRelease) {
              return false;
            }
            return true;
          });
        }

        self.getElementDescByCode = function (array, code, isMultiSelect = false) {
          let el;
          if (!isMultiSelect){
            el = array.find(function (element) {
              return element.Code === code;
            });
          } else {
            const elements = array.filter(x => code.indexOf(x.Code) >= 0).map(x => x.Desc);
            el = {Desc: elements.join(",")};
          }

          // A stored value that isn't in the configured options (e.g. a -1 sentinel or an
          // out-of-range P_AGE) has no matching element; return a blank so read-only display
          // shows nothing rather than dereferencing undefined or rendering the raw code.
          return el || { Desc: '' };
        }

        self.calculateAge = function (birthday) {
          var ageDifMs = Date.now() - (new Date(birthday)).getTime();
          var ageDate = new Date(ageDifMs);
          return Math.abs(ageDate.getUTCFullYear() - 1970);
        }

        self.noneCheckboxChange = function (id) {
          var rightHistoryData = _.find(self.rightHistoryData, function (item) {
            return item.name == id;
          });
          if (rightHistoryData) {
            const config = self.getRightHistoryConfigByName(id);

            if (rightHistoryData.none === true && rightHistoryData.unknown === true) {
              rightHistoryData.unknown = false;
            }
            if (config && config.Type === 'Finding' && rightHistoryData.none === true) {
              rightHistoryData.data = [];
              self.isDisplayFindingRecord[id] = false;
              self.findingCaptionsDict[id] = '';
            }
          }
        };

        self.unknownCheckboxChange = function (id) {
          var rightHistoryData = _.find(self.rightHistoryData, function (item) {
            return item.name == id;
          });
          if (rightHistoryData) {
            const config = self.getRightHistoryConfigByName(id);

            if (rightHistoryData.unknown === true && rightHistoryData.none === true) {
              rightHistoryData.none = false;
            }
            if (config && config.Type === 'Finding' && rightHistoryData.unknown === true) {
              rightHistoryData.data = [];
              self.isDisplayFindingRecord[id] = false;
              self.findingCaptionsDict[id] = '';
            }
          }
        };

        self.isDisableNoneCheckbox = function (id) {
          var rightHistoryData = _.find(self.rightHistoryData, function (item) {
            return item.name === id;
          });
          if (!rightHistoryData) {
            return true;
          }
          const config = self.getRightHistoryConfigByName(id);
          
          if (config && config.Type === 'Finding') {
            if (rightHistoryData.data && rightHistoryData.data.some(answer => 
              answer.Value === commonConstants.YES_VALUE && !answer.IsDeleted
            )) {
              rightHistoryData.none = false;
              return true;
            }
            return false;
          } else {
            var rightHistoryDataItems = rightHistoryData.data.filter(function (el) {
              return !el.IsDeleted;
            });
            if (rightHistoryDataItems && rightHistoryDataItems.length > 0) {
              rightHistoryData.none = false;
              return true;
            }
            return false;
          }
        };

        self.isDisableUnknowCheckbox = function (id) {
          var rightHistoryData = _.find(self.rightHistoryData, function (item) {
            return item.name === id;
          });

          if (!rightHistoryData) {
            return true;
          }

          const config = self.getRightHistoryConfigByName(id);
          if (config && config.Type === 'Finding') {
            if (rightHistoryData.data && rightHistoryData.data.some(answer => 
              answer.Value === commonConstants.YES_VALUE && !answer.IsDeleted
            )) {
              rightHistoryData.unknown = false;
              return true;
            }
            return false;
          } else {
            var rightHistoryDataItems = rightHistoryData.data.filter(function (el) {
              return !el.IsDeleted;
            });
            if (rightHistoryDataItems && rightHistoryDataItems.length > 0) {
              rightHistoryData.unknown = false;
              return true;
            }
            return false;
          }
        };

        self.processFindingConfig = function (config, answers) {
          const activeAnswers = answers.data || [];

          const result = config.ModelController
            .filter(item =>
              activeAnswers.some(answer => answer.Name === item.Name && answer.Value === commonConstants.YES_VALUE)
            )
            .map(item => item.Caption)
            .join(", ");

          self.findingCaptionsDict[config.Id] = result;
          self.isDisplayFindingRecord[config.Id] = result.length > 0;
          return result;
        };

        self.SetAllNone = function () {
          _.each(self.rightHistoryData, function (item) {
            if (item.name !== "BRCA" && (!item.data || item.data.length == 0)) {
              item.none = true;
              item.unknown = false;
              _.each(item.data, function (dataItem) {
                dataItem.IsDeleted = true;
              });
            }
          });
        }

        self.getBarcode = async function (accession) {
          let loading = await $ionicLoading.show({
            template: 'Generating accession barcode image...'
          });
          try {
            await Worklist.getBarcode(accession).then(async function (resp) {
              loading.hide();
              await self.showAccessionBarcodeDialogModal(resp.data.barcodeImage, accession);
            });
          } catch (error) {
            loading.hide();
            modalService.showErrorMessage(error.data.ExceptionMessage, error.data.ExceptionType);
          }
        }

        self.showAccessionBarcodeDialogModal = async function (barcodeImage, accession) {
          let data = {
            barcodeImage,
            accession
          };
          let model = new AccessionBarcodeDialogModel(data);
          let closeByButtonsClickOnly = true;
          await modalService.showDialogWindow('views/templates/accessionBarcodeDialog.html', model, closeByButtonsClickOnly);
        }

        // TPAD-1092: Norton - Techpad BRCA1 and BRCA2 support
        self.initPersonalBRCAValues = function () {
          self.personalBRCA1Value = self.leftHistoryData.PERSONAL_BRCA1;

          self.personalBRCA2Value = self.leftHistoryData.PERSONAL_BRCA2;
        }

        self.setFamilyBRCAValue = function () {
          self.leftHistoryData.PERSONAL_BRCA1 = self.personalBRCA1Value;
          self.leftHistoryData.PERSONAL_BRCA2 = self.personalBRCA2Value;
        }

        self.personalBRCA1Change = function (value) {
          self.personalBRCA1Value = value;
          if (value === '0') {
            if (angular.element(document).find('input[data-id=BRCA1No]').prop("checked") === false) {
              self.personalBRCA1Value = '';
            }
          }
          self.leftHistoryData.PERSONAL_BRCA1 = self.personalBRCA1Value;

          //Check if NCCN and BRCA gene config available - change there as well
          self.changeNccnGeneticCounselingOptionValue(riskPropertyConstants.testResultBRCA1OptionId, self.leftHistoryData.PERSONAL_BRCA1);
        }

        self.changeNccnGeneticCounselingOptionValue = function (optionName, optionValue) {
          if (self.nccnGuideline && self.nccnGuideline.Elements) {
            const nccnGeneticCounselingElement = self.nccnGuideline.Elements.find(e => e.Id == riskPropertyConstants.geneticCounselingElementId);
            if (nccnGeneticCounselingElement) {
              const testResultProperty = nccnGeneticCounselingElement.Properties.find(p => p.Id == riskPropertyConstants.gcTestResultsPropertyId);
              if (testResultProperty) {
                const brca1Option = testResultProperty.Options.find(o => o.Id == optionName);
                if (brca1Option) {
                  brca1Option.Response = optionValue;
                }
              }
            }
          }
        }

        self.checkIfHighlightForNccnGcQualified = function () {
          let isHighlight = false;
          if ($rootScope.techpadSettings.NccnPat && $rootScope.techpadSettings.NccnTab &&
            self.nccnGuideline && self.nccnGuideline.Elements) {
            const nccnGeneticCounselingElement = self.nccnGuideline.Elements.find(e => e.Id == riskPropertyConstants.geneticCounselingElementId);
            const nccnGeneticCounselingNotQualifiedElement = nccnGeneticCounselingElement &&
              nccnGeneticCounselingElement.Properties.find(p => p.Id === riskPropertyConstants.gcPatientNotQualifiedPropertyId);
            isHighlight = nccnGeneticCounselingElement && !nccnGeneticCounselingNotQualifiedElement;
          }

          return isHighlight;
        }

        self.personalBRCA2Change = function (value) {
          self.personalBRCA2Value = value;

          if (value === '0') {
            if (angular.element(document).find('input[data-id=BRCA2No]').prop("checked") === false) {
              self.personalBRCA2Value = '';
            }
          }
          self.leftHistoryData.PERSONAL_BRCA2 = self.personalBRCA2Value;

          //Check if NCCN and BRCA gene config available - change there as well
          self.changeNccnGeneticCounselingOptionValue(riskPropertyConstants.testResultBRCA2OptionId, self.leftHistoryData.PERSONAL_BRCA2);
        }

        self.checkPersonalBRCAHistory = function () {
          var isValid = true;
          if (self.personalBRCA1Value === "" || self.personalBRCA2Value === "") {
            isValid = false;
            self.notValidPersonalBRCAHistory = true;
          } else {
            self.notValidPersonalBRCAHistory = false;
          }
          return isValid;
        }

        self.editRefPhy = async function () {
          $ionicLoading.show({
            template: constantStrings.DefaultLoaderMessage
          });

          let model = new PatientReferringPhysiciansDialogModel(self.patient.Study, self.checkIfNotOffline);

          let closeByButtonsClickOnly = true;

          $ionicLoading.hide();
          let response = await modalService.showDialogWindow('views/templates/patientReferringPhysiciansDialog.html', model, closeByButtonsClickOnly);
        };

        self.goToReturnUrl = function () {
          $location.path(self.returnUrl);
          $location.search({});
        };

        self.patientImportDocumentPC = async function ($event) {
          let input = document.getElementById('image-upload-input');
          if (input){
            document.body.removeChild(input);
          }

          input = document.createElement('input');
          input.id = 'image-upload-input';
          input.type = 'file';
          input.accept = 'image/*, application/pdf, text/plain';
          input.multiple = false;
          input.onchange = self.onFileUploaded;

          document.body.appendChild(input);
          input.click();
        }

        self.onFileUploaded = async function ($event) {
          const file = $event.target.files[0];
          if (!file || !file.type.includes('image/') && !file.type.includes('application/pdf') && !file.type.includes('text/plain')) {
            await modalService.showErrorMessage(`Uploaded file type - ${file.type} is not supported. Supported types: image, PDF, txt`);
            return;
          }
          
          if (file.type.includes("image/")){
            const cropModel = new CropDialogModel(file, self.isIOSDevice);
            const cropResponse = await modalService.showDialogWindow('views/templates/cropDialog.html', cropModel, true);
            if (!cropResponse.isCancelled) {
              self.openImportDetailsModel(cropResponse.file);
            }
          }
          else {
            self.openImportDetailsModel(file);
          }
        }

        self.openImportDetailsModel = async function (file){
          const data = {
            ssn: self.patient.Ssn,
            sdate: self.patient.Study.SDate,
            date: '',
            description: '',
            comment: '',
            file: file
          };
          const model = new PatientImportDocumentDialogModel(self.isIOSDevice, 'Import Document', data);
          const responseModel = await modalService.showDialogWindow('views/templates/uploadDocumentDialog.html', model, true);
          if (!responseModel.isCancelled) {
            const data = responseModel.data;
            const fileToUpload = data.resultFile;
            const request = new ImportPatientDocumentModel(data.date, data.description, data.comment, fileToUpload, data.ssn, data.sdate);
            await documentsSvc.saveImportDocuments(request);
            await self.refreshPatientDocuments();
          }
        }

        self.deleteDocument = async function (document) {
          const isConfirmed = await modalService.showConfirmationAsync(commonConstants.DEFAULT_DELETE_PORTAL_DOCUMENT_CONFIRMATION_MESSAGE);
          if (isConfirmed) {
            try {
              $ionicLoading.show({
                template: commonConstants.DEFAULT_DELETE_PORTAL_DOCUMENT_LOADING_MESSAGE
              });

              await documentsSvc.deleteDocument(document.SSN, document.Id);
              $ionicLoading.hide();

              await self.refreshPatientDocuments();
            } catch (errorResponse) {
              $ionicLoading.hide();
              modalService.showErrorMessage(errorResponse || commonConstants.DEFAULT_REMOVE_DOCUMENT_ERROR_MESSAGE);
            }
          }
        };
      };
      return vm;
    }
  ]);



// WEBPACK FOOTER //
// ./src/scripts/models/patient.js